(function(){
  'use strict';
  if (window.__YF_NATIVE_DB_V138_CHANGE_MODEL_BUTTON__) return;
  window.__YF_NATIVE_DB_V138_CHANGE_MODEL_BUTTON__ = true;

  const esc = v => String(v == null ? '' : v).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const enc = v => encodeURIComponent(v == null ? '' : String(v));
  const norm = v => String(v || '').trim().toUpperCase().replace(/[\s\-\/\.]+/g, '');
  // Exact SKU lookup is intentionally stricter than part/model matching.
  // Trim/case-normalize only, so MD6-2 matches MD6-2 but not MD62 or MD6.
  const skuKey = v => String(v || '').trim().toUpperCase();
  const slug = v => String(v || '').toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
  const money = v => {
    if (v == null || v === '') return '';
    let raw = String(v).trim();
    let n = Number(raw.replace(/[^0-9.]/g,''));
    if (!Number.isFinite(n)) return raw;
    if (!raw.includes('.') && /^\d+$/.test(raw) && raw.length >= 3) n = n / 100;
    return '$' + n.toFixed(2);
  };
  const nativeSearchUrl = q => '/search?q=' + enc(q) + '&type=product&options%5Bprefix%5D=last&yf_native=1';
  function nativeModelSearchUrl(row){
    const model = Array.isArray(row) ? row[0] : (row && (row.m || row.model || row.modelNumber || row.n)) || row || '';
    const brand = Array.isArray(row) ? (row[1] || '') : (row && (row.b || row.brand || row.manufacturer)) || '';
    const category = Array.isArray(row) ? (row[2] || '') : (row && (row.c || row.category || row.af)) || '';
    let url = nativeSearchUrl(model) + '&view=yf-model-match&yf_force=model&yf_model_key=' + enc(norm(model));
    if(brand) url += '&yf_brand=' + enc(brand);
    if(category) url += '&yf_category=' + enc(category);
    return url;
  }
  const partInfoUrl = id => '/search?yf_mode=part-number&id=' + enc(id || '');
  const diagramUrl = id => '/search?yf_mode=breakdowns&diagram=' + enc(id || '');
  const modelBreakdownUrl = (m, serial) => {
    const model = String(m || '').trim();
    if(!model) return '/search';
    let url = nativeSearchUrl(model)
      + '&yf_mode=breakdowns&model=' + enc(model)
      + '&yf_force=model&yf_model_key=' + enc(norm(model));
    if(serial) url += '&serial=' + enc(serial);
    return url;
  };
  const YF_PENDING_MODEL_ROUTE_KEY = 'yf_pending_model_route_v2';
  const deb = (fn, ms) => { let t; return function(){ clearTimeout(t); const a = arguments; t = setTimeout(() => fn.apply(this, a), ms); }; };
  const idle = fn => (window.requestIdleCallback ? window.requestIdleCallback(fn, {timeout: 900}) : setTimeout(fn, 40));
  async function mapLimit(items, limit, worker){
    items = items || [];
    const out = new Array(items.length);
    let cursor = 0;
    async function run(){
      while(cursor < items.length){
        const i = cursor++;
        out[i] = await worker(items[i], i);
      }
    }
    await Promise.all(Array.from({length: Math.min(limit || 8, items.length || 1)}, run));
    return out;
  }
  function bucket(k){ k = norm(k); if(!k) return 'OTHER'; const c = k[0]; if(/[0-9]/.test(c)) return c; if(/[A-Z]/.test(c)) return c; return 'OTHER'; }
  function pageModelQueryFromHandle(handle){
    let h = slug(handle || '');
    const marker = 'product-id-';
    const pos = h.indexOf(marker);
    if(pos < 0) return '';
    let q = h.slice(pos + marker.length);
    q = q
      .replace(/-parts-lists?$/g, '')
      .replace(/-parts-list$/g, '')
      .replace(/-parts$/g, '')
      .replace(/^-+|-+$/g, '');
    return q;
  }

  class DB {
    constructor(){
      this.manifest = null;
      this.manifestPromise = null;
      this.cache = {};
      this.pending = {};
      this.manifestUrl = (window.YF_NATIVE_DB && window.YF_NATIVE_DB.manifestUrl) || '/assets/yf-index-manifest.json';
    }
    async init(){
      if(this.manifest) return this.manifest;
      if(this.manifestPromise) return this.manifestPromise;
      this.manifestPromise = (async () => {
        const r = await fetch(this.manifestUrl, {credentials:'same-origin', cache:'force-cache'});
        if(!r.ok) throw new Error('Could not load native search manifest');
        this.manifest = await r.json();
        return this.manifest;
      })();
      try{ return await this.manifestPromise; }
      catch(e){ this.manifestPromise = null; throw e; }
    }
    url(file){ const u = new URL(this.manifestUrl, location.href); u.search = ''; const parts = u.pathname.split('/'); parts[parts.length-1] = file; u.pathname = parts.join('/'); return u.toString(); }
    async load(type,b){
      await this.init();
      const file = this.manifest.chunks && this.manifest.chunks[type] && this.manifest.chunks[type][b];
      if(!file) return {};
      const key = type + ':' + b;
      if(this.cache[key]) return this.cache[key];
      if(this.pending[key]) return this.pending[key];
      this.pending[key] = (async () => {
        try{
          const r = await fetch(this.url(file), {credentials:'same-origin', cache:'force-cache'});
          if(!r.ok) return {};
          return await r.json();
        }catch(e){ return {}; }
      })();
      const j = await this.pending[key];
      this.cache[key] = j || {};
      delete this.pending[key];
      return this.cache[key];
    }
    collection(){ return this.load('collection','ALL'); }
    supersessions(){ return this.load('supersession','ALL'); }
    categoryModels(){ return this.load('categoryModels','ALL'); }
    async model(q){ const k = norm(q); const ch = await this.load('model', bucket(k)); return ch[k] || null; }
    async part(q){ const k = norm(q); const ch = await this.load('part', bucket(k)); return ch[k] || null; }
    async productPart(q){ const k = norm(q); const ch = await this.load('product-part', bucket(k)); return ch[k] || null; }
    async sku(q){ const k = skuKey(q); if(!k) return []; const ch = await this.load('sku', 'ALL'); return (ch[k] || []).map(p => Object.assign({}, p)); }
    async partModelCompat(q){ const k = norm(q); if(!k) return []; const ch = await this.load('part-model-compat', 'ALL'); return (ch[k] || []).map(row => Array.isArray(row) ? row.slice() : [row]); }
    async fitment(q){
      const k = norm(q);
      if(!k) return [];
      const ch = await this.load('fitment', bucket(k));
      const strings = (ch && ch.s) || [];
      const rows = (ch && ch.p && ch.p[k]) || [];
      return rows.map(row => ({
        brand: strings[row[0]] || '',
        model: strings[row[1]] || '',
        serial: strings[row[2]] || '',
        category: strings[row[3]] || '',
        exact: row[4] === 1
      }));
    }
    async loadAll(type){
      await this.init();
      const chunks = (this.manifest.chunks && this.manifest.chunks[type]) || {};
      const keys = Object.keys(chunks);
      const loaded = await Promise.all(keys.map(k => this.load(type, k)));
      return loaded.reduce((acc, item) => Object.assign(acc, item || {}), {});
    }
    async allParts(){ return this.loadAll('part'); }
    async diagram(id){ const ch = await this.load('diagram', bucket(id)); return ch[id] || null; }
    async modelDiagrams(modelKey){ const k = norm(modelKey); const ch = await this.load('model-diagrams', bucket(k)); return ch[k] || []; }
    async searchPrefix(type,q,limit){ const k = norm(q); if(!k) return []; const ch = await this.load(type, bucket(k)); const out = []; Object.keys(ch).some(key => { const rec = ch[key]; const hay = key + ' ' + norm(rec.m||'') + ' ' + norm(rec.p||'') + ' ' + norm(rec.d||''); if(key.startsWith(k) || hay.includes(k)){ out.push(rec); } return out.length >= (limit || 6); }); return out; }
  }
  const db = new DB();
  window.YFSearchDB = db;

  // V61: faster native database + browser-back restore cache. If a customer opens a product/diagram/collection
  // and then hits the browser Back button, restore the already-rendered native results
  // instantly instead of rebuilding the page and re-checking live Shopify products.
  const YF_PAGE_CACHE_VERSION = 'v138-exact-native-back-return-20260729';
  const YF_PAGE_CACHE_PREFIX = 'yf-native-page-cache:';
  const YF_PAGE_CACHE_TTL = 45 * 60 * 1000;
  let yfPageCacheTimer = null;
  function nativePageCacheKey(){ return YF_PAGE_CACHE_PREFIX + YF_PAGE_CACHE_VERSION + ':' + location.pathname + location.search; }
  function nativeAppRootFrom(scope){ return (scope && scope.closest && scope.closest('[data-yf-native-app]')) || document.querySelector('[data-yf-native-app]'); }
  function nativeResultsFrom(scope){ const root = nativeAppRootFrom(scope); return root && root.querySelector('[data-yf-results]'); }
  function nativePageHasLoading(res){ return !!(res && res.querySelector('.yf-loading, .yf-products-loading')); }
  function pruneNativePageCache(){
    try{
      const keys = [];
      for(let i=0;i<sessionStorage.length;i++){ const k = sessionStorage.key(i); if(k && k.indexOf(YF_PAGE_CACHE_PREFIX) === 0) keys.push(k); }
      keys.sort((a,b)=>{
        try{ return (JSON.parse(sessionStorage.getItem(b)||'{}').createdAt||0) - (JSON.parse(sessionStorage.getItem(a)||'{}').createdAt||0); }catch(e){ return 0; }
      });
      keys.slice(12).forEach(k => sessionStorage.removeItem(k));
    }catch(e){}
  }
  function saveNativePageCache(scope, force){
    try{
      const root = nativeAppRootFrom(scope);
      const res = root && root.querySelector('[data-yf-results]');
      if(!root || !res) return;
      const html = (res.innerHTML || '').trim();
      if(!html) return;
      if(!force && nativePageHasLoading(res)) return;
      const item = {
        version: YF_PAGE_CACHE_VERSION,
        createdAt: Date.now(),
        path: location.pathname,
        search: location.search,
        scrollX: window.scrollX || 0,
        scrollY: window.scrollY || 0,
        breakdownMode: document.body.classList.contains('yf-breakdown-mode'),
        pageType: (root && root.dataset && root.dataset.pageType) || '',
        html: html
      };
      sessionStorage.setItem(nativePageCacheKey(), JSON.stringify(item));
      pruneNativePageCache();
    }catch(e){}
  }
  function scheduleNativePageCacheSave(scope, force){
    clearTimeout(yfPageCacheTimer);
    yfPageCacheTimer = setTimeout(function(){ saveNativePageCache(scope, force); }, 120);
  }
  function clearRestoredEventBindings(scope){
    try{
      scope.querySelectorAll('[data-yf-serial-picker][data-bound], [data-yf-ref-search][data-bound], .yf-callout-dot[data-bound], [data-yf-category-widget][data-bound]').forEach(el => el.removeAttribute('data-bound'));
      scope.querySelectorAll('[data-yf-collection-card][data-collection-safe-bound]').forEach(el => el.removeAttribute('data-collection-safe-bound'));
    }catch(e){}
  }
  async function resumeRestoredNativeLoaders(root, pageType){
    try{
      const res = root && root.querySelector('[data-yf-results]');
      if(!res || !nativePageHasLoading(res)) return;
      const params = new URLSearchParams(location.search);
      const q = String(params.get('q') || '').trim();
      const forcedModelRoute =
        (params.get('yf_native') === '1' && (params.get('yf_force') || '').toLowerCase() === 'model') ||
        params.get('view') === 'yf-model-match' ||
        params.has('yf_model_key') ||
        /(?:^#|[#&])yf-model-match(?:=1)?(?:&|$)/i.test(location.hash || '') ||
        !!window.__YF_PENDING_MODEL_ROUTE__;

      // A cached native page can be captured while one of the live Shopify
      // product rails is still checking. Restore the finished DOM instantly,
      // then resume only the unfinished rail in the background. Never rebuild
      // the complete page, which would move the customer away from the exact
      // place they left before opening a product.
      if(res.querySelector('#yf-complete-products, #yf-model-products') && (forcedModelRoute || pageType === 'part-search' || pageType === 'search-router')){
        const model = await bestModelForQuery(q, {
          allowTextModels:true,
          exactKey:params.get('yf_model_key') || '',
          contextQuery:[q, params.get('yf_brand') || '', params.get('yf_category') || ''].filter(Boolean).join(' ')
        });
        if(model && !modelHasSerialHierarchy(model)){
          lazyLoadModelProducts(res, model, q);
          return;
        }
      }

      if(res.querySelector('#yf-part-products')){
        const part = await bestPartForQuery(q);
        if(part){ lazyLoadPartProducts(res, part); return; }
      }

      if(res.querySelector('#yf-breakdown-complete-products, #yf-breakdown-part-products')){
        const modelQ = String(params.get('model') || q || '').trim();
        const serialQ = String(params.get('serial') || '').trim();
        const model = await bestModelForQuery(modelQ, {allowTextModels:true});
        if(model){
          model._allDiagrams = await allDiagramSummariesForModel(model);
          const summaries = await allDiagramSummariesForModel(model, serialQ || '');
          const diagrams = displayDiagrams(await fullDiagramsFromSummaries(summaries));
          let parts = partNumbersFromDiagrams(diagrams);
          if(!parts.length && !serialQ) parts = model.parts || [];
          lazyLoadBreakdownProducts(res, model, modelQ, parts, serialQ);
        }
      }
    }catch(e){ console.warn('Could not resume cached native product checks', e); }
  }

  function restoreNativePageCache(root, pageType){
    try{
      const res = root && root.querySelector('[data-yf-results]');
      if(!res) return false;
      const raw = sessionStorage.getItem(nativePageCacheKey());
      if(!raw) return false;
      const item = JSON.parse(raw);
      if(!item || item.version !== YF_PAGE_CACHE_VERSION || !item.html) return false;
      if(Date.now() - (item.createdAt || 0) > YF_PAGE_CACHE_TTL){ sessionStorage.removeItem(nativePageCacheKey()); return false; }
      res.innerHTML = item.html;
      clearRestoredEventBindings(res);
      if(item.breakdownMode || pageType === 'breakdowns') document.body.classList.add('yf-breakdown-mode');
      hydrateProducts(res);
      hydrateCollectionCards(res);
      initCollectionLinkSafety(res);
      initSerialSelectors(res);
      initCategoryWidgets();
      bindDiagramInteractions(res);
      window.__yfNativePageCacheRestored = true;
      const restoreX = Number(item.scrollX || 0);
      const restoreY = Number(item.scrollY || 0);
      let restoreAttempts = 0;
      function restoreCachedScroll(){
        restoreAttempts++;
        window.scrollTo(restoreX, restoreY);
        if(restoreAttempts < 12) requestAnimationFrame(restoreCachedScroll);
        else window.dispatchEvent(new CustomEvent('yf:dynamic-content-ready', {detail:{source:'native-page-cache'}}));
      }
      requestAnimationFrame(restoreCachedScroll);
      resumeRestoredNativeLoaders(root, pageType);
      return true;
    }catch(e){ return false; }
  }

  const productJsonCache = {};
  const productsForPartCache = {};
  const supersessionResultCache = {};
  const supersessionChainResultCache = {};
  const inferBrandResultCache = {};
  function productContextKey(context){
    context = context || {};
    return [
      context.fastStatic ? 'fast' : 'live',
      (context.expectedBrands || []).map(rootBrand).filter(Boolean).sort().join(','),
      plain(context.expectedCategory || '')
    ].join('|');
  }
  const YF_BRAND_ALIASES = [
    ['SUBURBAN', ['SUBURBAN']],
    ['DOMETIC', ['DOMETIC','A&E','AE']],
    ['ATWOOD', ['ATWOOD']],
    ['NORCOLD', ['NORCOLD']],
    ['MAGICCHEF', ['MAGIC CHEF','MAGICCHEF']],
    ['WEDGEWOOD', ['WEDGEWOOD','WEDGEWOOD VISION','WEDGEWOOD VISION']],
    ['COLEMAN', ['COLEMAN','MACH','AIRXCEL']],
    ['CAREFREE', ['CAREFREE']],
    ['THETFORD', ['THETFORD']],
    ['LIPPERT', ['LIPPERT','LCI']],
    ['FURRION', ['FURRION']],
    ['DEXTER', ['DEXTER']],
    ['ARCON', ['ARCON']],
    ['CAMCO', ['CAMCO']],
    ['VALTERRA', ['VALTERRA']],
    ['SHURFLO', ['SHURFLO','SHUR FLO']],
    ['FLOJET', ['FLOJET']],
    ['JABSCO', ['JABSCO']],
    ['REMCO', ['REMCO']],
    ['WFCO', ['WFCO']],
    ['JENSEN', ['JENSEN']],
    ['DOMETIC_ATWOOD', ['DOMETIC ATWOOD','ATWOOD DOMETIC']]
  ];
  function plain(v){ return String(v || '').toUpperCase().replace(/\u00A0/g,' ').replace(/[^A-Z0-9]+/g,' ').replace(/\s+/g,' ').trim(); }
  function rootBrand(v){
    const h = plain(v);
    if(!h) return '';
    if(/\bSUBURBAN\b/.test(h)) return 'SUBURBAN';
    if(/\bNORCOLD\b/.test(h)) return 'NORCOLD';
    if(/\bMAGIC\s*CHEF\b|\bMAGICCHEF\b/.test(h)) return 'MAGICCHEF';
    if(/\bWEDGEWOOD\b/.test(h)) return 'WEDGEWOOD';
    if(/\bATWOOD\b/.test(h)) return 'ATWOOD';
    if(/\bDOMETIC\b|\bA\s*E\b/.test(h)) return 'DOMETIC';
    if(/\bCOLEMAN\b|\bMACH\b|\bAIRXCEL\b/.test(h)) return 'COLEMAN';
    if(/\bCAREFREE\b/.test(h)) return 'CAREFREE';
    if(/\bTHETFORD\b/.test(h)) return 'THETFORD';
    if(/\bLIPPERT\b|\bLCI\b/.test(h)) return 'LIPPERT';
    if(/\bFURRION\b/.test(h)) return 'FURRION';
    if(/\bDEXTER\b/.test(h)) return 'DEXTER';
    if(/\bARCON\b/.test(h)) return 'ARCON';
    if(/\bCAMCO\b/.test(h)) return 'CAMCO';
    if(/\bVALTERRA\b/.test(h)) return 'VALTERRA';
    if(/\bSHUR\s*FLO\b/.test(h)) return 'SHURFLO';
    if(/\bFLOJET\b/.test(h)) return 'FLOJET';
    if(/\bJABSCO\b/.test(h)) return 'JABSCO';
    if(/\bREMCO\b/.test(h)) return 'REMCO';
    if(/\bWFCO\b/.test(h)) return 'WFCO';
    return h.split(' ')[0] || '';
  }
  function strictRootBrand(v){
    const r = rootBrand(v);
    const known = new Set(['SUBURBAN','DOMETIC','ATWOOD','NORCOLD','MAGICCHEF','WEDGEWOOD','COLEMAN','CAREFREE','THETFORD','LIPPERT','FURRION','DEXTER','ARCON','CAMCO','VALTERRA','SHURFLO','FLOJET','JABSCO','REMCO','WFCO']);
    return known.has(r) ? r : '';
  }
  function relatedBrandSet(brands, category){
    const set = new Set((brands || []).map(rootBrand).filter(Boolean));
    const cat = plain(category);
    // Atwood water heaters are often branded/sold as Dometic/Atwood. Allow that specific family,
    // but do not allow it for unrelated brands like Suburban.
    if((set.has('ATWOOD') || set.has('DOMETIC')) && /WATER HEATER|HOT WATER/.test(cat)){ set.add('ATWOOD'); set.add('DOMETIC'); }
    return set;
  }
  function brandLabelFromRoot(v){
    const r = rootBrand(v);
    const labels = {SUBURBAN:'Suburban',DOMETIC:'Dometic',ATWOOD:'Atwood',NORCOLD:'Norcold',MAGICCHEF:'Magic Chef',WEDGEWOOD:'Wedgewood',COLEMAN:'Coleman/Airxcel',CAREFREE:'Carefree',THETFORD:'Thetford',LIPPERT:'Lippert',FURRION:'Furrion',DEXTER:'Dexter',ARCON:'Arcon',CAMCO:'Camco',VALTERRA:'Valterra',SHURFLO:'SHURflo',FLOJET:'Flojet',JABSCO:'Jabsco',REMCO:'Remco',WFCO:'WFCO'};
    return labels[r] || String(v || '').replace(/_/g,' ').replace(/\w/g, c => c.toUpperCase());
  }
  function partBrandLabel(part, ctx){
    const brands = (ctx && ctx.expectedBrands) || [];
    if(brands.length) return brandLabelFromRoot(brands[0]);
    if(part && part.used && part.used.length) return '';
    return '';
  }
  function detectedProductBrands(p){
    const hay = plain([p && p.vendor, p && p.title, p && p.productType, p && p.type].filter(Boolean).join(' '));
    const found = new Set();
    YF_BRAND_ALIASES.forEach(([canon, aliases]) => aliases.forEach(a => { const aa = plain(a); if(aa && hay.includes(aa)) found.add(canon === 'DOMETIC_ATWOOD' ? 'DOMETIC' : canon); }));
    return found;
  }
  function productPassesCategoryContext(product, candidate){
    const exp = plain((candidate && candidate._expectedCategory) || '');
    if(!exp) return false;
    const hay = plain([product && product.productType, product && product.type, product && product.title, product && product.vendor].filter(Boolean).join(' '));
    if(!hay) return false;
    if(/FURNACE/.test(exp)) return /FURNACE|HEATER|SUBURBAN/.test(hay) && !/WATER HEATER|HOT WATER/.test(hay);
    if(/WATER HEATER|HOT WATER/.test(exp)) return /WATER HEATER|HOT WATER|ATWOOD|SUBURBAN|DOMETIC/.test(hay);
    if(/REFRIGERATOR|FRIDGE/.test(exp)) return /REFRIGERATOR|FRIDGE|NORCOLD|DOMETIC/.test(hay);
    if(/AIR CONDITIONER|AIRCONDITIONER/.test(exp)) return /AIR CONDITIONER|A\/C|AC |COLEMAN|MACH|DOMETIC/.test(hay);
    // RV range/oven/stove parts are often product-typed as burners, knobs, grates, valves, pilots, racks, hinges, doors, etc.
    // Do not require the literal word "range" or we will hide correct Magic Chef/Wedgewood range products.
    if(/RANGE|OVEN|STOVE|COOKTOP|COOK TOP/.test(exp)) return /RANGE|OVEN|STOVE|COOKTOP|COOK TOP|BURNER|GRATE|KNOB|PILOT|REGULATOR|VALVE|RACK|HINGE|DOOR|MANIFOLD|GROMMET|MAGIC CHEF|MAGICCHEF|WEDGEWOOD|ATWOOD|SUBURBAN/.test(hay);
    if(/AWNING/.test(exp)) return /AWNING|CAREFREE|DOMETIC|A\s*E/.test(hay);
    if(/PUMPS?|WATER PUMP|FRESH WATER|WASTE WATER/.test(exp)) return /PUMPS?|WATER PUMP|FRESH WATER|WASTE WATER|FLOJET|JABSCO|SHUR\s*FLO|SHURFLO|REMCO|THETFORD|WFCO/.test(hay) && !/VACUUM|CENTRAL VAC/.test(hay);
    const first = exp.split(' ')[0] || '';
    return !!first && (hay.includes(first) || hay.includes(first.replace(/S$/, '')) || hay.includes(first + 'S'));
  }
  function productMetafieldMatchesCandidate(product, candidate){
    const target = norm((candidate && (candidate._targetPart || candidate._matchedPart || candidate.partNumber || candidate.p)) || '');
    if(!target) return true;
    const mf = norm((candidate && (candidate._metafieldPartNumber || candidate.metafieldPartNumber || candidate.partNumber)) || '');
    // Visible smart-panel products must be grounded in the Shopify product metafield.
    // SKU/title-only matches are too risky because part numbers repeat across brands/categories.
    return !!mf && mf === target;
  }
  function productPassesBrandContext(product, candidate){
    const expected = relatedBrandSet(candidate && candidate._expectedBrands, candidate && candidate._expectedCategory);
    if(!expected.size) return true;
    const productBrands = detectedProductBrands(product);
    for(const b of productBrands){ if(expected.has(b)) return true; }
    // If the product is not clearly branded, require category/family agreement instead of accepting it blindly.
    if(!productBrands.size) return productPassesCategoryContext(product, candidate);
    return false;
  }
  async function inferBrandsForPartNumber(partNumber, existingPart){
    const cacheKey = norm(partNumber);
    if(cacheKey && !existingPart && inferBrandResultCache[cacheKey]) return inferBrandResultCache[cacheKey];
    const promise = (async () => {
    const part = existingPart || await db.part(partNumber);
    const brands = new Set();
    const categoryHints = new Set();
    // Do not treat the first word of a plain description as a brand.
    // Example: "BACK, FLUE COLLECTOR" used to become brand "Back".
    // Only use known brand words from the description; otherwise infer brand from connected diagrams/models.
    const descBrand = strictRootBrand(part && part.d);
    if(descBrand) brands.add(descBrand);
    for(const u of ((part && part.used) || []).slice(0, 18)){
      const did = u && u[2];
      if(!did) continue;
      const d = await db.diagram(did);
      const rb = rootBrand(d && d.b);
      if(rb) brands.add(rb);
      if(d && d.c) categoryHints.add(d.c);
    }
    return {expectedBrands:[...brands], expectedCategory:[...categoryHints][0] || ''};
    })();
    if(cacheKey && !existingPart) inferBrandResultCache[cacheKey] = promise;
    return promise;
  }
  async function shopifyProduct(handle){
    if(!handle) return null;
    if(productJsonCache[handle] !== undefined) return productJsonCache[handle];
    productJsonCache[handle] = (async () => {
      try{
        const r = await fetch('/products/' + handle + '.js', {credentials:'same-origin'});
        if(!r.ok) return null;
        return await r.json();
      }catch(e){ return null; }
    })();
    return productJsonCache[handle];
  }
  function bestVariant(j){ if(!j || !Array.isArray(j.variants) || !j.variants.length) return null; return j.variants.find(v => v.available) || j.variants[0]; }
  function variantForSku(j, sku){
    if(!j || !Array.isArray(j.variants) || !j.variants.length) return null;
    const k = skuKey(sku);
    return j.variants.find(v => skuKey(v && v.sku) === k) || bestVariant(j);
  }
  function variantIdFromProduct(p, v){
    if(v && v.id) return String(v.id);
    const raw = String((p && p.variantId) || '');
    return raw ? raw.split('/').pop() : '';
  }
  function productImage(j){ return (j && (j.featured_image || (j.images && j.images[0]))) || ''; }
  async function liveProductFromCandidate(p){
    if(!p || !p.handle) return null;
    if(!productMetafieldMatchesCandidate(null, p)) return null;
    const j = await shopifyProduct(p.handle);
    if(!j) return null;
    const v = bestVariant(j);
    if(!v || !v.available || j.available === false) return null;
    const live = {
      handle: j.handle || p.handle,
      title: j.title || p.title || p.handle,
      url: '/products/' + (j.handle || p.handle),
      imageUrl: productImage(j) || p.imageUrl || '',
      vendor: j.vendor || p.vendor || '',
      productType: j.type || p.productType || '',
      price: v.price,
      compareAtPrice: v.compare_at_price || j.compare_at_price || p.compareAtPrice || null,
      sku: v.sku || p.sku || '',
      partNumber: p.partNumber || p.p || p._matchedPart || '',
      metafieldPartNumber: p.metafieldPartNumber || p._metafieldPartNumber || p.partNumber || '',
      available: true
    };
    if(!productPassesBrandContext(live, p)) return null;
    return live;
  }
  function candidateLooksAvailable(p){
    if(!p) return false;
    if(p.available === false) return false;
    if(p.inventory != null && Number(p.inventory) <= 0) return false;
    return true;
  }
  function staticProductFromCandidate(p){
    if(!p || !p.handle) return null;
    if(!productMetafieldMatchesCandidate(null, p)) return null;
    if(!candidateLooksAvailable(p)) return null;
    const live = {
      handle: p.handle,
      title: p.title || p.handle,
      url: p.url || ('/products/' + p.handle),
      imageUrl: p.imageUrl || p.image || '',
      vendor: p.vendor || '',
      productType: p.productType || p.type || '',
      price: p.price || '',
      compareAtPrice: p.compareAtPrice || null,
      sku: p.sku || '',
      partNumber: p.partNumber || p.p || p._matchedPart || '',
      metafieldPartNumber: p.metafieldPartNumber || p._metafieldPartNumber || p.partNumber || '',
      available: true,
      _fastStatic: true
    };
    if(!productPassesBrandContext(live, p)) return null;
    return live;
  }
  async function enrichProductsFastStatic(candidates, limit){
    const unique = [], seen = new Set();
    for(const p of (candidates || [])){
      const h = p && p.handle;
      if(!h || seen.has(h)) continue;
      seen.add(h);
      const live = staticProductFromCandidate(p);
      if(live) unique.push(Object.assign({}, live, {_matchedPart:p._matchedPart, _label:p._label, _klass:p._klass}));
      if(limit && unique.length >= limit) break;
    }
    return unique.slice(0, limit || unique.length);
  }

  async function enrichProducts(candidates, limit){
    // V33 speed fix: validate Shopify products in parallel instead of one-by-one.
    // The cards still come from yf_extracted_data.part_number matches and still require live Shopify availability,
    // but the user no longer waits for every handle sequentially.
    const unique = [], seen = new Set();
    for(const p of (candidates || [])){
      const h = p && p.handle;
      if(!h || seen.has(h)) continue;
      seen.add(h);
      unique.push(p);
    }
    const max = limit || unique.length;
    const out = [];
    let cursor = 0;
    async function worker(){
      while(cursor < unique.length && out.length < max){
        const p = unique[cursor++];
        try{
          const live = await liveProductFromCandidate(p);
          if(live && out.length < max){
            out.push(Object.assign({}, live, {_matchedPart:p._matchedPart, _label:p._label, _klass:p._klass}));
          }
        }catch(e){}
      }
    }
    await Promise.all(Array.from({length: Math.min(12, unique.length || 1)}, worker));
    return out.slice(0, max);
  }

  async function filterLiveOnlineInStockProducts(products, limit){
    const unique = [], seen = new Set();
    for(const p of (products || [])){
      const handle = p && (p.handle || handleFromProductUrl(p.url));
      if(!handle || seen.has(handle)) continue;
      seen.add(handle);
      unique.push(Object.assign({}, p, {handle}));
    }
    const max = limit || unique.length;
    const out = [];
    let cursor = 0;
    async function worker(){
      while(cursor < unique.length && out.length < max){
        const p = unique[cursor++];
        try{
          if(p.inventory != null && p.inventory !== '' && isFinite(Number(p.inventory)) && Number(p.inventory) <= 0) continue;
          const j = await shopifyProduct(p.handle);
          if(!j || j.available === false) continue;
          const v = bestVariant(j);
          if(!v || !v.available) continue;
          if(v.inventory_quantity != null && isFinite(Number(v.inventory_quantity)) && Number(v.inventory_quantity) <= 0) continue;
          const variantId = variantIdFromProduct(p, v);
          out.push(Object.assign({}, p, {
            handle: j.handle || p.handle,
            title: j.title || p.title || p.handle,
            url: '/products/' + (j.handle || p.handle) + (variantId ? '?variant=' + enc(variantId) : ''),
            imageUrl: productImage(j) || p.imageUrl || p.image || '',
            vendor: j.vendor || p.vendor || '',
            productType: j.type || p.productType || p.type || '',
            price: v.price != null ? v.price : p.price,
            compareAtPrice: v.compare_at_price || j.compare_at_price || p.compareAtPrice || null,
            sku: v.sku || p.sku || '',
            inventory: v.inventory_quantity != null ? v.inventory_quantity : p.inventory,
            available: true
          }));
        }catch(e){}
      }
    }
    await Promise.all(Array.from({length: Math.min(10, unique.length || 1)}, worker));
    return out.slice(0, max);
  }
  function handleFromProductUrl(url){
    try{
      const u = new URL(url || '', location.origin);
      const m = u.pathname.match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    }catch(e){
      const m = String(url || '').match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    }
  }
  const searchProductCache = {};
  async function shopifySearchProductsForPart(pn, context){
    const k = norm(pn);
    if(!k) return [];
    if(searchProductCache[k]) return searchProductCache[k];
    searchProductCache[k] = (async () => {
      const out = [];
      try{
        // This alternate Shopify search template returns live Shopify products plus the yf_extracted_data.part_number metafield.
        // It lets the native theme find products that Shopify already knows about even if the static export missed them.
        const r = await fetch('/search?type=product&view=yfjson&q=' + enc(pn), {credentials:'same-origin'});
        if(r.ok){
          const j = await r.json();
          (j.products || []).forEach(p => {
            const mf = norm(p.partNumber || p.metafieldPartNumber || '');
            const sku = norm(p.sku || '');
            if(mf === k || (!mf && sku === k)){
              const handle = p.handle || handleFromProductUrl(p.url);
              if(handle){ out.push(Object.assign({}, p, {handle, _matchedPart: pn, _targetPart: pn, _metafieldPartNumber: p.partNumber || p.metafieldPartNumber || '', partNumber: p.partNumber || pn, _expectedBrands:(context&&context.expectedBrands)||[], _expectedCategory:(context&&context.expectedCategory)||'', matchSource: 'live-shopify-search'})); }
            }
          });
        }
      }catch(e){}
      // Do not use predictive-search for product cards here. It does not expose yf_extracted_data.part_number,
      // so it can return unrelated products that happen to share the same numeric code.
      // Dedupe by handle before returning candidates.
      const seen = new Set();
      return out.filter(p => { const h = p.handle || handleFromProductUrl(p.url); if(!h || seen.has(h)) return false; seen.add(h); return true; });
    })();
    return searchProductCache[k];
  }
  async function productsForPart(pn, context){
    context = context || {};
    const partKey = norm(pn);
    const cacheKey = partKey + '|' + productContextKey(context);
    if(productsForPartCache[cacheKey]) return productsForPartCache[cacheKey];
    productsForPartCache[cacheKey] = (async () => {
      const pp = await db.productPart(pn);
      const staticCandidates = [...(pp && pp.products || [])].map(p => Object.assign({}, p, {_matchedPart: pn, _targetPart: pn, _metafieldPartNumber: p.partNumber || p.metafieldPartNumber || pn, partNumber: p.partNumber || pn, _expectedBrands:context.expectedBrands || [], _expectedCategory:context.expectedCategory || ''}));

      // V61 speed path: model/breakdown pages often check 50-200 part numbers.
      // The generated product-part index already contains active Shopify availability/inventory,
      // so bulk pages can render matching product cards immediately and hydrate images/prices in the background.
      if(context.fastStatic){
        return enrichProductsFastStatic(staticCandidates, 80);
      }

      const liveSearchCandidates = await shopifySearchProductsForPart(pn, context);
      const all = [];
      const seen = new Set();
      [...staticCandidates, ...liveSearchCandidates].forEach(p => {
        const h = p && (p.handle || handleFromProductUrl(p.url));
        if(!h || seen.has(h)) return;
        seen.add(h);
        all.push(Object.assign({}, p, {handle:h, _matchedPart: pn, _targetPart: pn, _metafieldPartNumber: p._metafieldPartNumber || p.metafieldPartNumber || p.partNumber || '', partNumber: p.partNumber || pn, _expectedBrands:context.expectedBrands || p._expectedBrands || [], _expectedCategory:context.expectedCategory || p._expectedCategory || ''}));
      });
      return enrichProducts(all, 80);
    })();
    return productsForPartCache[cacheKey];
  }
  async function productForPart(pn, context){ const ps = await productsForPart(pn, context || {}); return ps[0] || null; }

  let allIndexedProductsPromise = null;
  async function allIndexedProducts(){
    if(allIndexedProductsPromise) return allIndexedProductsPromise;
    allIndexedProductsPromise = (async () => {
      await db.init();
      const chunks = (db.manifest && db.manifest.chunks && db.manifest.chunks['product-part']) || {};
      const out = [];
      const seen = new Set();
      await Promise.all(Object.keys(chunks).map(async b => {
        const ch = await db.load('product-part', b);
        Object.keys(ch || {}).forEach(k => {
          const rec = ch[k];
          (rec && rec.products || []).forEach(p => {
            const h = p && p.handle;
            if(!h || seen.has(h)) return;
            seen.add(h);
            out.push(p);
          });
        });
      }));
      return out;
    })();
    return allIndexedProductsPromise;
  }
  async function relatedProductsForSkuProduct(product, part, limit){
    const all = await allIndexedProducts();
    const handle = product && product.handle;
    const exactSku = skuKey(product && product.sku);
    const productType = plain(product && product.productType);
    const vendor = rootBrand(product && product.vendor);
    const usedPartNumbers = new Set([norm(product && product.partNumber), norm(part && part.p)].filter(Boolean));
    const scored = [];
    all.forEach(p => {
      if(!p || !p.handle || p.handle === handle) return;
      if(exactSku && skuKey(p.sku) === exactSku) return;
      if(p.available === false) return;
      const pt = plain(p.productType);
      const pv = rootBrand(p.vendor);
      let score = 0;
      if(productType && pt === productType) score += 90;
      else if(productType && pt && (pt.includes(productType) || productType.includes(pt))) score += 45;
      if(vendor && pv === vendor) score += 25;
      if(usedPartNumbers.has(norm(p.partNumber))) score -= 200;
      if(score > 0) scored.push(Object.assign({}, p, {_score:score}));
    });
    scored.sort((a,b) => (b._score-a._score) || Number(b.inventory||0)-Number(a.inventory||0) || String(a.title||'').localeCompare(String(b.title||'')));
    return scored.slice(0, limit || 6);
  }
  async function enrichSkuProduct(p){
    if(!p || !p.handle) return p;
    const j = await shopifyProduct(p.handle);
    if(!j) return p;
    const v = variantForSku(j, p.sku);
    const variantId = variantIdFromProduct(p, v);
    return Object.assign({}, p, {
      title: j.title || p.title,
      vendor: j.vendor || p.vendor,
      productType: j.type || p.productType,
      imageUrl: productImage(j) || p.imageUrl || '',
      price: (v && v.price != null) ? v.price : p.price,
      compareAtPrice: (v && v.compare_at_price != null) ? v.compare_at_price : p.compareAtPrice,
      sku: (v && v.sku) || p.sku,
      available: v ? !!v.available : p.available,
      variantId: variantId || p.variantId,
      url: '/products/' + (j.handle || p.handle) + (variantId ? '?variant=' + enc(variantId) : '')
    });
  }

  async function supersessionFor(pn){
    const k = norm(pn);
    if(supersessionResultCache[k]) return supersessionResultCache[k];
    supersessionResultCache[k] = (async () => {
      const all = await db.supersessions();
      const rec = all[k] || {partNumber: pn, supersededBy: [], supersededParts: []};
      const part = await db.part(pn);
      if(part){
        for(const x of part.replacedBy || []){ const nx = norm(x); if(nx && !rec.supersededBy.includes(nx)) rec.supersededBy.push(nx); }
        for(const x of part.replaces || []){ const nx = norm(x); if(nx && !rec.supersededParts.includes(nx)) rec.supersededParts.push(nx); }
        const m = String(part.d || '').match(/\bUSE\s*:?\s*([A-Z0-9][A-Z0-9\-\./]{1,30})/i);
        if(m){ const nx = norm(m[1]); if(nx && !rec.supersededBy.includes(nx)) rec.supersededBy.push(nx); }
      }
      return rec;
    })();
    return supersessionResultCache[k];
  }
  async function supersessionChain(pn){
    const searched = norm(pn);
    if(supersessionChainResultCache[searched]) return supersessionChainResultCache[searched];
    supersessionChainResultCache[searched] = (async () => {
      const forward = [], seen = new Set([searched]);
      let cur = searched;
      for(let i=0;i<6;i++){
        const s = await supersessionFor(cur); const n = (s.supersededBy || [])[0];
        if(!n || seen.has(n)) break;
        forward.push(n); seen.add(n); cur = n;
      }
      const reverse = [];
      for(const k of [searched, ...forward]){
        const s = await supersessionFor(k);
        for(const old of s.supersededParts || []){ const no = norm(old); if(no && !seen.has(no)){ reverse.push(no); seen.add(no); } }
      }
      return {searched, current: forward.length ? forward[forward.length-1] : searched, forward, reverse};
    })();
    return supersessionChainResultCache[searched];
  }
  async function productsForChain(pn, context){
    context = context || await inferBrandsForPartNumber(pn);
    const ch = await supersessionChain(pn);
    const order = [];
    if(ch.forward.length) order.push(...ch.forward.slice().reverse().map(p => [p, 'Current replacement', 'blue']));
    order.push([ch.searched, ch.forward.length ? 'Legacy part' : 'Exact match', ch.forward.length ? 'amber' : 'green']);
    order.push(...ch.reverse.map(p => [p, 'Older number', 'amber']));
    const out = [], seen = new Set();
    for(const [part, label, klass] of order){
      const partCtx = part === norm(pn) ? context : (context && context.expectedBrands && context.expectedBrands.length ? context : await inferBrandsForPartNumber(part));
      const ps = await productsForPart(part, partCtx);
      for(const p of ps){ const key = p.handle || p.url || p.title; if(key && !seen.has(key)){ seen.add(key); out.push({product:p, matchedPart:part, label, klass}); } }
    }
    return {chain: ch, items: out};
  }
  async function productsForPartsDirect(parts, limit, context){
    // Fast path for model/diagram pages: match each diagram part number directly to Shopify products.
    // V78: when used for replacement-part panels, re-check every candidate against /products/{handle}.js.
    // That guarantees the card is still active, published to the Online Store, and actually in stock.
    const max = limit || 96;
    const input = [...new Set((parts || []).map(x => String(x || '').trim()).filter(Boolean).map(norm))].slice(0, 160);
    const requireOnlineStore = !!(context && context.requireOnlineStore);
    const poolMax = requireOnlineStore ? Math.max(max * 3, max + 24) : max;
    const out = [], seen = new Set();
    const bulkContext = Object.assign({}, context || {}, {fastStatic:true});
    let cursor = 0;
    async function worker(){
      while(cursor < input.length && out.length < poolMax){
        const pn = input[cursor++];
        try{
          const ps = await productsForPart(pn, bulkContext);
          for(const p of ps){
            const key = p && (p.handle || p.url || p.title);
            if(key && !seen.has(key)){
              seen.add(key);
              out.push(Object.assign({}, p, {_matchedPart:pn, _label:'Matching part', _klass:'green'}));
              if(out.length >= poolMax) break;
            }
          }
        }catch(e){ console.warn('Direct product match failed for part', pn, e); }
      }
    }
    await Promise.all(Array.from({length: Math.min(14, input.length || 1)}, worker));
    if(requireOnlineStore) return filterLiveOnlineInStockProducts(out, max);
    return out.slice(0, max);
  }


  async function productsForDiagramPartNumbersLive(parts, limit, context){
    // V125: Model-match and serial-match product panels must mirror the breakdown
    // diagram product discovery path. The old model panel used the fast static
    // product-part index, which could show only one matching product per part
    // number and miss newer New/Used duplicates that the diagram page found with
    // live exact yf_extracted_data.part_number lookups. This function checks each
    // diagram part through productsForReferencePart(), then dedupes the live,
    // active, Online Store, in-stock products across every connected breakdown.
    const max = limit || 160;
    const input = [...new Set((parts || []).map(x => String(x || '').trim()).filter(Boolean).map(norm))].slice(0, 320);
    const out = [];
    const seen = new Set();
    let cursor = 0;
    async function worker(){
      while(cursor < input.length && out.length < Math.max(max * 2, max + 32)){
        const pn = input[cursor++];
        try{
          const chain = await supersessionChain(pn);
          const list = await productsForReferencePart(pn, chain);
          for(const p of (list || [])){
            const h = p && (p.handle || handleFromProductUrl(p.url));
            const key = h || (p && (p.url || p.title));
            if(!key || seen.has(key)) continue;
            seen.add(key);
            out.push(Object.assign({}, p, {handle:h || p.handle, _matchedPart:p._matchedPart || pn, _label:p._label || 'Exact part', _klass:p._klass || 'green'}));
            if(out.length >= Math.max(max * 2, max + 32)) break;
          }
        }catch(e){ console.warn('Live diagram product match failed for part', pn, e); }
      }
    }
    await Promise.all(Array.from({length: Math.min(10, input.length || 1)}, worker));
    // productsForReferencePart already does this check, but keep a final guard so
    // model panels and diagram panels follow the same availability rules.
    return filterLiveOnlineInStockProducts(out, max);
  }


  const modelReversePartCache = {};
  async function partNumbersThatFitModel(model){
    if(!model) return [];
    const modelKey = norm(model.m);
    if(!modelKey) return [];
    if(modelReversePartCache[modelKey]) return modelReversePartCache[modelKey];
    modelReversePartCache[modelKey] = (async () => {
      const out = new Set();
      const diagramIds = new Set();
      try{
        const summaries = (model._allDiagrams && model._allDiagrams.length) ? model._allDiagrams : await allDiagramSummariesForModel(model);
        (summaries || []).forEach(d => { if(d && d.id) diagramIds.add(String(d.id)); });
        const full = await fullDiagramsFromSummaries(summaries || []);
        (full || []).forEach(d => { if(d && d.id) diagramIds.add(String(d.id)); });
      }catch(e){}
      try{
        const all = await db.allParts();
        Object.keys(all || {}).forEach(k => {
          const rec = all[k];
          if(!rec || !Array.isArray(rec.used)) return;
          const fits = rec.used.some(u => {
            const usedModel = norm((Array.isArray(u) ? u[0] : (u && (u.model || u.m))) || '');
            const usedDiagram = String((Array.isArray(u) ? u[2] : (u && (u.diagram_id || u.diagramId || u.d))) || '');
            return usedModel === modelKey || (usedDiagram && diagramIds.has(usedDiagram));
          });
          if(fits){
            const pn = rec.p || rec.n || k;
            const nk = norm(pn);
            if(nk) out.add(pn);
          }
        });
      }catch(e){ console.warn('Could not scan reverse part/model compatibility', e); }
      return Array.from(out);
    })();
    return modelReversePartCache[modelKey];
  }

  async function productsForParts(parts, limit, context){
    const max = limit || 96;
    const input = [...new Set((parts || []).map(x => String(x || '').trim()).filter(Boolean).map(norm))].slice(0, 220);
    const out = [], seen = new Set();
    const bulkContext = (context && context.forceLiveSearch) ? Object.assign({}, context || {}, {fastStatic:false}) : Object.assign({}, context || {}, {fastStatic:true});
    let cursor = 0;
    async function worker(){
      while(cursor < input.length && out.length < max){
        const pn = input[cursor++];
        try{
          const res = await productsForChain(pn, bulkContext);
          for(const item of res.items){
            const p = item.product; const key = p && (p.handle || p.url || p.title);
            if(key && !seen.has(key)){
              seen.add(key);
              out.push(Object.assign({}, p, {_matchedPart:item.matchedPart, _label:item.label, _klass:item.klass}));
              if(out.length >= max) break;
            }
          }
        }catch(e){ console.warn('Product match failed for part', pn, e); }
      }
    }
    await Promise.all(Array.from({length: Math.min(8, input.length || 1)}, worker));
    return out.slice(0, max);
  }
  async function productsForModel(model, limit){
    // V55: Model-result products must mirror the products available from EVERY
    // connected breakdown diagram. Build one full part-number set from:
    // 1) model.parts, 2) every associated full diagram.parts row, and
    // 3) legacy/replaced rows that enrichDiagramParts can recover from part_knowledge.used.
    // Then run the same exact/direct lookup used by breakdown pages first, because that is
    // the source the user can visually verify from each breakdown. Finally add supersession
    // chain matches as extras without replacing the exact breakdown matches.
    if(!model) return [];
    const parts = new Set();
    (model.parts || []).forEach(p => { const k = norm(p); if(k) parts.add(k); });
    try{
      const summaries = (model._allDiagrams && model._allDiagrams.length) ? model._allDiagrams : await allDiagramSummariesForModel(model);
      const full = await fullDiagramsFromSummaries(summaries || []);
      for(const d of (full || [])){
        const enriched = await enrichDiagramParts(d, model);
        (enriched || []).forEach(row => { const k = norm(row && row[1]); if(k) parts.add(k); });
      }
      partNumbersFromDiagrams(full).forEach(p => { const k = norm(p); if(k) parts.add(k); });
    }catch(e){ console.warn('Could not load all model breakdown parts for product matching', e); }
    let reverseParts = [];
    try{
      reverseParts = await partNumbersThatFitModel(model);
      (reverseParts || []).forEach(p => { const k = norm(p); if(k) parts.add(k); });
    }catch(e){ console.warn('Could not load reverse model part matches', e); }
    const ctx = {expectedBrands:[model.b], expectedCategory:model.c, requireOnlineStore:true};
    const max = limit || 160;
    const liveDiagramMatches = await productsForDiagramPartNumbersLive([...parts], max, ctx);
    const direct = await productsForPartsDirect([...parts], max, ctx);
    const chain = await productsForParts([...parts], max, ctx);
    const reverseLive = (reverseParts && reverseParts.length) ? await productsForParts(reverseParts, max, Object.assign({}, ctx, {forceLiveSearch:true})) : [];
    const out = [], seen = new Set();
    [...liveDiagramMatches, ...direct, ...chain, ...reverseLive].forEach(p => {
      const key = p && (p.handle || p.url || p.title);
      if(key && !seen.has(key) && out.length < Math.max(max * 2, max + 24)){ seen.add(key); out.push(p); }
    });
    return filterLiveOnlineInStockProducts(out, max);
  }
  async function productsForCompleteUnit(model, originalQuery, limit){
    const candidates = [];
    const ctx = {expectedBrands:[model && model.b].filter(Boolean), expectedCategory:model && model.c};
    function add(v){ v = String(v || '').trim(); if(!v) return; if(!candidates.map(norm).includes(norm(v))) candidates.push(v); }
    add(originalQuery);
    add(model && model.m);
    add(model && model.n);
    if(model && model.m) add(String(model.m).replace(/\s+Series$/i, '').trim());
    if(originalQuery) add(String(originalQuery).replace(/\s+Series$/i, '').trim());
    const out = [], seen = new Set();
    for(const c of candidates){
      const ps = await productsForPart(c, ctx);
      for(const p of ps){
        const key = p.handle || p.url || p.title;
        if(key && !seen.has(key)){ seen.add(key); out.push(Object.assign({}, p, {_matchedPart:c, _label:'Complete unit', _klass:'green'})); if(limit && out.length >= limit) return out; }
      }
    }
    return out;
  }
  async function allDiagramSummariesForModel(model, serial){
    const keys = [];
    if(model){ keys.push(model._lookupModelKey, model.n, model.m); }
    const unique = [...new Set(keys.map(norm).filter(Boolean))];
    let all = [];
    for(const k of unique){
      try{
        const arr = await db.modelDiagrams(k);
        if(arr && arr.length){ all = arr; break; }
      }catch(e){}
    }
    if(!all.length) all = (model && model.diagrams) || [];
    const serialFilter = serial || (model && model._serial) || '';
    if(serialFilter) all = all.filter(d => serialMatches(d && d.s, serialFilter));
    const seen = new Set(), out = [];
    all.forEach(d => { const id = d && d.id; if(id && !seen.has(id)){ seen.add(id); out.push(d); } });
    return displayDiagrams(out);
  }

  async function fullDiagramsFromSummaries(summaries){
    return mapLimit((summaries || []), 10, async d => {
      if(d && Array.isArray(d.parts) && d.parts.length) return d;
      const full = d && d.id ? await db.diagram(d.id) : null;
      return full || d;
    });
  }

  const collectionImageCache = {};
  function firstProductImageFromCollectionProduct(p){
    if(!p) return '';
    if(typeof p.image === 'string') return p.image;
    if(p.image && p.image.src) return p.image.src;
    if(Array.isArray(p.images)){
      for(const img of p.images){
        if(typeof img === 'string') return img;
        if(img && img.src) return img.src;
      }
    }
    return '';
  }
  async function collectionImage(handle){
    handle = canonicalCollectionHandle(handle);
    if(!handle) return '';
    if(collectionImageCache[handle] !== undefined) return collectionImageCache[handle];
    collectionImageCache[handle] = (async () => {
      try{
        // V36/V61: if a collection has no dedicated collection image, use the first available product
        // image from the collection instead of leaving the recommended card blank. Cache in-flight requests too.
        const r = await fetch('/collections/' + handle + '/products.json?limit=20', {credentials:'same-origin'});
        if(!r.ok) return '';
        const j = await r.json();
        for(const p of (j.products || [])){
          const img = firstProductImageFromCollectionProduct(p);
          if(img) return img;
        }
        return '';
      }catch(e){ return ''; }
    })();
    return collectionImageCache[handle];
  }
  function cleanCategoryName(v){
    let s = String(v || '').replace(/[_-]+/g,' ').trim();
    const map = {'water heater':'Water Heaters','water heaters':'Water Heaters','hot water heater':'Water Heaters','furnace':'Furnaces','furnaces':'Furnaces','fridge':'Refrigerators','fridges':'Refrigerators','refrigerator':'Refrigerators','refrigerators':'Refrigerators','air conditioner':'Air Conditioners','air conditioners':'Air Conditioners','awning':'Awnings','awnings':'Awnings'};
    const k = s.toLowerCase(); if(map[k]) return map[k];
    return s.replace(/\b\w/g, m => m.toUpperCase()).replace(/\bRv\b/g,'RV');
  }

  const YF_COLLECTION_ALIASES = {
    // V35: dropdown/category links must never build guessed handles that 404.
    // These aliases force common display/title guesses back to the real Shopify collection handles.
    'water-pumps-accessories':'pompes-et-accessoires',
    'pumps-accessories':'pompes-et-accessoires',
    'water-pump':'pompes-et-accessoires',
    'water-pumps':'pompes-et-accessoires',
    'used-rv-water-pumps-parts':'used-water-pumps-parts',
    'used-water-pump-parts':'used-water-pumps-parts',
    'rv-water-pumps-parts':'used-water-pumps-parts',
    'new-rv-ladders-bunk-ladders':'new-rv-ladders-bunk-ladders',
    'rv-ladders-bunk-ladders':'new-rv-ladders-bunk-ladders',
    'new-rv-refrigerator-replacement-parts':'new-used-rv-refrigerators-replacement-parts',
    'new-rv-refrigerators-replacement-parts':'new-used-rv-refrigerators-replacement-parts',
    'new-rv-water-heater-replacement-parts':'new-used-rv-hot-water-heaters',
    'new-rv-hot-water-heaters':'new-used-rv-hot-water-heaters',
    'new-rv-furnaces-replacement-parts':'new-used-rv-furnaces-replacement-parts',
    'new-rv-furnace-replacement-parts':'new-used-rv-furnaces-replacement-parts',
    'new-rv-air-conditioners-replacement-parts':'new-used-rv-air-conditioners-replacement-parts',
    'rv-air-conditioners-replacement-parts':'new-used-rv-air-conditioners-replacement-parts',
    'rv-rims-and-tires':'used-rv-rims-tires',
    'rims-and-tires':'used-rv-rims-tires',
    'rv-rims-tires':'used-rv-rims-tires',
    'rv-tires':'used-rv-rims-tires',
    'tires':'used-rv-rims-tires',
    'tire':'used-rv-rims-tires',
    'rv-vacuum-cleaners-and-accessories':'rv-vacuum-cleaners-accessories',
    'vacuum-cleaners-accessories':'rv-vacuum-cleaners-accessories',
    'central-vacuum-systems':'rv-vacuum-cleaners-accessories',
    'covers':'rv-covers',
    'rv-wheel-covers':'rv-covers'
  };
  const YF_CATEGORY_TO_COLLECTION = {
    'WATERHEATER':'new-used-rv-hot-water-heaters',
    'HOTWATERHEATER':'new-used-rv-hot-water-heaters',
    'WATERHEATERS':'new-used-rv-hot-water-heaters',
    'WATER_HEATER':'new-used-rv-hot-water-heaters',
    'REFRIGERATOR':'new-used-rv-refrigerators-replacement-parts',
    'REFRIGERATORS':'new-used-rv-refrigerators-replacement-parts',
    'FRIDGE':'new-used-rv-refrigerators-replacement-parts',
    'FURNACE':'new-used-rv-furnaces-replacement-parts',
    'FURNACES':'new-used-rv-furnaces-replacement-parts',
    'AIRCONDITIONER':'new-used-rv-air-conditioners-replacement-parts',
    'AIRCONDITIONERS':'new-used-rv-air-conditioners-replacement-parts',
    'AC':'new-used-rv-air-conditioners-replacement-parts',
    'AWNING':'new-rv-awnings-replacement-parts-accessories',
    'AWNINGS':'new-rv-awnings-replacement-parts-accessories',
    'WATERPUMP':'pompes-et-accessoires',
    'WATERPUMPS':'pompes-et-accessoires',
    'PUMP':'pompes-et-accessoires',
    'PUMPS':'pompes-et-accessoires',
    'LADDER':'new-rv-ladders-bunk-ladders',
    'LADDERS':'new-rv-ladders-bunk-ladders'
  };

  // V28: Shopify-native curated category engine.
  // This mirrors the old server-side order: preprocess query -> detect condition -> curated collection scoring -> selector category.
  // The theme cannot run Gemini, but it can run the same deterministic curated/category layer natively.
  const YF_COMPOUND_FIXES = [
    ['waterheater','water heater'], ['hotwaterheater','hot water heater'], ['waterpumps','water pumps'], ['waterpump','water pump'], ['water pups','water pumps'], ['waterpups','water pumps'], ['water pup','water pump'],
    ['airconditioner','air conditioner'], ['gasvalve','gas valve'],
    ['coolingunit','cooling unit'], ['slideout','slide out'], ['ignitionboard','ignition board'], ['thermocouple','thermocouple'],
    ['thermalcouple','thermocouple'], ['furnase','furnace'], ['furnece','furnace'], ['refridgerator','refrigerator'], ['frige','fridge'], ['thermstat','thermostat'], ['laders','ladders'], ['lader','ladder']
  ];
  const YF_STOP_WORDS = new Set(['a','an','the','for','in','of','rv','replacement','parts','part','accessories','accessory','looking','need','want','find','show','me','my','to','with','and','or','on','please']);
  function singularToken(t){
    t = String(t || '').trim();
    if(t.length <= 3) return t;
    if(/ies$/.test(t)) return t.slice(0,-3)+'y';
    if(/sses$/.test(t)) return t.slice(0,-2);
    if(/ches$|shes$|xes$|zes$/.test(t)) return t.slice(0,-2);
    if(/s$/.test(t) && !/ss$/.test(t)) return t.slice(0,-1);
    return t;
  }
  function cleanQueryForCategory(q){
    let out = String(q || '').toLowerCase();
    YF_COMPOUND_FIXES.forEach(([from,to]) => { out = out.replace(new RegExp(from, 'g'), to); });
    out = out.replace(/[^a-z0-9\s\-\/]/g,' ').replace(/[\-\/]+/g,' ').replace(/\s+/g,' ').trim();
    return out;
  }
  function categoryTokens(q){
    return cleanQueryForCategory(q).split(/\s+/).filter(Boolean).filter(t => !YF_STOP_WORDS.has(t)).map(singularToken);
  }
  function detectCondition(q){
    const clean = cleanQueryForCategory(q);
    if(/\b(used|pre owned|preowned|second hand)\b/.test(clean)) return 'used';
    if(/\b(new|brand new)\b/.test(clean)) return 'new';
    return 'any';
  }
  function editDistance(a,b){
    a=String(a||''); b=String(b||'');
    if(a===b) return 0;
    if(!a) return b.length; if(!b) return a.length;
    const dp = Array.from({length:a.length+1},(_,i)=>[i]);
    for(let j=1;j<=b.length;j++) dp[0][j]=j;
    for(let i=1;i<=a.length;i++) for(let j=1;j<=b.length;j++) dp[i][j]=Math.min(dp[i-1][j]+1, dp[i][j-1]+1, dp[i-1][j-1]+(a[i-1]===b[j-1]?0:1));
    return dp[a.length][b.length];
  }
  function wordClose(a,b){
    if(!a||!b) return false;
    if(a===b) return true;
    if(a.length < 4 || b.length < 4) return editDistance(a,b) <= 1;
    return editDistance(a,b) <= 2;
  }
  function keywordScore(rawQuery, keyword){
    const q = cleanQueryForCategory(rawQuery), k = cleanQueryForCategory(keyword);
    if(!q || !k) return 0;
    if(q === k) return 100;
    if(q.includes(k)) return 70 + k.split(/\s+/).length * 5;
    if(k.includes(q)) return 60 + q.split(/\s+/).length * 5;
    const qt = categoryTokens(q), kt = categoryTokens(k);
    if(!qt.length || !kt.length) return 0;
    let hits = 0;
    kt.forEach(w => { if(qt.some(t => wordClose(t,w))) hits++; });
    const coverage = hits / Math.max(kt.length,1);
    return hits ? Math.round(30 + coverage * 45) : 0;
  }
  function makeCollections({singleUrl,newUrl,usedUrl}, condition){
    const out=[];
    const add = (label, url) => {
      if(!url) return;
      const h = canonicalCollectionHandle(url);
      out.push({label:label, collectionHandle:h, collectionUrl:'/collections/' + h});
    };
    if(singleUrl) add('Best', singleUrl);
    else if(condition === 'used' && usedUrl) add('Used', usedUrl);
    else if(condition === 'new' && newUrl) add('New', newUrl);
    else { add('New', newUrl); add('Used', usedUrl); }
    return out;
  }
  function rule(label, title, keywords, urls, selectorHandle, selector={}){
    return {label, title, terms:keywords, keywords, category:selector.category || title, selectorHandle:selectorHandle || '', selectorAllow:selector.allow || [], selectorBlock:selector.block || [], collectionsBase:urls};
  }
  const YF_REFERRING_COLLECTION_RULES = [
    rule('furnace','Furnaces & Replacement Parts',['furnace','furnaces','furnace thermostat','furnace ducting','register','furnace access door','suburban furnace','atwood furnace'],{singleUrl:'/collections/new-used-rv-furnaces-replacement-parts'},'new-used-rv-furnaces-replacement-parts',{category:'Furnace',allow:['furnace','suburban','atwood','nt series','sf series']}),
    rule('refrigerator','Refrigerators & Replacement Parts',['fridge','fridges','refrigerator','refrigerators','refer','cooling unit','fridge roof vent','fridge access door','dometic refrigerator','norcold refrigerator'],{singleUrl:'/collections/new-used-rv-refrigerators-replacement-parts'},'new-used-rv-refrigerators-replacement-parts',{category:'Refrigerator',allow:['refrigerator','dometic','norcold','rm series','ndr']}),
    rule('air-conditioner','Air Conditioners & Replacement Parts',['air conditioner','airconditioner','air conditioners','a/c','ac','shroud','ceiling assembly','ac thermostat','ac ducting','coleman ac','dometic ac'],{singleUrl:'/collections/new-used-rv-air-conditioners-replacement-parts'},'new-used-rv-air-conditioners-replacement-parts',{category:'Air Conditioner',allow:['air conditioner','coleman','dometic','duotherm']}),
    rule('water-heater','Hot Water Heaters',['water heater','waterheater','hot water heater','hot water heaters','water heater door','water heater bypass','anode rod','sw6','gc6','g6a'],{singleUrl:'/collections/new-used-rv-hot-water-heaters'},'new-used-rv-hot-water-heaters',{category:'Water Heater',allow:['water heater','atwood','suburban','gc','sw','g6a']}),
    rule('microwave','Microwaves & Parts',['microwave','microwaves','microwave part'],{singleUrl:'/collections/new-rv-microwaves-parts'},'new-rv-microwaves-parts',{category:'Microwave'}),
    rule('range-oven','Ranges, Ovens & Cooktops',['oven','ovens','stove','stoves','cooktop','range hood','range hood vent','bifold cover','range parts'],{newUrl:'/collections/new-rv-ranges-ovens-range-hoods-replacement-parts',usedUrl:'/collections/used-ovens-ranges-hood-fans-parts'},'new-rv-ranges-ovens-range-hoods-replacement-parts',{category:'Range'}),
    rule('vacuum','RV Vacuum Cleaners & Accessories',['vacuum','central vacuum','vacuum cleaner','vacuum accessory','vacuum parts','dometic vacuum','dirt devil'],{singleUrl:'/collections/rv-vacuum-cleaners-accessories'},'rv-vacuum-cleaners-accessories',{category:'Central Vacuum Systems',allow:['vacuum'],block:['fresh water','waste water','water pump']}),
    rule('washer-dryer','RV Washers & Dryers',['washer','washers','dryer','dryers','washer dryer','washer dryer combo'],{singleUrl:'/collections/rv-washers-dryers'},'rv-washers-dryers',{category:'Washers & Dryers'}),
    rule('fireplace','RV Fireplaces',['fireplace','fireplaces','fire place','fireplace part'],{singleUrl:'/collections/new-used-rv-fireplaces'},'',{}),
    rule('water-pump','Water Pumps & Accessories',['water pump','water pumps','fresh water pump','waste water pump','pump fitting','pump filter','pump parts'],{newUrl:'/collections/pompes-et-accessoires',usedUrl:'/collections/used-water-pumps-parts'},'pompes-et-accessoires',{category:'Pumps',allow:['fresh water','waste water','flojet','jabsco','shurflo','shur flo','remco','thetford','wfco','lippert'],block:['vacuum','central vacuum','dometic vacuum']}),
    rule('fresh-water','Fresh Water Accessories',['water inlet','water fitting','water hose','water filter','water cleaner','fresh water accessory'],{newUrl:'/collections/fresh-water-accessories',usedUrl:'/collections/used-rv-access-hatches-doors'},'',{}),
    rule('water-tank','RV Water & Holding Tanks',['fresh water tank','grey water tank','gray water tank','black water tank','holding tank'],{newUrl:'/collections/fresh-water-tanks',usedUrl:'/collections/used-rv-holding-tanks'},'',{}),
    rule('toilet','RV Toilets & Accessories',['toilet','toilets','toilet part','toilet chemical','toilet paper','thetford toilet','aqua magic'],{newUrl:'/collections/toilets-accessories',usedUrl:'/collections/used-toilets'},'toilets-accessories',{category:'Toilets'}),
    rule('faucet','Faucets & Shower Fixtures',['faucet','faucets','shower head','shower hose','outdoor shower','faucet replacement'],{newUrl:'/collections/faucets-shower-fixtures',usedUrl:'/collections/used-faucets'},'faucets-shower-fixtures',{category:'Faucet'}),
    rule('sewer','Sewer & Sanitation Parts',['sewer','sewer hose','sewer fitting','waste valve','hose support','sewer chemical','sanitation vent','toilet rinser'],{singleUrl:'/collections/sanitation'},'sanitation',{category:'Waste Valve'}),
    rule('bath','Bath Tubs, Showers & Sinks',['bath tub','bathtub','tub surround','sink','sink part','shower surround'],{newUrl:'/collections/new-rv-bath-tubs-showers-sinks',usedUrl:'/collections/used-sinks'},'',{}),
    rule('vent','Vents, Roof Fans & Skylights',['vent','vents','roof vent','roof fan','vent cover','vent lid','skylight','escape hatch','exterior vent','vent installation'],{newUrl:'/collections/ventilation-products',usedUrl:'/collections/used-vents-skylights'},'ventilation-products',{category:'Vents'}),
    rule('roofing','RV Roofing & Sealants',['roofing','roof sealant','sealant','caulking','butyl tape','putty tape','roof product'],{singleUrl:'/collections/rv-roofing-sealants-1'},'',{}),
    rule('maintenance','RV Maintenance Products',['maintenance','rv cleaner','cleaner','protector','slide out conditioner','slide lubricant','underbelly tape','carpet protector','spray paint'],{singleUrl:'/collections/rv-maintenance-products'},'',{}),
    rule('door','RV Doors & Storage Parts',['entry door','rv door','storage door','baggage door','cargo door','door lock','door holder','entry door window'],{newUrl:'/collections/new-rv-doors-storage-parts',usedUrl:'/collections/used-exterior-windows-doors'},'',{}),
    rule('stabilizer','Stabilizers & Landing Gear',['stabilizer','stabilizers','landing gear','jack','jacks','camper jack','wheel chock','leveler','fifth wheel king pin'],{newUrl:'/collections/rv-stabilizers',usedUrl:'/collections/used-stabilizers-landing-gear'},'rv-stabilizers',{category:'Leveling Systems'}),
    rule('step','RV Steps & Parts',['step','steps','electric step','step parts','step accessory'],{newUrl:'/collections/steps',usedUrl:'/collections/used-steps-replacement-parts'},'steps',{category:'Steps'}),
    rule('slide-out','Slide-Out Parts & Accessories',['slide out','slideout','slide motor','slide gear','slide electronics','slide seal','slide moulding','slide extrusion'],{newUrl:'/collections/slide-out-parts-accessories',usedUrl:'/collections/used-slide-parts'},'SLIDEOUTS',{category:'Slideouts'}),
    rule('propane','Propane Parts & Accessories',['propane','propane alarm','smoke detector','carbon monoxide detector','regulator','propane hose','propane fitting','propane tank','propane cover','propane gauge'],{newUrl:'/collections/new-rv-propane-parts-accessories',usedUrl:'/collections/used-propane'},'',{}),
    rule('lighting','RV Lighting',['lighting','light','lights','interior light','exterior light','wall switch','wall receptacle','bulb','marker light','tail light'],{newUrl:'/collections/new-rv-lighting',usedUrl:'/collections/used-rv-lights'},'',{}),
    rule('window','RV Windows',['window','windows','window part','window hardware','blind','blind hardware','curtain hardware'],{newUrl:'/collections/new-rv-windows',usedUrl:'/collections/used-windows'},'',{}),
    rule('cover','RV Covers',['rv cover','tire cover','propane cover','wheel cover'],{singleUrl:'/collections/rv-covers'},'',{}),
    rule('ladder','RV Ladders & Bike Racks',['ladder','ladders','bunk ladder','ladder part','bike rack'],{singleUrl:'/collections/new-rv-ladders-bunk-ladders'},'',{}),
    rule('fender-skirt','Fender Skirts',['fender skirt','wheel skirt'],{singleUrl:'/collections/fender-skirt-replacement-parts'},'',{}),
    rule('moulding','RV Mouldings & Exterior Trim',['vinyl trim','skew cover','screw cover','awning gutter','exterior moulding','moulding','molding'],{singleUrl:'/collections/mouldings'},'',{}),
    rule('cabinet-hardware','Cabinet & Drawer Hardware',['cabinet','cabinet hardware','drawer hardware','bunk bed clamp','interior hinge','interior knob','cupboard hardware'],{newUrl:'/collections/new-rv-drawer-cabinet-hardware',usedUrl:'/collections/used-rv-drawer-cabinet-hardware'},'',{}),
    rule('table','RV Tables & Hardware',['table','table hardware','table base','table leg','table mount'],{newUrl:'/collections/new-rv-tables-hardware',usedUrl:'/collections/used-rv-tables-hardware'},'new-rv-tables-hardware',{category:'Portable Waste Tank',allow:['table'],block:['waste tank']}),
    rule('interior-door','Interior Doors & Hardware',['interior door','closet door','sliding door','fabric door','interior door knob','interior door hardware'],{newUrl:'/collections/new-rv-interior-door-hardware',usedUrl:'/collections/used-rv-interior-doors-hardware'},'',{}),
    rule('kitchen','Kitchen Accessories',['kitchen accessory','kitchen accessories','cuisine'],{singleUrl:'/collections/cuisine'},'',{}),
    rule('converter','Converters & Inverters',['converter','inverter','converter door','power distribution center','breaker','fuse panel'],{newUrl:'/collections/new-rv-converters-inverters',usedUrl:'/collections/used-converters-inverters-parts'},'new-rv-converters-inverters',{category:'Converter'}),
    rule('electrical','Electrical Exterior Accessories',['electrical cord','extension cord','power cord','surge protector','adapter','adaptor','plug cover','outlet box','receptacle','power inlet'],{newUrl:'/collections/rallonges-et-adaptateurs-electriques-pour-vr',usedUrl:'/collections/used-cords-receptacles'},'',{}),
    rule('battery','Battery Accessories',['battery','batteries','battery accessory','battery disconnect'],{newUrl:'/collections/batteries-accessories',usedUrl:'/collections/used-batteries-accessories'},'batteries-accessories',{category:'Battery Disconnect'}),
    rule('solar','Solar Parts',['solar','solar charger','solar panel','charge controller'],{newUrl:'/collections/chargeurs-solaires-et-accessoires',usedUrl:'/collections/used-solar-chargers'},'chargeurs-solaires-et-accessoires',{category:'Solar Panel'}),
    rule('generator','Generators & Parts',['generator','generators','onan','cummins generator'],{singleUrl:'/collections/rv-generators-parts'},'rv-generators-parts',{category:'Generators'}),
    rule('radio','Radios, Antennas & Satellites',['radio','speaker','speakers','antenna','satellite'],{newUrl:'/collections/new-rv-radios-antennas-satellites',usedUrl:'/collections/used-radios-satellites'},'new-rv-radios-antennas-satellites',{category:'Antenna'}),
    rule('tank-monitor','Tank Monitors',['tank monitor','monitor panel'],{newUrl:'/collections/new-rv-tank-monitors',usedUrl:'/collections/used-tank-monitors'},'new-rv-tank-monitors',{category:'Monitor Panel'}),
    rule('awning','Awnings & Replacement Parts',['awning','awnings','awning parts','awning arm','awning hardware','carefree awning','awning replacement parts','awning hardware parts'],{newUrl:'/collections/new-rv-awnings-replacement-parts-accessories',usedUrl:'/collections/used-awnings'},'mouldings',{category:'Awning',allow:['awning','a&e','dometic','carefree','lippert','solera','weather pro','sunchaser','8500','9000','9500','one step','two step']}),
    rule('furniture','RV Furniture',['furniture','chair','chairs','mattress','rv mattress'],{newUrl:'/collections/new-rv-furniture-chairs-mattresses',usedUrl:'/collections/used-rv-furniture'},'',{}),
    rule('camping','Camping Accessories',['camping accessory','camping accessories'],{singleUrl:'/collections/accessoires-de-camping'},'',{}),
    rule('motorhome-body','Motorhome Body Parts',['motorhome body','motorhome part','motorhome parts'],{singleUrl:'/collections/used-rv-motorhome-parts'},'',{}),
    rule('tire-wheel','RV Rims & Tires',['tire','tires','rim','rims','hub cap','hub caps','wheel'],{singleUrl:'/collections/used-rv-rims-tires'},'',{}),
    rule('skirting','RV Skirting & Underbelly',['skirting','underbelly','belly wrap','coroplast','winter skirting','underbelly insulation'],{singleUrl:'/collections/rv-skirting-underbelly'},'',{}),
    rule('access-hatch','RV Access Hatches & Doors',['access hatch','utility hatch','service hatch','water hatch','cable hatch','electrical hatch','access panel'],{newUrl:'/collections/new-rv-access-hatches-doors',usedUrl:'/collections/used-rv-access-hatches-doors'},'',{}),
    rule('exterior-hardware','RV Exterior Hardware',['exterior bracket','mounting bracket','corner bracket','exterior support','exterior hardware'],{singleUrl:'/collections/rv-exterior-hardware'},'',{})
  ];
  function scoreRuleForQuery(rule, q){
    let best = 0;
    (rule.terms || rule.keywords || []).forEach(t => { best = Math.max(best, keywordScore(q,t)); });
    return best;
  }
  function allReferringRulesForQuery(q){
    const condition = detectCondition(q);
    let matches = YF_REFERRING_COLLECTION_RULES.map(r => {
      const score = scoreRuleForQuery(r,q);
      if(score < 40) return null;
      const clone = Object.assign({}, r);
      clone.score = score;
      clone.conditionHint = condition;
      clone.collections = makeCollections(r.collectionsBase || {}, condition).map(c => Object.assign({}, c, {displayName:c.displayName || r.title, categoryGroup:r.category || r.title}));
      return clone;
    }).filter(Boolean).sort((a,b)=>b.score-a.score);

    // V35: if the query clearly matches one curated category (ex: water pump), do not show weak
    // shared-word categories (ex: hot water heater) just because they also contain "water".
    // For mixed intent searches such as "slide out vent", the top scores are close enough to keep both.
    if(matches.length){
      const top = matches[0].score || 0;
      if(top >= 95) matches = matches.filter(m => (m.score || 0) >= 85);
      else if(top >= 75) matches = matches.filter(m => (m.score || 0) >= Math.max(40, top - 20));
    }
    return matches;
  }
  function referringRuleForQuery(q){ return allReferringRulesForQuery(q)[0] || null; }

  function canonicalCollectionHandle(input){
    let h = String(input || '').trim().replace(/^\/collections\//,'').replace(/^https?:\/\/[^/]+\/collections\//,'').replace(/\?.*$/,'').replace(/^\/+|\/+$/g,'');
    if(YF_COLLECTION_ALIASES[h]) h = YF_COLLECTION_ALIASES[h];
    const key = norm(h);
    if(YF_CATEGORY_TO_COLLECTION[key]) h = YF_CATEGORY_TO_COLLECTION[key];
    return h;
  }

  // V49: Only send customers directly to collection URLs that are known canonical Shopify handles.
  // Unknown or guessed handles fall back to Shopify search instead of ever visiting /collections/{guess}.
  const YF_VERIFIED_COLLECTION_HANDLES = new Set([
    'pompes-et-accessoires','used-water-pumps-parts','new-used-rv-hot-water-heaters','new-used-rv-refrigerators-replacement-parts','new-used-rv-furnaces-replacement-parts','new-used-rv-air-conditioners-replacement-parts','new-rv-microwaves-parts','new-rv-ranges-ovens-range-hoods-replacement-parts','used-ovens-ranges-hood-fans-parts','rv-vacuum-cleaners-accessories','rv-washers-dryers','new-used-rv-fireplaces','fresh-water-accessories','used-rv-access-hatches-doors','fresh-water-tanks','used-rv-holding-tanks','toilets-accessories','used-toilets','faucets-shower-fixtures','used-faucets','sanitation','new-rv-bath-tubs-showers-sinks','used-sinks','ventilation-products','used-vents-skylights','rv-roofing-sealants-1','rv-maintenance-products','new-rv-doors-storage-parts','used-exterior-windows-doors','rv-stabilizers','used-stabilizers-landing-gear','steps','used-steps-replacement-parts','slide-out-parts-accessories','used-slide-parts','new-rv-propane-parts-accessories','used-propane','new-rv-lighting','used-rv-lights','new-rv-windows','used-windows','rv-covers','new-rv-ladders-bunk-ladders','fender-skirt-replacement-parts','mouldings','new-rv-drawer-cabinet-hardware','used-rv-drawer-cabinet-hardware','new-rv-tables-hardware','used-rv-tables-hardware','new-rv-interior-door-hardware','used-rv-interior-doors-hardware','cuisine','new-rv-converters-inverters','used-converters-inverters-parts','rallonges-et-adaptateurs-electriques-pour-vr','used-cords-receptacles','batteries-accessories','used-batteries-accessories','chargeurs-solaires-et-accessoires','used-solar-chargers','rv-generators-parts','new-rv-radios-antennas-satellites','used-radios-satellites','new-rv-tank-monitors','used-tank-monitors','new-rv-awnings-replacement-parts-accessories','used-awnings','new-rv-furniture-chairs-mattresses','used-rv-furniture','accessoires-de-camping','used-rv-motorhome-parts','used-rv-rims-tires','rv-skirting-underbelly','new-rv-access-hatches-doors','rv-exterior-hardware'
  ]);
  function verifiedCollectionUrl(handle){
    const h = canonicalCollectionHandle(handle || '');
    return (h && YF_VERIFIED_COLLECTION_HANDLES.has(h)) ? '/collections/' + h : '';
  }

  function collectionHref(c){
    const raw = c && (c.collectionUrl || c.url || c.collectionHandle || c.handle);
    const h = canonicalCollectionHandle(raw);
    const verified = verifiedCollectionUrl(h);
    if(verified) return verified;
    const q = (c && (c.displayName || c.keyword || c.categoryGroup)) || (h ? h.replace(/-/g,' ') : 'rv parts');
    return nativeSearchUrl(q);
  }
  function normalizeCollectionRecord(c){
    if(!c) return null;
    const copy = Object.assign({}, c);
    copy.collectionHandle = canonicalCollectionHandle(copy.collectionHandle || copy.handle || copy.collectionUrl || copy.url || '');
    if(!copy.collectionHandle){
      const key = norm(copy.displayName || copy.keyword || copy.categoryGroup || '');
      copy.collectionHandle = YF_CATEGORY_TO_COLLECTION[key] || '';
    }
    if(copy.collectionHandle) copy.collectionUrl = '/collections/' + copy.collectionHandle;
    return copy;
  }

  function titleFromCollection(c){
    c = normalizeCollectionRecord(c) || {};
    const h = c.collectionHandle || '';
    const special = {
      'new-used-rv-hot-water-heaters':'New & Used RV Hot Water Heaters',
      'new-used-rv-refrigerators-replacement-parts':'New & Used RV Refrigerators & Replacement Parts',
      'new-used-rv-furnaces-replacement-parts':'New & Used RV Furnaces & Replacement Parts',
      'new-rv-air-conditioners-replacement-parts':'New RV Air Conditioners & Replacement Parts',
      'new-rv-awnings-replacement-parts-accessories':'New RV Awnings, Replacement Parts & Accessories',
      'pompes-et-accessoires':'Pumps & Accessories',
      'used-water-pumps-parts':'Used RV Water Pumps & Parts',
      'used-rv-rims-tires':'RV Rims & Tires',
      'rv-covers':'RV Covers',
      'rv-vacuum-cleaners-accessories':'RV Vacuum Cleaners & Accessories',
      'new-rv-ladders-bunk-ladders':'New RV Ladders & Bunk Ladders'
    };
    if(special[h]) return special[h];
    if(c.displayName && !/^[a-z_]+$/.test(String(c.displayName))) return c.displayName;
    return (h || c.displayName || c.keyword || 'Recommended Collection').replace(/-/g,' ').replace(/\bnew used\b/i,'New & Used').replace(/\brv\b/ig,'RV').replace(/\b\w/g,m=>m.toUpperCase());
  }
  async function primaryCollection(q, model, part){
    // V34: use the curated/referring-links category engine before the old static collection index.
    // This catches fuzzy category searches like ladder, ladders, water pups, water pumps, etc.
    if(!model && !part){
      const r = referringRuleForQuery(q);
      if(r && r.collections && r.collections.length) return normalizeCollectionRecord(r.collections[0]);
    }
    if(model){
      if(model.newCol) return normalizeCollectionRecord({displayName:model.colName || cleanCategoryName(model.c) || 'Recommended Collection', collectionHandle:model.newCol, categoryGroup:model.c || model.af || ''});
      if(model.usedCol) return normalizeCollectionRecord({displayName:model.colName || cleanCategoryName(model.c) || 'Recommended Collection', collectionHandle:model.usedCol, categoryGroup:model.c || model.af || ''});
    }
    if(part){
      for(const u of ((part.used) || []).slice(0,20)){ const m = await db.model(u && u[0]); const c = await primaryCollection(q, m, null); if(c) return c; }
    }
    const col = await db.collection(); const k = norm(q); let best = null, bestScore = 0;
    Object.keys(col).forEach(key => { const c = col[key]; const hay = key + ' ' + norm(c.keyword) + ' ' + norm(c.displayName) + ' ' + (c.synonyms || []).map(norm).join(' '); let score = 0; if(hay.includes(k) || k.includes(key)) score = Math.max(key.length, k.length); if(score > bestScore && c.collectionHandle){ best = normalizeCollectionRecord(c); bestScore = score; } });
    return best;
  }

  function friendlyDiagramTitle(d, model){
    const b = (d && d.b) || (model && model.b) || ''; const m = (d && d.m) || (model && model.m) || '';
    let t = [b, m].filter(Boolean).join(' ');
    if(!t) t = 'Breakdown Diagram'; else t += ' Breakdown Diagram';
    if(d && d.s) t += ' · Serial ' + d.s;
    return t;
  }
  function diagramSubtext(d){ return [(d && d.c) ? cleanCategoryName(d.c) : '', (d && d.s) ? 'Serial ' + d.s : 'All serials / no serial split'].filter(Boolean).join(' • '); }
  function diagramThumb(d, alt){ return d && d.url ? '<div class="yf-diagram-thumb"><img loading="lazy" src="'+esc(d.url)+'" alt="'+esc(alt || 'Breakdown diagram')+'"></div>' : '<div class="yf-diagram-thumb empty">Diagram</div>'; }

  function serialMatches(a,b){
    const aa = norm(a), bb = norm(b);
    if(!bb) return true;
    if(!aa) return false;
    // V54: Serial filters must be exact after normalization.
    // Selecting N611 must not include N611C, N611F, N611V, etc.
    // The old contains-based match was only helpful for loose searching, but
    // selected serial/production range pages must show that exact serial only.
    return aa === bb;
  }
  function isPlaceholderDiagram(d){
    const hay = String((d && (d.bn || d.img || d.url || d.id)) || '').toLowerCase();
    return hay.includes('dinologo') || hay.includes('placeholder') || hay.includes('no-image');
  }
  function displayDiagrams(diagrams){
    // V29: Do not drop DinoLogo/secondary diagram records.
    // Some models use those records as legitimate individual breakdowns,
    // so the customer must see every diagram connected to the model/serial.
    return (diagrams || []).filter(Boolean);
  }
  function diagramsForModel(model, serial){
    let diagrams = (model && (model._allDiagrams || model.diagrams) || []);
    if(serial) diagrams = diagrams.filter(d => serialMatches(d && d.s, serial));
    return displayDiagrams(diagrams);
  }
  function breakdownDisplayName(d, model, index){
    const n = Number.isFinite(index) ? (index + 1) : 1;
    return 'Breakdown ' + n;
  }
  function diagramCard(d, model, index, currentId){
    const name = breakdownDisplayName(d, model, index);
    const active = currentId && d && d.id === currentId ? ' active' : '';
    const serial = d && d.s ? 'Serial ' + d.s : 'All serials';
    return '<a class="yf-diagram-preview yf-diagram-preview-compact'+active+'" href="'+diagramUrl(d.id)+'">'
      + diagramThumb(d, name)
      + '<div class="yf-diagram-copy"><strong>'+esc(name)+'</strong><span>'+esc(serial)+'</span></div></a>';
  }
  function diagramGrid(diagrams, model, empty, currentId){
    diagrams = diagrams || [];
    if(!diagrams.length) return '<div class="yf-empty-state">'+esc(empty || 'No breakdown diagrams found.')+'</div>';
    return '<div class="yf-diagram-row all">'+diagrams.map((d,i)=>diagramCard(d,model,i,currentId)).join('')+'</div>';
  }
  function partNumbersFromDiagrams(diagrams){
    const seen = new Set(), out = [];
    (diagrams || []).forEach(d => (d.parts || []).forEach(x => {
      const pn = x && x[1]; const k = norm(pn);
      if(k && !seen.has(k)){ seen.add(k); out.push(pn); }
    }));
    return out;
  }

  function productCard(p, opts={}){
    const handle = p.handle || ''; const url = p.url || ('/products/' + handle);
    const badge = opts.badge || p._label || '';
    const condition = opts.showCondition ? yfPartInfoCondition(p) : '';
    return '<a class="yf-product-card yf-product-card-clickable" data-yf-product-card data-handle="'+esc(handle)+'" href="'+esc(url)+'" aria-label="View '+esc(p.title || 'product')+'">'
      + '<div class="yf-product-image" data-yf-product-img>' + (p.imageUrl ? '<img loading="lazy" src="'+esc(p.imageUrl)+'" alt="'+esc(p.title||'Product image')+'">' : '<span>No image</span>') + '</div>'
      + '<div class="yf-product-body">'
      + '<div class="yf-product-badge-row">'
      + (badge ? '<span class="yf-product-badge '+esc(opts.badgeClass || p._klass || '')+'">'+esc(badge)+'</span>' : '')
      + (condition ? '<span class="yf-product-condition-badge '+(condition === 'Used' ? 'used' : 'new')+'">'+esc(condition)+'</span>' : '')
      + '</div>'
      + '<h3>'+esc(p.title || handle || 'Product')+'</h3>'
      + '<div class="yf-chip-row">' + (p.partNumber ? '<span>Part '+esc(p.partNumber)+'</span>' : '') + (opts.matchedPart || p._matchedPart ? '<span>Matched '+esc(opts.matchedPart || p._matchedPart)+'</span>' : '') + '</div>'
      + '<div class="yf-price-row"><strong data-yf-product-price>'+esc(money(p.price||''))+'</strong><small data-yf-product-compare>' + (p.compareAtPrice && Number(p.compareAtPrice) > Number(p.price) ? '<s>'+esc(money(p.compareAtPrice))+'</s>' : '') + '</small></div>'
      + '<div class="yf-stock" data-yf-product-availability>In stock</div>'
      + '<div class="yf-card-actions"><span class="yf-btn">View Product</span></div>'
      + '</div></a>';
  }

  async function hydrateProducts(scope){
    const cards = [...scope.querySelectorAll('[data-yf-product-card]')].slice(0,120);
    await mapLimit(cards, 8, async card => {
      const handle = card.getAttribute('data-handle'); if(!handle || card.dataset.hydrated) return; card.dataset.hydrated = '1';
      const j = await shopifyProduct(handle); if(!j) return;
      const img = card.querySelector('[data-yf-product-img]'); const src = productImage(j); if(img && src) img.innerHTML = '<img loading="lazy" src="'+esc(src)+'" alt="'+esc(j.title||'Product image')+'">';
      const v = bestVariant(j);
      const price = card.querySelector('[data-yf-product-price]'); if(price && v && v.price != null) price.textContent = money(v.price);
      const compare = card.querySelector('[data-yf-product-compare]'); if(compare && v && v.compare_at_price && v.compare_at_price > v.price) compare.innerHTML = '<s>'+esc(money(v.compare_at_price))+'</s>';
      const avail = card.querySelector('[data-yf-product-availability]'); if(avail && v){ avail.textContent = v.available ? 'In stock' : 'Out of stock'; avail.classList.toggle('red', !v.available); }
    });
  }

  function collectionCard(c, label){
    c = normalizeCollectionRecord(c) || {};
    const url = collectionHref(c); const title = titleFromCollection(c); const group = cleanCategoryName(c.categoryGroup || c.displayName || c.keyword || '');
    const kicker = label || c.label || 'Best collection';
    const img = c.imageUrl || c.image || (c.featuredImage && c.featuredImage.url) || '';
    // V41: The actual href is intentionally safe Shopify search. JS resolves to the real
    // collection URL on click. If JS fails/caches, the customer still never lands on a 404.
    const safeHref = verifiedCollectionUrl(c.collectionHandle) || nativeSearchUrl(title || group || 'rv parts');
    return '<a class="yf-collection-card" data-yf-collection-card data-handle="'+esc(c.collectionHandle||'')+'" data-fallback-q="'+esc(title || group || 'rv parts')+'" href="'+esc(safeHref)+'">'
      + '<div class="yf-collection-img" data-yf-collection-img>'+(img ? '<img loading="lazy" src="'+esc(img)+'" alt="'+esc(title)+'">' : '<span>Collection</span>')+'</div><div class="yf-collection-copy"><div class="yf-kicker">'+esc(kicker)+'</div><h3>'+esc(title)+'</h3>' + (group ? '<p>'+esc(group)+'</p>' : '') + '</div></a>';
  }
  async function hydrateCollectionCards(scope){
    const cards = [...scope.querySelectorAll('[data-yf-collection-card]')];
    await mapLimit(cards, 4, async card => {
      if(card.dataset.collectionImgHydrated) return;
      const h = card.getAttribute('data-handle');
      const img = await collectionImage(h);
      const box = card.querySelector('[data-yf-collection-img]');
      if(box && img) box.innerHTML = '<img loading="lazy" src="'+esc(img)+'" alt="Collection image">';
      card.dataset.collectionImgHydrated = '1';
    });
  }


  function collectionResultsFromSuggest(j){
    const r = j && j.resources && j.resources.results;
    return (r && (r.collections || r.collection)) || [];
  }
  async function resolveCollectionUrl(handle, fallbackQ){
    const h = canonicalCollectionHandle(handle || '');

    // V49: If the handle is in our verified canonical list, go directly there.
    // If it is not verified, never visit /collections/{guess}; use Shopify suggestions or search.
    const verified = verifiedCollectionUrl(h);
    if(verified) return verified;

    const qList = [];
    if(fallbackQ) qList.push(fallbackQ);
    if(h) qList.push(h.replace(/-/g,' '));
    for(const q of qList){
      try{
        const r = await fetch('/search/suggest.json?q=' + enc(q) + '&resources[type]=collection&resources[limit]=10', {credentials:'same-origin'});
        if(!r.ok) continue;
        const j = await r.json();
        const cols = collectionResultsFromSuggest(j);
        if(cols && cols.length){
          const nq = norm(q);
          const best = cols.find(c => c && c.url && norm(c.title || '') === nq)
            || cols.find(c => c && c.url && (norm(c.title || '').includes(nq) || nq.includes(norm(c.title || ''))))
            || cols[0];
          if(best && best.url) return best.url;
        }
      }catch(e){}
    }

    // Do not fall back to unverified /collections/{handle}; that was the 404 source.
    return nativeSearchUrl(fallbackQ || (h ? h.replace(/-/g,' ') : 'rv parts'));
  }
  async function initCollectionLinkSafety(scope){
    scope.querySelectorAll('[data-yf-collection-card]').forEach(card => {
      if(card.dataset.collectionSafeBound) return;
      card.dataset.collectionSafeBound = '1';
      card.addEventListener('click', async function(e){
        const href = card.getAttribute('href') || '';
        const h = canonicalCollectionHandle(card.getAttribute('data-handle') || '');
        if(!h) return;
        e.preventDefault();
        const title = card.getAttribute('data-fallback-q') || (card.querySelector('h3') && card.querySelector('h3').textContent) || h.replace(/-/g,' ');
        location.href = await resolveCollectionUrl(h, title);
      });
    });
  }


  function collectionsFromRule(rule){
    return (rule && rule.collections ? rule.collections : []).map(normalizeCollectionRecord).filter(Boolean);
  }
  async function collectionsForQuery(q, model, part, primary){
    if(model || part) return primary ? [normalizeCollectionRecord(primary)] : [];
    const rules = allReferringRulesForQuery(q).slice(0,4);
    if(rules.length){
      const out=[], seen=new Set();
      rules.forEach(rule => collectionsFromRule(rule).forEach(c => {
        const h = canonicalCollectionHandle(c && c.collectionHandle);
        if(h && !seen.has(h)){ seen.add(h); out.push(c); }
      }));
      return out;
    }
    return primary ? [normalizeCollectionRecord(primary)] : [];
  }
  async function categoryInfoForSearch(q, collections){
    const idx = await db.categoryModels();
    const rule = referringRuleForQuery(q);
    if(rule && rule.selectorHandle){
      const h = canonicalCollectionHandle(rule.selectorHandle);
      if(idx[h]) return Object.assign({}, idx[h], {_yfRuleLabel:rule.label});
    }
    const handles = (collections || []).map(c => canonicalCollectionHandle(c && c.collectionHandle)).filter(Boolean);
    for(const h of handles){ if(idx[h]) return idx[h]; }
    // If a curated category was found but does not have a trusted selector handle, do not guess a selector from a broad category.
    // This prevents categories such as mouldings from accidentally showing awning breakdowns.
    if(rule) return null;
    const nq = norm(q);
    const values = Object.values(idx || {});
    let best = null, bestScore = 0;
    for(const c of values){
      const hay = [c.collectionHandle, c.displayName, c.category].map(norm).join(' ');
      let score = 0;
      if(nq && (hay.includes(nq) || nq.includes(norm(c.displayName || c.category || '')))) score += 30;
      if(score > bestScore){ best = c; bestScore = score; }
    }
    return bestScore >= 30 ? best : null;
  }
  function categoryCollectionsPanel(collections){
    if(!collections || !collections.length) return '';
    const cards = collections.map(c => collectionCard(c, c.label || (collections.length > 1 ? 'Collection' : 'Best collection'))).join('');
    return '<section class="yf-panel yf-category-collections"><div class="yf-panel-head"><div><h2>Browse collections</h2></div><strong>'+esc(collections.length)+'</strong></div><div class="yf-collection-grid">'+cards+'</div></section>';
  }
  function suggestedCollectionsPanel(collections, title, copy){
    collections = (collections || []).map(normalizeCollectionRecord).filter(Boolean);
    if(!collections.length) return '';
    const seen = new Set();
    collections = collections.filter(c => { const h = canonicalCollectionHandle(c.collectionHandle); if(!h || seen.has(h)) return false; seen.add(h); return true; });
    if(!collections.length) return '';
    return '<section class="yf-panel yf-suggested-collections"><div class="yf-panel-head"><div><h2>'+esc(title || 'Recommended collections')+'</h2>'+(copy?'<p>'+esc(copy)+'</p>':'')+'</div><strong>'+esc(collections.length)+'</strong></div><div class="yf-collection-grid">'+collections.map(c => collectionCard(c, c.label || 'Recommended')).join('')+'</div></section>';
  }
  function categorySearchIntro(q, rule, collections){
    const title = (rule && rule.title) || (collections && collections[0] && titleFromCollection(collections[0])) || cleanCategoryName(q);
    return '<section class="yf-match-hero yf-category-hero"><div><div class="yf-kicker">Category match</div><h2>'+esc(title)+'</h2><p>Browse matching collections, or choose your manufacturer and model to find the exact breakdown diagrams.</p></div></section>';
  }
  function categorySelectorShell(c, q){
    if(!c) return '';
    return '<div data-yf-category-widget data-collection-handle="'+esc(c.collectionHandle || '')+'" data-collection-title="'+esc(c.displayName || c.category || '')+'" data-category-query="'+esc(q || '')+'"></div>';
  }


  function queryMatchCandidates(q){
    const raw = String(q || '').toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim();
    const words = raw ? raw.split(/\s+/).filter(Boolean) : [];
    const candidates = [];
    const add = v => { const k = norm(v); if(k && k.length >= 2 && !candidates.includes(k)) candidates.push(k); };
    add(q);
    words.forEach(add);
    // Adjacent combinations catch model numbers typed with spaces, like G6A 8E, RM 2652, SW 6D.
    for(let i=0;i<words.length;i++){
      add(words[i] + (words[i+1] || ''));
      add(words[i] + (words[i+1] || '') + (words[i+2] || ''));
    }
    return candidates.sort((a,b) => b.length - a.length);
  }
  function partOrModelCandidateTokens(q){
    // V37: a database model/part match must contain a number. This prevents plain category words
    // such as "window" from matching model names like "Window Awning", while still allowing
    // embedded searches such as "suburban sw6d" to resolve to SW6D.
    return queryMatchCandidates(q).filter(x => /[0-9]/.test(x));
  }
  function shouldPreferPartMatch(q, part, model, force){
    if(force === 'part') return !!part;
    if(force === 'model') return false;
    if(!part) return false;
    if(!model) return true;
    const pn = norm(part.p || '');
    const mn = norm(model.m || model.n || '');
    const tokens = partOrModelCandidateTokens(q);
    // If the customer typed/clicked an exact part number, never let a broader model prefix
    // or nearby model like 9093100 steal the page. This fixes part dropdown clicks such as 93100.
    if(tokens.includes(pn)) return true;
    if(tokens.includes(mn)) return false;
    // Numeric-only searches are normally part-number intent unless a model is an exact match.
    if(tokens.some(t => /^[0-9]+$/.test(t) && pn.startsWith(t))) return true;
    return false;
  }
  async function bestPartForQuery(q){
    const candidates = partOrModelCandidateTokens(q);
    if(!candidates.length) return null;
    for(const c of candidates){
      const p = await db.part(c);
      if(p) return p;
    }
    // Last resort: only use prefix search on numeric-bearing tokens, never plain words.
    for(const c of candidates.filter(x => x.length >= 4)){
      const list = await db.searchPrefix('part', c, 3);
      if(list && list.length) return list.find(p => norm(p.p || '').startsWith(c)) || list[0];
    }
    return null;
  }
  function cleanManufacturerLabel(v){
    let s = String(v || '').replace(/\u00a0/g,' ').replace(/\s+/g,' ').trim();
    // Strip known series suffixes from brand label only.
    s = s.replace(/\s+(SF|NT|DD|SH|P|RM|CF|VG|SW)\s+Series$/i,'').trim();
    return s;
  }
  async function modelFromCategorySelectorToken(q, opts){
    opts = opts || {};
    const candidates = opts.allowTextModels ? queryMatchCandidates(q).filter(x => x.length >= 3) : partOrModelCandidateTokens(q);
    if(!candidates.length) return null;
    const idx = await db.categoryModels();
    const exact = new Set(candidates.map(norm));
    let fallback = null;
    for(const col of Object.values(idx || {})){
      const category = col && (col.category || col.displayName || '');
      const mans = (col && col.manufacturers) || {};
      for(const [manufacturerRaw, man] of Object.entries(mans)){
        const manufacturer = cleanManufacturerLabel(manufacturerRaw);
        const series = (man && man.series) || {};
        for(const [seriesKey, models] of Object.entries(series)){
          for(const m of (models || [])){
            const modelNumber = m && (m.modelNumber || m.m || '');
            const modelNorm = norm(m && (m.normalized || modelNumber || seriesKey));
            if(exact.has(modelNorm)){
              return {m:modelNumber, n:modelNorm, b:manufacturerRaw, c:category, af:category, _lookupModelKey:modelNorm, _seriesKey:seriesKey};
            }
            for(const serial of (m.serials || [])){
              const sn = norm(serial);
              if(exact.has(sn)){
                return {m:serial, n:sn, b:manufacturerRaw, c:category, af:category, _lookupModelKey:modelNorm || norm(seriesKey), _seriesKey:seriesKey, _serial:serial, _fromSerial:true};
              }
              // Prefix fallback for common furnace formats like SF20 typed against SF20F/SF20Q, but only after exact checks.
              if(!fallback && candidates.some(c => c.length >= 4 && sn.startsWith(c))){
                fallback = {m:serial, n:sn, b:manufacturerRaw, c:category, af:category, _lookupModelKey:modelNorm || norm(seriesKey), _seriesKey:seriesKey, _serial:serial, _fromSerial:true};
              }
            }
          }
        }
        // Some categories also have a flat models list.
        for(const m of ((man && man.models) || [])){
          const modelNumber = m && (m.modelNumber || m.m || '');
          const modelNorm = norm(m && (m.normalized || modelNumber));
          if(exact.has(modelNorm)) return {m:modelNumber, n:modelNorm, b:manufacturerRaw, c:category, af:category, _lookupModelKey:modelNorm};
          for(const serial of (m.serials || [])){
            const sn = norm(serial);
            if(exact.has(sn)) return {m:serial, n:sn, b:manufacturerRaw, c:category, af:category, _lookupModelKey:modelNorm, _serial:serial, _fromSerial:true};
          }
        }
      }
    }
    return fallback;
  }
  function modelContextText(model){
    return String([
      model && model.m,
      model && model.n,
      model && model.b,
      model && model.c,
      model && model.af,
      model && model.colName,
      model && model.newCol,
      model && model.usedCol
    ].filter(Boolean).join(' ')).toLowerCase().replace(/[^a-z0-9]+/g, ' ');
  }
  function modelContextScore(model, q, candidate, exact){
    const query = String(q || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const words = query ? query.split(/\s+/).filter(w => w.length >= 3 && !/^\d+$/.test(w)) : [];
    const hay = modelContextText(model);
    let score = exact ? 100 : 35;
    const mn = norm(model && (model.m || model.n || ''));
    if(mn === candidate) score += 50;
    else if(candidate && mn.startsWith(candidate)) score += 12;

    // Context words matter a lot when a short numeric model is shared by different brands/categories.
    // Example: "Dometic 310 toilet" should choose the Dometic/Sealand toilet model, not HWH 310.
    words.forEach(w => { if(hay.includes(w)) score += 45; });
    if(/\bdometic\b/.test(query) && /\bdometic\b/.test(hay)) score += 90;
    if(/\bsealand\b/.test(query) && /\bsealand\b/.test(hay)) score += 90;
    if(/\btoilets?\b/.test(query) && /\btoilets?\b/.test(hay)) score += 110;
    if(/\bhwh\b/.test(query) && /\bhwh\b/.test(hay)) score += 110;
    if(/\blevel(?:ing)?\b|\bstabilizers?\b/.test(query) && /\blevel(?:ing)?\b|\bstabilizers?\b/.test(hay)) score += 90;
    return score;
  }
  async function bestModelForQuery(q, opts){
    opts = opts || {};
    const exactKey = norm(opts.exactKey || '');
    const candidates = opts.allowTextModels ? queryMatchCandidates(q).filter(x => x.length >= 3) : partOrModelCandidateTokens(q);
    if(exactKey && !candidates.includes(exactKey)) candidates.unshift(exactKey);
    if(!candidates.length) return null;

    const found = [];
    const seen = new Set();
    function addModel(model, candidate, exact){
      if(!model) return;
      const key = norm(model.m || model.n || '') + '|' + norm(model.b || '') + '|' + norm(model.c || '');
      if(seen.has(key)) return;
      seen.add(key);
      found.push({model, candidate, exact});
    }

    // Collect exact and nearby prefix matches before choosing. A plain "310" can still pick the
    // exact HWH model, but "Dometic 310 toilet" now uses the Dometic/toilet words to choose 310S.
    for(const c of candidates){
      const ch = await db.load('model', bucket(c));
      Object.keys(ch || {}).forEach(key => {
        if(key === c) addModel(ch[key], c, true);
        else if(c.length >= 3 && key.startsWith(c)) addModel(ch[key], c, false);
      });
    }

    // Also search the category selector index. Some Suburban furnace models such as SF20/SF20F
    // are stored as serial/model variants under "SF Series" rather than as standalone model rows.
    const selectorModel = await modelFromCategorySelectorToken(q, opts);
    if(selectorModel) addModel(selectorModel, norm(selectorModel.n || selectorModel.m || ''), true);

    if(found.length){
      const scoreQuery = opts.contextQuery || q;
      found.sort((a,b) => modelContextScore(b.model, scoreQuery, b.candidate, b.exact) - modelContextScore(a.model, scoreQuery, a.candidate, a.exact));
      return found[0].model;
    }
    return null;
  }
  function modelSerialGroups(model){
    const groups = {}; displayDiagrams(model && (model._allDiagrams || model.diagrams) || []).forEach(d => { const s = String(d.s || '').trim(); if(!s) return; (groups[s] || (groups[s] = [])).push(d); });
    return Object.keys(groups).sort().map(s => ({serial:s, diagrams:groups[s]}));
  }
  function modelHasSerialHierarchy(model){ return modelSerialGroups(model).length > 1; }
  function serialPickerHtml(model){
    const groups = modelSerialGroups(model);
    if(!groups.length) return '';
    const id = 'yf-serial-' + norm(model.m);
    return '<section class="yf-step-card" data-yf-serial-picker data-model="'+esc(model.m)+'"><div class="yf-step-number">1</div><div class="yf-step-content"><h2>Choose your serial number first</h2><p>Different serial ranges can use different parts. Pick the serial from the appliance label so we only show the correct diagrams and products.</p><label class="yf-select-label" for="'+esc(id)+'">Serial number</label><div class="yf-serial-controls"><select id="'+esc(id)+'" data-yf-serial-select><option value="">Select serial number</option>'+groups.map(g => '<option value="'+esc(g.serial)+'">'+esc(g.serial)+'</option>').join('')+'</select><button type="button" class="yf-btn" data-yf-serial-go disabled>Show correct parts</button></div></div></section>';
  }
  function initSerialSelectors(scope){
    scope.querySelectorAll('[data-yf-serial-picker]').forEach(box => {
      if(box.dataset.bound) return;
      box.dataset.bound = '1';
      const sel = box.querySelector('[data-yf-serial-select]');
      const btn = box.querySelector('[data-yf-serial-go]');
      const model = box.getAttribute('data-model') || '';
      const go = () => {
        const serial = sel && sel.value;
        if(!serial) return;
        location.assign(modelBreakdownUrl(model, serial));
      };
      if(sel && btn){
        sel.addEventListener('change', () => { btn.disabled = !sel.value; });
        btn.addEventListener('click', go);
      }
    });
  }

  function stat(value, label, tone){
    let safeValue;
    if(value && value.__html){ safeValue = value.__html; }
    else safeValue = esc(value == null || value === '' ? '—' : value);
    return '<div class="yf-stat '+(tone||'')+'"><strong>'+safeValue+'</strong><span>'+esc(label)+'</span></div>';
  }
  function modelDatabasePartCount(model){
    const seen = new Set();
    function add(v){ const k = norm(v); if(k) seen.add(k); }
    (model && model.parts || []).forEach(add);
    const diagrams = (model && (model._fullDiagrams || model._allDiagrams || model.diagrams)) || [];
    (diagrams || []).forEach(d => {
      (d && d.parts || []).forEach(row => {
        if(Array.isArray(row)) add(row[1]);
        else if(row && typeof row === 'object') add(row.partNumber || row.p || row.mfg_part_no);
      });
    });
    return seen.size || ((model && model.parts || []).length);
  }
  function modelIntro(model, serialAware){
    const brand = model && model.b ? brandLabelFromRoot(model.b) : '';
    const cat = cleanCategoryName(model && model.c);
    const diagrams = diagramsForModel(model);
    return '<section class="yf-match-hero yf-match-hero--model-no-stats"><div><div class="yf-kicker">'+(serialAware?'Serial-aware model match':'Model match')+'</div><h2>'+esc(model.m)+'</h2>'
      + (brand ? '<div class="yf-match-brand">'+esc(brand)+'</div>' : '')
      + '<p>'+esc(cat || '')+'</p></div></section>';
  }
  function partIntro(part, chain, productCount, brandLabel){
    return '<section class="yf-match-hero"><div><div class="yf-kicker">Part number match</div><h2>'+esc(part.p)+'</h2>'
      + (brandLabel ? '<div class="yf-match-brand">'+esc(brandLabel)+'</div>' : '')
      + '<p>'+esc(part.d || '')+'</p></div><div class="yf-match-stats">'
      + stat(part.fits || (part.used||[]).length || 0, 'fits models', 'green')
      + stat(productCount && productCount.__html ? productCount : productCount, 'available products', 'red')
      + '</div></section>';
  }
  function supersessionBanner(partNumber, chain, opts){
    if(!chain) return '';
    opts = opts || {};
    const current = norm(chain.current || partNumber);
    const searched = norm(partNumber);
    const newPart = current || searched;
    const oldSet = new Set();
    const addOld = v => { const k = norm(v); if(k && k !== newPart) oldSet.add(k); };
    if(searched && searched !== newPart) oldSet.add(searched);
    (chain.reverse || []).forEach(addOld);
    if(!oldSet.size && !(chain.forward && chain.forward.length) && !(chain.reverse && chain.reverse.length)) return '';
    const oldNums = Array.from(oldSet);
    const title = opts.title || 'Part Number Information';
    const icon = '<span class="yf-supersession-icon" aria-hidden="true">i</span>';
    return '<div class="yf-supersession-card '+(opts.compact?'compact':'')+'">'
      + '<div class="yf-supersession-title">'+icon+'<strong>'+esc(title)+'</strong></div>'
      + '<div class="yf-supersession-row"><span>New Part Number:</span><b>'+esc(newPart || partNumber)+'</b></div>'
      + (oldNums.length ? '<div class="yf-supersession-row"><span>Old Part Numbers:</span><div class="yf-supersession-pills">'+oldNums.map(n => '<em>'+esc(n)+'</em>').join('')+'</div></div>' : '')
      + '</div>';
  }
  function productConditionLabel(p){
    const t = plain([p && p.title, p && p.vendor, p && p.productType].filter(Boolean).join(' '));
    if(/\bUSED\b/.test(t)) return 'Used';
    if(/\bNEW\b/.test(t)) return 'New';
    return '';
  }
  function productVariantUrl(p){
    const h = p && p.handle;
    if(!h) return (p && p.url) || '#';
    const vid = variantIdFromProduct(p, null);
    return (p.url && String(p.url).includes('/products/')) ? p.url : ('/products/' + h + (vid ? '?variant=' + enc(vid) : ''));
  }
  function skuMetaRow(label, value, copyable){
    const safe = value == null || value === '' ? 'N/A' : value;
    return '<div class="yf-sku-meta-row"><span>'+esc(label)+':</span><strong>'+esc(safe)+'</strong>'+(copyable && safe !== 'N/A' ? '<button class="yf-copy-mini" type="button" data-yf-copy="'+esc(safe)+'" aria-label="Copy '+esc(label)+'">⧉</button>' : '')+'</div>';
  }
  function skuProductHeroCard(p){
    const url = productVariantUrl(p);
    const condition = productConditionLabel(p);
    const stock = p && p.available === false ? 'Out of Stock' : 'In Stock';
    const inventory = p && p.inventory != null && p.inventory !== '' ? (String(p.inventory) + ' units') : (p && p.available === false ? '0 units' : 'Available');
    return '<article class="yf-sku-product-detail">'
      + '<div class="yf-sku-product-head"><div><h3>'+esc((p && p.title) || 'Matching product')+'</h3><div class="yf-sku-badges"><span class="yf-sku-stock '+(stock === 'In Stock' ? 'green' : 'red')+'">'+esc(stock)+'</span>'+(condition ? '<span class="yf-sku-condition">'+esc(condition)+'</span>' : '')+'</div></div>'
      + '<div class="yf-sku-product-img">'+(p && p.imageUrl ? '<img loading="lazy" src="'+esc(p.imageUrl)+'" alt="'+esc(p.title || 'Product image')+'">' : '<span>No image</span>')+'</div></div>'
      + '<div class="yf-sku-price-grid"><div><span>Price:</span><strong class="yf-sku-price">'+esc(money(p && p.price || ''))+'</strong>'+(p && p.compareAtPrice && Number(p.compareAtPrice) > Number(p.price) ? '<small><s>'+esc(money(p.compareAtPrice))+'</s></small>' : '')+'</div><div><span>Inventory:</span><strong>'+esc(inventory)+'</strong></div></div>'
      + '<div class="yf-sku-meta">'
      + skuMetaRow('SKU', p && p.sku, true)
      + skuMetaRow('Part Number', p && p.partNumber, true)
      + skuMetaRow('Model Number', p && (p.modelNumber || p.model || ''), false)
      + skuMetaRow('Location', p && (p.location || 'Alberta - Pickup & Shipping'), false)
      + '</div><a class="yf-btn yf-sku-view-product" href="'+esc(url)+'">View Product ↗</a></article>';
  }
  async function skuBreakdownListFromPart(part){
    const used = (part && part.used || []).slice(0,24);
    const seen = new Set(), items = [];
    for(const u of used){
      const did = u && u[2];
      if(!did || seen.has(did)) continue;
      seen.add(did);
      const d = await db.diagram(did);
      if(d) items.push(d);
      if(items.length >= 8) break;
    }
    return items;
  }
  function skuSidePanel(title, count, body){
    return '<section class="yf-sku-side-panel"><div class="yf-sku-side-head"><strong>'+esc(title)+' ('+esc(count)+')</strong><span>⌃</span></div>'+body+'</section>';
  }
  function skuCompatibleModelsPanel(part){
    const seen = new Set();
    const models = (part && part.used || []).filter(u => { const k = norm(u && u[0]); if(!k || seen.has(k)) return false; seen.add(k); return true; });
    const body = models.length ? '<div class="yf-sku-model-scroll">'+models.slice(0,60).map(u => '<a href="'+nativeModelSearchUrl(u)+'">'+esc(u[0])+'</a>').join('')+'</div>' : '<div class="yf-sku-empty">No compatible models found.</div>';
    return skuSidePanel('Compatible Models', models.length, body);
  }
  function skuBreakdownsPanel(diagrams){
    diagrams = diagrams || [];
    const body = diagrams.length ? '<div class="yf-sku-list">'+diagrams.map(d => '<a href="'+diagramUrl(d.id)+'"><strong>'+esc(friendlyDiagramTitle(d,null).replace(/ Breakdown Diagram$/,''))+'</strong><span>'+esc([cleanCategoryName(d.c), d.m].filter(Boolean).join(' | '))+'</span></a>').join('')+'</div>' : '<div class="yf-sku-empty">No breakdown diagrams found.</div>';
    return skuSidePanel('Breakdown Diagrams', diagrams.length, body);
  }
  function skuRelatedProductsPanel(products){
    products = products || [];
    const body = products.length ? '<div class="yf-sku-list yf-sku-related">'+products.map(p => '<a href="'+esc(productVariantUrl(p))+'"><strong>'+esc(p.title || 'Related product')+'</strong><span>'+esc(p.partNumber || 'N/A')+'</span><em>'+esc(money(p.price || ''))+'</em></a>').join('')+'</div>' : '<div class="yf-sku-empty">No related products found.</div>';
    return skuSidePanel('Related Products', products.length, body);
  }


  function yfPartInfoCondition(p){
    const explicit = String((p && (p.condition || p.customCondition || p._condition)) || '').trim();
    if(/^used$/i.test(explicit)) return 'Used';
    if(/^new$/i.test(explicit)) return 'New';
    const title = String((p && p.title) || '');
    if(/^\s*used\b/i.test(title) || /\bused\b/i.test(title)) return 'Used';
    return 'New';
  }
  function yfPartInfoSortProducts(items){
    return (items || []).slice().sort((a,b) => {
      const au = yfPartInfoCondition(a) === 'Used' ? 0 : 1;
      const bu = yfPartInfoCondition(b) === 'Used' ? 0 : 1;
      if(au !== bu) return au - bu;
      const ap = Number(String(a.price || '').replace(/[^0-9.]/g,''));
      const bp = Number(String(b.price || '').replace(/[^0-9.]/g,''));
      if(Number.isFinite(ap) && Number.isFinite(bp) && ap !== bp) return ap - bp;
      return String(a.title || '').localeCompare(String(b.title || ''));
    });
  }
  function yfPartInfoNumbers(partNo, chain){
    const seen = new Set();
    const out = [];
    function add(v){ const k = norm(v); if(k && !seen.has(k)){ seen.add(k); out.push(k); } }
    if(chain && chain.current) add(chain.current);
    add(partNo);
    (chain && chain.forward || []).forEach(add);
    (chain && chain.reverse || []).forEach(add);
    return out;
  }
  function yfExtractProductPagePartNumber(root){
    if(!root) return '';
    // Product-page matching must only use the structured extracted part number metafield.
    // Do not fall back to SKU, title, or custom.part_number because those can create false matches.
    return norm(root.dataset.part || '');
  }
  function yfPartInfoHasSupersession(chain){
    return !!(chain && ((chain.forward && chain.forward.length) || (chain.reverse && chain.reverse.length)));
  }
  let yfPartInfoConditionIndexPromise = null;
  function yfPartInfoIndexKey(value){
    return String(value == null ? '' : value).trim().toLowerCase().replace(/[^a-z0-9]+/g, '');
  }
  async function yfPartInfoConditionIndex(){
    const url = window.YF_CONDITION_OPTIONS_INDEX_URL || '';
    if(!url) return {};
    if(!yfPartInfoConditionIndexPromise){
      yfPartInfoConditionIndexPromise = fetch(url, {credentials:'same-origin'})
        .then(r => r && r.ok ? r.json() : {})
        .then(data => data && (data.parts || data) || {})
        .catch(() => ({}));
    }
    return yfPartInfoConditionIndexPromise;
  }
  async function yfProductsFromConditionIndex(partNumbers, excludeHandle){
    const idx = await yfPartInfoConditionIndex();
    const out = [];
    const seen = new Set();
    (partNumbers || []).forEach(pn => {
      const rows = idx[yfPartInfoIndexKey(pn)] || [];
      rows.forEach(raw => {
        const h = raw && (raw.handle || (raw.url && String(raw.url).split('/products/')[1] || '').split(/[?#]/)[0]);
        if(!h || h === excludeHandle || seen.has(h)) return;
        seen.add(h);
        out.push({
          handle: h,
          url: raw.url || ('/products/' + h),
          title: raw.title || '',
          imageUrl: raw.image || raw.featured_image || '',
          price: raw.price || '',
          compareAtPrice: raw.compareAtPrice || raw.compare_at_price || '',
          partNumber: raw.partNumber || pn,
          available: raw.available !== false,
          inventory: raw.inventory,
          _matchedPart: pn,
          _condition: yfPartInfoCondition(raw)
        });
      });
    });
    return out;
  }
  async function yfProductsForExactPartNumbers(partNumbers, excludeHandle){
    const out = [];
    const seen = new Set();
    function pushProduct(p, pn){
      const h = p && p.handle;
      if(!h || h === excludeHandle || seen.has(h)) return;
      seen.add(h);
      out.push(Object.assign({}, p, {
        imageUrl: p.imageUrl || p.image || p.featured_image || '',
        _matchedPart: pn || p._matchedPart || p.partNumber || '',
        _condition: yfPartInfoCondition(p)
      }));
    }
    for(const pn of (partNumbers || [])){
      const rec = await db.productPart(pn);
      (rec && rec.products || []).forEach(p => pushProduct(p, pn));
    }

    // Product pages must match from yf_extracted_data.part_number only, but the product-part
    // database does not always contain every duplicate Shopify product. Add the same exact
    // part-number condition index used by collection cards so New products still show
    // Other Matching Parts when the only available matches are other New products.
    const conditionIndexProducts = await yfProductsFromConditionIndex(partNumbers, excludeHandle);
    conditionIndexProducts.forEach(p => pushProduct(p, p._matchedPart));

    const live = await filterLiveOnlineInStockProducts(out, 64);
    return yfPartInfoSortProducts(live.map(p => Object.assign({}, p, {
      imageUrl: p.imageUrl || p.image || p.featured_image || '',
      _condition: yfPartInfoCondition(p)
    })));
  }
  function yfPartInfoProductCard(p){
    const url = productVariantUrl(p);
    const condition = yfPartInfoCondition(p);
    return '<a class="yf-part-info-match-card" href="'+esc(url)+'">'
      + '<div class="yf-part-info-match-img">'+(p.imageUrl ? '<img loading="lazy" src="'+esc(p.imageUrl)+'" alt="'+esc(p.title || 'Matching part')+'">' : '<span>No image</span>')+'</div>'
      + '<div class="yf-part-info-match-copy"><span class="yf-part-info-condition '+(condition === 'Used' ? 'used' : 'new')+'">'+esc(condition)+'</span>'
      + '<strong>'+esc(p.title || 'Matching product')+'</strong>'
      + '<div class="yf-part-info-match-meta">'+(p.partNumber ? '<span>Part '+esc(p.partNumber)+'</span>' : '')+(p._matchedPart ? '<span>Matched '+esc(p._matchedPart)+'</span>' : '')+'</div>'
      + '<div class="yf-part-info-match-price">'+esc(money(p.price || ''))+(p.compareAtPrice && Number(p.compareAtPrice) > Number(p.price) ? ' <s>'+esc(money(p.compareAtPrice))+'</s>' : '')+'</div>'
      + '</div></a>';
  }
  async function initProductPartInfoWidgets(){
    document.querySelectorAll('[data-yf-product-part-info]').forEach(async root => {
      if(root.dataset.bound) return;
      root.dataset.bound = '1';
      const partNo = yfExtractProductPagePartNumber(root);
      const exclude = root.dataset.handle || '';
      if(!partNo){ root.hidden = true; root.innerHTML = ''; return; }
      try{
        const chain = await supersessionChain(partNo);
        const nums = yfPartInfoNumbers(partNo, chain);
        const products = await yfProductsForExactPartNumbers(nums, exclude);
        const currentCondition = yfPartInfoCondition({condition: root.dataset.condition || ''});
        const usedProducts = products.filter(p => yfPartInfoCondition(p) === 'Used');
        const displayProducts = (currentCondition === 'New' && usedProducts.length) ? usedProducts : products;
        const hasSupersessionInfo = yfPartInfoHasSupersession(chain);
        const banner = hasSupersessionInfo ? supersessionBanner(partNo, chain, {title:'Part Number Information', compact:true}) : '';

        // Product-page matching must only use yf_extracted_data.part_number, but it should
        // still show for New products when active, online, in-stock Used options exist for
        // the same exact extracted part number. Do not require old/superseded numbers for
        // that used-options drawer.
        if(!hasSupersessionInfo && !displayProducts.length){ root.hidden = true; root.innerHTML = ''; return; }

        root.hidden = false;
        const count = displayProducts.length;
        const isUsedOptions = currentCondition === 'New' && usedProducts.length > 0;
        const autoOpenUsedOptions = isUsedOptions && usedProducts.length <= 4;
        const buttonText = isUsedOptions ? 'Show Used Options' : 'Other Matching Parts';
        const panelTitle = autoOpenUsedOptions ? 'Used Options' : (isUsedOptions ? (count + ' used option' + (count === 1 ? '' : 's')) : (count + ' matching part' + (count === 1 ? '' : 's')));
        let html = '<div class="yf-part-info-widget '+(isUsedOptions ? 'is-used-options' : '')+(autoOpenUsedOptions ? ' is-auto-open-used-options' : '')+'">' + (banner || '');
        if(displayProducts.length){
          if(autoOpenUsedOptions){
            html += '<div class="yf-part-info-auto-title"><span>'+esc(panelTitle)+'</span><em>'+esc(count)+' available</em></div>'
              + '<div class="yf-part-info-matches" data-yf-part-info-matches><div class="yf-part-info-match-grid">'+displayProducts.map(yfPartInfoProductCard).join('')+'</div></div>';
          }else{
            html += '<button type="button" class="yf-part-info-toggle" data-yf-part-info-toggle aria-expanded="false"><span>'+esc(buttonText)+'</span><em>'+esc(count)+' available</em></button>'
              + '<div class="yf-part-info-matches" data-yf-part-info-matches hidden><div class="yf-part-info-match-head"><strong>'+esc(panelTitle)+'</strong></div><div class="yf-part-info-match-grid">'+displayProducts.map(yfPartInfoProductCard).join('')+'</div></div>';
          }
        }
        html += '</div>';
        root.innerHTML = html;
        root.classList.toggle('is-open', !!autoOpenUsedOptions);
        const btn = root.querySelector('[data-yf-part-info-toggle]');
        const panel = root.querySelector('[data-yf-part-info-matches]');
        if(btn && panel){
          btn.addEventListener('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            const open = panel.hidden;
            panel.hidden = !open;
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            root.classList.toggle('is-open', open);
          });
        }
      }catch(e){
        console.warn('YF product part info failed', e);
        root.hidden = true; root.innerHTML = '';
      }
    });
  }
  async function renderSkuLookup(root, q, matches){
    const res = root.querySelector('[data-yf-results]');
    const enriched = await mapLimit((matches || []).slice(0,4), 4, enrichSkuProduct);
    const first = enriched[0];
    if(!first){ return false; }
    const part = first.partNumber ? await db.part(first.partNumber) : null;
    const [diagrams, related] = await Promise.all([skuBreakdownListFromPart(part), relatedProductsForSkuProduct(first, part, 6)]);
    const intro = '<section class="yf-sku-lookup"><div class="yf-sku-exact-line"><span class="yf-tech-badge">ⓘ Technical Specs</span><span>Exact Match: <strong>'+esc(first.sku || q)+'</strong></span></div><div class="yf-sku-layout">'
      + '<div class="yf-sku-main">'+enriched.map(skuProductHeroCard).join('')+'</div>'
      + '<aside class="yf-sku-sidebar">'+skuCompatibleModelsPanel(part)+skuBreakdownsPanel(diagrams)+skuRelatedProductsPanel(related)+'</aside></div></section>';
    res.innerHTML = intro;
    bindSkuCopyButtons(res);
    scheduleNativePageCacheSave(res, true);
    return true;
  }
  function bindSkuCopyButtons(scope){
    (scope || document).querySelectorAll('[data-yf-copy]').forEach(btn => {
      if(btn.dataset.copyBound) return;
      btn.dataset.copyBound = '1';
      btn.addEventListener('click', async e => {
        e.preventDefault(); e.stopPropagation();
        const txt = btn.getAttribute('data-yf-copy') || '';
        try{ await navigator.clipboard.writeText(txt); btn.textContent = '✓'; setTimeout(()=>{ btn.textContent = '⧉'; }, 900); }catch(err){}
      });
    });
  }

  function productScroller(title, text, products, empty){
    const showCondition = /Available replacement parts|Available products from this diagram/i.test(String(title || ''));
    return '<section class="yf-panel yf-products-panel"><div class="yf-panel-head"><div><h2>'+esc(title)+'</h2>'+((text&&String(text).trim())?'<p>'+esc(text)+'</p>':'')+'</div><strong>'+esc(products.length)+'</strong></div>'
      + (products.length ? '<div class="yf-product-rail">'+products.map(p => productCard(p, {matchedPart:p._matchedPart || p.partNumber, badge:p._label, badgeClass:p._klass, showCondition:showCondition})).join('')+'</div>' : '<div class="yf-empty-state">'+esc(empty || 'No active in-stock Shopify products found.')+'</div>') + '</section>';
  }

  function productPlaceholder(id, title, text){
    return '<section id="'+esc(id)+'" class="yf-panel yf-products-panel yf-products-loading"><div class="yf-panel-head"><div><h2>'+esc(title)+'</h2>'+((text&&String(text).trim())?'<p>'+esc(text)+'</p>':'')+'</div><strong>…</strong></div><div class="yf-loading soft"><span></span> Checking live Shopify products…</div></section>';
  }
  function replaceProductPanel(scope, id, title, text, products, empty){
    const el = scope.querySelector('#' + id);
    if(!el) return;
    el.outerHTML = productScroller(title, text, products || [], empty);
    scheduleNativePageCacheSave(scope, false);
    idle(function(){ hydrateProducts(scope).then(function(){ scheduleNativePageCacheSave(scope, false); }).catch(function(){ scheduleNativePageCacheSave(scope, false); }); });
  }
  async function lazyLoadModelProducts(scope, model, q, opts){
    opts = opts || {};
    const currentHandle = String(opts.currentHandle || '').trim();
    const completePanelId = opts.completePanelId || 'yf-complete-products';
    const modelPanelId = opts.modelPanelId || 'yf-model-products';
    const markCurrentProduct = (products) => (products || []).map(function(p){
      const h = String((p && p.handle) || '').trim();
      if(currentHandle && h && h === currentHandle){
        return Object.assign({}, p, {_label:'Current product', _klass:'current'});
      }
      return p;
    });
    const completeTask = (async () => {
      try{
        const completeUnits = markCurrentProduct(await productsForCompleteUnit(model, q, 12));
        replaceProductPanel(scope, completePanelId, 'Complete units', '', completeUnits, 'No complete units are currently active, online, and in stock for this model number.');
      }catch(e){ replaceProductPanel(scope, completePanelId, 'Complete units', '', [], 'Could not check complete units.'); }
    })();
    const partsTask = (async () => {
      try{
        const modelProducts = await productsForModel(model, 48);
        replaceProductPanel(scope, modelPanelId, 'Available replacement parts for this model', '', modelProducts, 'No active in-stock replacement products matched any breakdown part number for this model yet.');
      }catch(e){ replaceProductPanel(scope, modelPanelId, 'Available replacement parts for this model', '', [], 'Could not check replacement parts.'); }
    })();
    await Promise.allSettled([completeTask, partsTask]);
  }
  async function lazyLoadPartProducts(scope, part){
    try{
      const partCtx = await inferBrandsForPartNumber(part.p, part);
      const chainRes = await productsForChain(part.p, partCtx);
      const products = chainRes.items.map(i => Object.assign({}, i.product, {_matchedPart:i.matchedPart,_label:i.label,_klass:i.klass}));
      const stats = scope.querySelector('[data-yf-part-product-count]'); if(stats) stats.textContent = products.length;
      replaceProductPanel(scope, 'yf-part-products', 'Available products for this part', 'Shows available Shopify products for the searched number, newer replacements, and older related numbers.', products, 'No active in-stock Shopify product matched this part number or its replacement chain yet.');
    }catch(e){ replaceProductPanel(scope, 'yf-part-products', 'Available products for this part', 'Shows available Shopify products for the searched number, newer replacements, and older related numbers.', [], 'Could not check products.'); }
  }
  async function lazyLoadBreakdownProducts(scope, m, modelQ, parts, serialQ){
    const completeTask = (async () => {
      try{
        const completeUnits = await productsForCompleteUnit(m, modelQ, 12);
        replaceProductPanel(scope, 'yf-breakdown-complete-products', 'Complete units', '', completeUnits, 'No complete units available.');
      }catch(e){ replaceProductPanel(scope, 'yf-breakdown-complete-products', 'Complete units', '', [], 'Could not check complete units.'); }
    })();
    const partsTask = (async () => {
      try{
        const products = await productsForDiagramPartNumbersLive(parts, 120, {expectedBrands:[m && m.b].filter(Boolean), expectedCategory:m && m.c, requireOnlineStore:true});
        replaceProductPanel(scope, 'yf-breakdown-part-products', serialQ?'Available replacement parts for this serial':'Available replacement parts for this model', '', products, 'No active in-stock products matched these diagram part numbers yet.');
      }catch(e){ replaceProductPanel(scope, 'yf-breakdown-part-products', serialQ?'Available replacement parts for this serial':'Available replacement parts for this model', '', [], 'Could not check replacement products.'); }
    })();
    await Promise.allSettled([completeTask, partsTask]);
  }
  function breakdownPreview(model, serial){
    let diagrams = diagramsForModel(model, serial);
    if(modelHasSerialHierarchy(model) && !serial) return '';
    return '<section class="yf-panel"><div class="yf-panel-head"><div><h2>All matching breakdowns</h2><p>Open a breakdown to view reference numbers and matching Shopify products.</p></div><strong>'+esc(diagrams.length)+'</strong></div>'+diagramGrid(diagrams, model, 'No breakdown diagrams found.')+'</section>';
  }

  async function renderSearch(root, q, opts){
    opts = opts || {};
    const res = root.querySelector('[data-yf-results]');
    if(!q){
      if(opts.removeWhenNoModel){ if(root && root.remove) root.remove(); return; }
      res.innerHTML = '<section class="yf-welcome"><h2>Find the right RV part faster</h2><p>Search a model number, part number, or category. Try <strong>G6A-7</strong>, <strong>RM2652</strong>, <strong>91602</strong>, or <strong>water heater</strong>.</p></section>'; return;
    }
    res.innerHTML = '<div class="yf-loading"><span></span> Finding the best match for '+esc(q)+'…</div>';
    try{
      const params = new URLSearchParams(location.search);
      const forceMatch = opts.modelOnly ? 'model' : ((params.get('yf_force') || '').toLowerCase());
      const skuMatches = (forceMatch === 'model' || forceMatch === 'part') ? [] : await db.sku(q);
      if(skuMatches && skuMatches.length){ await renderSkuLookup(root, q, skuMatches); return; }
      if(forceMatch === 'sku'){ res.innerHTML = ''; return; }
      let part = forceMatch === 'model' ? null : await bestPartForQuery(q);
      let model = forceMatch === 'part' ? null : await bestModelForQuery(q, forceMatch === 'model' ? {allowTextModels:true, exactKey:params.get('yf_model_key') || '', contextQuery:[q, params.get('yf_brand') || '', params.get('yf_category') || ''].filter(Boolean).join(' ')} : {});
      const preferPart = shouldPreferPartMatch(q, part, model, forceMatch);
      if(preferPart) model = null;
      else if(model) part = null;
      if(model){
        // An exact database model match is a dedicated YF Native Database page.
        // Hide Shopify's normal search header/grid even when Shopify strips the
        // custom view parameters or the customer typed the exact model directly.
        activateNativeModelOnlyMode(root);
        hideShopifyNativeSearchSections(root);
        model._allDiagrams = await allDiagramSummariesForModel(model);
        try{
          const fullForModel = await fullDiagramsFromSummaries(model._allDiagrams);
          if(fullForModel && fullForModel.length){
            model._fullDiagrams = fullForModel;
            model._allDiagrams = fullForModel;
          }
        }catch(e){ console.warn('Could not load full model diagrams for count/preview', e); }
      }
      if(opts.modelOnly && !model){
        if(opts.removeWhenNoModel){ if(root && root.remove) root.remove(); }
        else res.innerHTML = '';
        return;
      }
      if(forceMatch === 'model' && !model){
        res.innerHTML = '<div class="yf-empty-state">No exact model match found.</div>';
        hideShopifyNativeSearchSections(root);
        return;
      }
      let collection = await primaryCollection(q, model, part);
      // V38: keep the search-results panel in sync with the header dropdown.
      // If there is no exact model/part database match, still show the same curated/referring-link
      // collection matches that appear while typing (ex: tire, ladder, water pups).
      let curatedCollections = [];
      if(!model && !part){
        curatedCollections = await collectionsForQuery(q, null, null, collection);
        if(!collection && curatedCollections && curatedCollections.length) collection = curatedCollections[0];
      }
      let html = '<div class="yf-layout">';
      let main = '', side = '';

      if(model){
        const serialAware = modelHasSerialHierarchy(model);
        main += modelIntro(model, serialAware);
        if(serialAware){
          main += serialPickerHtml(model);
          main += '<section class="yf-panel yf-soft"><h2>Choose a serial before we show parts</h2><p>This model has serial-specific breakdowns. We hide complete units, replacement parts, and diagram choices until a serial is selected so customers do not buy parts from the wrong production run.</p></section>';
          if(collection) main += suggestedCollectionsPanel([collection], 'Recommended collection', '');
        }else{
          main += breakdownPreview(model);
          main += productPlaceholder('yf-complete-products', 'Complete units', '');
          if(collection) main += suggestedCollectionsPanel([collection], 'Recommended collection', '');
          main += productPlaceholder('yf-model-products', 'Available replacement parts for this model', '');
        }
      } else if(part){
        const chain = await supersessionChain(part.p);
        const partCtx = await inferBrandsForPartNumber(part.p, part);
        const pBrand = partBrandLabel(part, partCtx);
        main += partIntro(part, chain, {__html:'<span data-yf-part-product-count>…</span>'}, pBrand);
        main += supersessionBanner(part.p, chain);
        main += productPlaceholder('yf-part-products', 'Available products for this part', 'Shows available Shopify products for the searched number, newer replacements, and older related numbers.');
        if(collection) main += suggestedCollectionsPanel([collection], 'Recommended collection', '');
        main += '<section class="yf-panel"><div class="yf-panel-head"><div><h2>Fits these models</h2><p>Open a model to view the breakdown and related parts.</p></div><strong>'+esc((part.used||[]).length)+'</strong></div><div class="yf-model-list">'+(part.used||[]).slice(0,80).map(u => '<a href="'+nativeModelSearchUrl(u)+'"><strong>'+esc(u[0])+'</strong></a>').join('')+'</div></section>';
      } else if(collection || (curatedCollections && curatedCollections.length)){
        const collections = (curatedCollections && curatedCollections.length) ? curatedCollections : await collectionsForQuery(q, null, null, collection);
        const rule = referringRuleForQuery(q);
        const catInfo = await categoryInfoForSearch(q, collections);
        // V38: category-only searches should show useful collection matches, not a "no database match" card.
        main += categorySearchIntro(q, rule, collections);
        main += categoryCollectionsPanel(collections);
        if(catInfo){
          main += categorySelectorShell(catInfo, q);
        }
      } else {
        // V38: if nothing smart matches, render nothing above Shopify's native search results.
        main += '';
      }

      html += '<div class="yf-main-col '+(!side ? 'wide' : '')+'">'+main+'</div>'+(side ? '<aside class="yf-side-col">'+side+'</aside>' : '')+'</div>';
      res.innerHTML = html;
      hydrateProducts(res).then(function(){ scheduleNativePageCacheSave(res, false); }).catch(function(){ scheduleNativePageCacheSave(res, false); });
      hydrateCollectionCards(res).then(function(){ scheduleNativePageCacheSave(res, false); }).catch(function(){ scheduleNativePageCacheSave(res, false); });
      initCollectionLinkSafety(res); initSerialSelectors(res); initCategoryWidgets(); bindDiagramInteractions(res);
      if(model && !modelHasSerialHierarchy(model)) lazyLoadModelProducts(res, model, q);
      if(part) lazyLoadPartProducts(res, part);
    }catch(e){ console.error(e); res.innerHTML = '<div class="yf-empty-state">Something went wrong loading the native parts data. Please try again.</div>'; }
  }

  async function renderPart(root, q){
    const res = root.querySelector('[data-yf-results]'); q = q || '';
    if(!q){ res.innerHTML = '<div class="yf-empty-state">Enter a part number.</div>'; return; }
    const part = await db.part(q);
    if(!part){ res.innerHTML = '<div class="yf-empty-state">Part number not found.</div>'; return; }
    const chainRes = await productsForChain(part.p, await inferBrandsForPartNumber(part.p, part));
    const products = chainRes.items.map(i => Object.assign({}, i.product, {_matchedPart:i.matchedPart,_label:i.label,_klass:i.klass}));
    res.innerHTML = '<div class="yf-main-col wide">'+partIntro(part, chainRes.chain, products.length)+supersessionBanner(part.p, chainRes.chain)+productScroller('Available products', 'Live Shopify products matched by yf_extracted_data.part_number.', products, 'No active products found.')+'<section class="yf-panel"><h2>Compatible models</h2><div class="yf-model-list">'+(part.used||[]).slice(0,160).map(u=>'<a href="'+nativeModelSearchUrl(u)+'"><strong>'+esc(u[0])+'</strong></a>').join('')+'</div></section></div>';
    hydrateProducts(res).then(function(){ scheduleNativePageCacheSave(res, false); }).catch(function(){ scheduleNativePageCacheSave(res, false); });
  }

  async function renderBreakdown(root, params){
    const res = root.querySelector('[data-yf-results]');
    const diagramId = params.get('diagram'); const modelQ = params.get('model') || params.get('q'); const serialQ = String(params.get('serial') || '').trim();
    res.innerHTML = '<div class="yf-loading"><span></span> Loading breakdown…</div>';
    if(diagramId){ const d = await db.diagram(diagramId); if(!d){ res.innerHTML = '<div class="yf-empty-state">Diagram not found.</div>'; return; } return renderDiagram(root, d); }
    if(modelQ){
      const m = await bestModelForQuery(modelQ, {allowTextModels:true}); if(!m){ res.innerHTML = '<div class="yf-empty-state">No breakdowns found for this model.</div>'; return; }
      m._allDiagrams = await allDiagramSummariesForModel(m);
      if(modelHasSerialHierarchy(m) && !serialQ){ res.innerHTML = modelIntro(m, true) + serialPickerHtml(m); initSerialSelectors(res); scheduleNativePageCacheSave(res, false); return; }
      let diagramSummaries = await allDiagramSummariesForModel(m, serialQ || '');
      const diagrams = displayDiagrams(await fullDiagramsFromSummaries(diagramSummaries));
      let parts = partNumbersFromDiagrams(diagrams); if(!parts.length && !serialQ) parts = (m.parts || []);
      const col = await primaryCollection(modelQ, m, null);
      const serialTitle = serialQ ? 'Serial '+esc(serialQ)+' breakdowns' : 'Breakdown diagrams';
      const serialCopy = serialQ ? 'These diagrams and products are filtered to the selected serial number only.' : 'Use the diagram to confirm reference numbers before buying.';
      const hasSerialChoices = modelHasSerialHierarchy(m);
      const changeMode = serialQ && hasSerialChoices ? 'serial' : 'model';
      const changeHeading = changeMode === 'serial' ? 'Need a different serial?' : 'Need a different model?';
      const changeLabel = changeMode === 'serial' ? 'Change serial number' : 'Change serial/model';
      const changeHref = changeMode === 'serial' ? modelBreakdownUrl(m.m) : nativeSearchUrl(m.m);
      const changeAction = '<section class="yf-panel side yf-change-model-panel"><h2>'+changeHeading+'</h2><a class="yf-btn ghost" href="'+changeHref+'" data-yf-change-serial-model data-yf-change-mode="'+changeMode+'" data-yf-change-model="'+esc(m.m)+'">'+changeLabel+'</a></section>';
      res.innerHTML = '<div class="yf-layout"><div class="yf-main-col">'+modelIntro(m, false)+'<section class="yf-panel"><div class="yf-panel-head"><div><h2>'+serialTitle+'</h2><p>'+serialCopy+'</p></div><strong>'+esc(diagrams.length)+'</strong></div>'+diagramGrid(diagrams, m, serialQ ? 'No diagrams found for this serial.' : 'No diagrams found for this model.')+'</section>'+productPlaceholder('yf-breakdown-complete-products', 'Complete units', '')+productPlaceholder('yf-breakdown-part-products', serialQ?'Available replacement parts for this serial':'Available replacement parts for this model', '')+'</div><aside class="yf-side-col">'+(col?'<section class="yf-panel side">'+collectionCard(col)+'</section>':'')+changeAction+'</aside></div>';
      hydrateProducts(res).then(function(){ scheduleNativePageCacheSave(res, false); }).catch(function(){ scheduleNativePageCacheSave(res, false); });
      hydrateCollectionCards(res).then(function(){ scheduleNativePageCacheSave(res, false); }).catch(function(){ scheduleNativePageCacheSave(res, false); });
      initCollectionLinkSafety(res); bindDiagramInteractions(res); lazyLoadBreakdownProducts(res, m, modelQ, parts, serialQ); return;
    }
    res.innerHTML = '<div class="yf-welcome"><h2>Find a breakdown diagram</h2><p>Search a model number above to see diagrams and matching parts.</p></div>';
    scheduleNativePageCacheSave(res, false);
  }

  async function productsForReferencePart(pn, chain){
    const nums = [];
    const add = v => { const k = norm(v); if(k && !nums.includes(k)) nums.push(k); };
    add(pn);
    if(chain && chain.forward && chain.forward.length) chain.forward.forEach(add);
    if(chain && chain.current) add(chain.current);
    if(chain && chain.reverse && chain.reverse.length) chain.reverse.forEach(add);
    const out = [];
    const seen = new Set();

    // V121: Breakdown diagram reference rows must include every live Shopify product
    // with the same exact yf_extracted_data.part_number, not only products that were
    // present in the static product-part export. The product page can find newer live
    // products through the Shopify yfjson search view, so diagram pages need to use
    // that same live lookup path too. This fixes cases where a used option appeared
    // on the product page but the newer matching product was missing from the
    // breakdown diagram parts list / Available products from this diagram panel.
    await Promise.all(nums.slice(0,8).map(async num => {
      const label = norm(num) === norm(pn) ? 'Exact part' : (chain && chain.forward && chain.forward.map(norm).includes(norm(num))) || (chain && norm(chain.current) === norm(num) && norm(num)!==norm(pn)) ? 'Replacement' : 'Related number';
      const klass = label === 'Replacement' ? 'blue' : (label === 'Related number' ? 'amber' : 'green');
      const ps = await productsForPart(num, {fastStatic:false});
      ps.slice(0,12).forEach(pr => {
        const h = pr && (pr.handle || handleFromProductUrl(pr.url));
        if(!h || seen.has(h)) return;
        seen.add(h);
        out.push(Object.assign({}, pr, {handle:h, _matchedPart:num, _label:label, _klass:klass}));
      });
    }));
    // Breakdown diagram product rows and the "Available products from this diagram" panel
    // must only use products that Shopify confirms are available on the Online Store and in stock.
    return filterLiveOnlineInStockProducts(out, 16);
  }


  function refRank(ref){
    const raw = String(ref == null ? '' : ref).trim();
    if(!raw || /^NS$/i.test(raw)) return [999999, raw];
    const m = raw.match(/^(\d+)([A-Za-z]*)/);
    if(m) return [parseInt(m[1],10), (m[2]||'')];
    return [500000, raw];
  }
  function sortDiagramParts(parts){
    return (parts || []).slice().sort((a,b) => {
      const ar = refRank(a && a[0]);
      const br = refRank(b && b[0]);
      if(ar[0] !== br[0]) return ar[0] - br[0];
      if(ar[1] !== br[1]) return String(ar[1]).localeCompare(String(br[1]));
      return String((a && a[1]) || '').localeCompare(String((b && b[1]) || ''));
    });
  }
  async function enrichDiagramParts(d, relatedModel){
    // Build the visible parts list from every source that can belong to this
    // displayed diagram. Many old breakdown imports split one breakdown across
    // two records: a real scanned diagram image, and a DinoLogo/placeholder row
    // that contains the complete reference/parts table. If we only use d.parts,
    // the customer sees the diagram image but the right-side reference list is
    // missing most callouts. So for a real image diagram, merge any placeholder
    // sibling parts for the exact same model/serial/category before enriching.
    const base = (d && Array.isArray(d.parts)) ? d.parts.slice() : [];
    const seen = new Set();
    function addRow(row){
      if(!row) return;
      const ref = (row[0] == null || row[0] === '') ? 'NS' : row[0];
      const pn = row[1] || '';
      const key = norm(ref) + '|' + norm(pn);
      if(seen.has(key)) return;
      seen.add(key);
      base.push([ref, pn, row[2] || '', row[3] == null ? null : row[3], row[4] == null ? null : row[4]]);
    }
    // Reset base via addRow so duplicate checks are normalized.
    const original = base.splice(0, base.length);
    original.forEach(addRow);

    try{
      if(relatedModel && relatedModel._allDiagrams && !isPlaceholderDiagram(d)){
        const siblings = await fullDiagramsFromSummaries(relatedModel._allDiagrams || []);
        const currentSerial = (d && d.s) || '';
        (siblings || []).forEach(sib => {
          if(!sib || !sib.parts || !sib.parts.length) return;
          if(!isPlaceholderDiagram(sib)) return;
          if(norm(sib.m) !== norm(d && d.m)) return;
          if(norm((sib.s || '')) !== norm((currentSerial || ''))) return;
          (sib.parts || []).forEach(addRow);
        });
      }
    }catch(e){ console.warn('Could not merge sibling breakdown reference table', e); }

    // Some diagram records can also be missing legacy/replaced rows even though
    // part_knowledge.used points back to this same diagram id. Add those too.
    const candidates = new Set();
    base.forEach(x => { if(x && x[1]) candidates.add(String(x[1])); });
    ((relatedModel && relatedModel.parts) || []).forEach(pn => { if(pn) candidates.add(String(pn)); });
    const diagramIds = new Set([String((d && d.id) || '')]);
    // If this is a real image backed by placeholder table rows, also allow the
    // placeholder diagram id when checking part_knowledge.used.
    try{
      if(relatedModel && relatedModel._allDiagrams && !isPlaceholderDiagram(d)){
        const siblings = await fullDiagramsFromSummaries(relatedModel._allDiagrams || []);
        const currentSerial = (d && d.s) || '';
        (siblings || []).forEach(sib => {
          if(!sib || !isPlaceholderDiagram(sib)) return;
          if(norm(sib.m) !== norm(d && d.m)) return;
          if(norm((sib.s || '')) !== norm((currentSerial || ''))) return;
          if(sib.id) diagramIds.add(String(sib.id));
        });
      }
    }catch(e){}
    await mapLimit(Array.from(candidates).slice(0,700), 14, async pn => {
      const rec = await db.part(pn);
      if(!rec || !Array.isArray(rec.used)) return;
      rec.used.forEach(u => {
        const did = String((u && u[2]) || '');
        if(!diagramIds.has(did)) return;
        const ref = (u && u[1]) || 'NS';
        const partNo = rec.p || rec.n || pn;
        addRow([ref, partNo, rec.d || '', null, null]);
      });
    });
    return sortDiagramParts(base);
  }

  function bindReferenceSearch(scope){
    const input = scope.querySelector('[data-yf-ref-search]');
    if(!input || input.dataset.bound) return;
    input.dataset.bound = '1';
    input.addEventListener('input', () => {
      const q = norm(input.value);
      scope.querySelectorAll('.yf-part-row').forEach(row => {
        // Reference search on breakdown pages should only filter by the diagram reference number.
        // It should not match part numbers, descriptions, supersessions, or product text.
        const refOnly = norm(row.getAttribute('data-ref-number') || '');
        row.hidden = !!q && !refOnly.includes(q);
      });
    });
  }
  function bindDiagramInteractions(scope){
    bindReferenceSearch(scope);
    scope.querySelectorAll('.yf-callout-dot').forEach(btn => {
      if(btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', () => {
        const i = btn.dataset.i;
        scope.querySelectorAll('.yf-callout-dot').forEach(b => b.classList.toggle('active', b === btn));
        scope.querySelectorAll('.yf-part-row').forEach(r => r.classList.toggle('active', r.getAttribute('data-part-i') === i));
        const row = scope.querySelector('[data-part-i="'+i+'"]');
        if(row) row.scrollIntoView({behavior:'smooth', block:'center'});
      });
    });
  }

  async function renderDiagram(root, d){
    const res = root.querySelector('[data-yf-results]');
    const relatedModel = d && d.m ? await db.model(d.m) : null;
    if(relatedModel){ relatedModel._allDiagrams = await allDiagramSummariesForModel(relatedModel); }
    const relatedAll = displayDiagrams(relatedModel && relatedModel._allDiagrams ? relatedModel._allDiagrams : []);
    // On an individual serial/product-id breakdown page, only show sibling
    // breakdowns for that exact serial number. Previously this panel used every
    // breakdown in the model series, which mixed unrelated serial ranges.
    const currentDiagramSerial = norm((d && d.s) || '');
    const related = currentDiagramSerial
      ? relatedAll.filter(x => norm((x && x.s) || '') === currentDiagramSerial)
      : relatedAll;
    const parts = await enrichDiagramParts(d, relatedModel);
    const uniq = [...new Set(parts.map(x => x[1]).filter(Boolean))];
    const productMap = {}, productListMap = {}, chainMap = {};
    await mapLimit(uniq.slice(0,260), 18, async pn => {
      const chain = await supersessionChain(pn);
      const list = await productsForReferencePart(pn, chain);
      productListMap[pn] = list;
      productMap[pn] = list[0] || null;
      chainMap[pn] = chain;
    });
    const seenAvailable = new Set();
    const available = [];
    Object.keys(productListMap).forEach(pn => (productListMap[pn] || []).forEach(pr => { if(pr && pr.handle && !seenAvailable.has(pr.handle)){ seenAvailable.add(pr.handle); available.push(pr); } }));
    const dots = parts.filter(x => x[3] != null && x[4] != null).map((x,i) => '<button class="yf-callout-dot" style="left:'+esc(x[3])+'%;top:'+esc(x[4])+'%" data-i="'+i+'">'+esc(x[0])+'</button>').join('');
    const rows = parts.map((x,i) => {
      const ref = x[0] || 'NS';
      const pn = x[1] || '';
      const chain = chainMap[pn] || {};
      const sup = supersessionBanner(pn, chain, {compact:true});
      const plist = productListMap[pn] || [];
      const products = plist.length ? '<div class="yf-ref-products">'+plist.slice(0,6).map(pr => {
        const url = pr.url || ('/products/' + (pr.handle || ''));
        return '<a class="yf-part-product" data-yf-product-card data-handle="'+esc(pr.handle||'')+'" href="'+esc(url)+'">'
          + '<div class="yf-part-product-img" data-yf-product-img>'+(pr.imageUrl?'<img loading="lazy" src="'+esc(pr.imageUrl)+'" alt="">':'')+'</div>'
          + '<div class="yf-part-product-copy"><span class="yf-product-badge '+esc(pr._klass||'')+'">'+esc(pr._label||'Product')+'</span><strong>'+esc(pr.title||'Matching product')+'</strong><div class="yf-part-product-price" data-yf-product-price>'+esc(money(pr.price||''))+'</div><span data-yf-product-availability class="yf-stock small">In stock</span></div></a>';
      }).join('')+'</div>' : '<div class="yf-oos-note">Out of stock</div>';
      const btn = plist.length ? '<a class="yf-btn small" href="'+esc(plist[0].url||('/products/'+plist[0].handle))+'">View</a>' : '<span class="yf-oos small">Out of stock</span>';
      return '<div class="yf-part-row" data-part-i="'+i+'" data-ref-number="'+esc(ref)+'"><div class="yf-ref">'+esc(ref)+'</div><div class="yf-part-main"><strong>'+esc(pn || 'No part #')+'</strong><span>'+esc(x[2] || '')+'</span>'+sup+products+'</div>'+btn+'</div>';
    }).join('');
    const relatedTitle = currentDiagramSerial ? 'All breakdowns for this serial' : 'All breakdowns for this model';
    const relatedSubtext = currentDiagramSerial
      ? 'Switch between breakdowns connected to serial '+((d && d.s) ? esc(d.s) : 'this serial')+'.'
      : 'Switch between every individual breakdown connected to '+esc((relatedModel && relatedModel.m) || d.m || 'this model')+'.';
    const relatedPanel = related && related.length > 1 ? '<section class="yf-panel"><div class="yf-panel-head"><div><h2>'+relatedTitle+'</h2><p>'+relatedSubtext+'</p></div><strong>'+esc(related.length)+'</strong></div>'+diagramGrid(related, relatedModel || d, '', d.id)+'</section>' : '';
    const html = '<section class="yf-panel yf-diagram-page"><div class="yf-diagram-titlebar"><div><div class="yf-kicker">Breakdown diagram</div><h2>'+esc(friendlyDiagramTitle(d,null))+'</h2><p>'+esc(diagramSubtext(d))+'</p></div><a class="yf-btn ghost" href="'+nativeModelSearchUrl({m:d.m,b:d.b,c:d.c})+'">Search model</a></div><div class="yf-diagram-workspace"><div class="yf-diagram-left"><div class="yf-diagram-wrap"><img class="yf-diagram-img" src="'+esc(d.url)+'" alt="'+esc([d.b,d.m].filter(Boolean).join(' '))+' breakdown" loading="eager">'+dots+'</div></div><aside class="yf-parts-panel"><div class="yf-parts-panel-head"><div><strong>Parts list</strong><span>'+esc(parts.length)+' refs</span></div><input class="yf-ref-search" data-yf-ref-search type="search" inputmode="search" placeholder="Search reference or part #"></div><div class="yf-parts-list">'+rows+'</div></aside></div></section>' + relatedPanel + (available.length ? productScroller('Available products from this diagram', 'Live Shopify products connected to diagram part numbers.', available.slice(0,32), '') : '');
    res.innerHTML = html;
    hydrateProducts(res).then(function(){ scheduleNativePageCacheSave(res, false); }).catch(function(){ scheduleNativePageCacheSave(res, false); });
    bindDiagramInteractions(res);
  }

  function ddItem(type,title,desc,href){
    let extra = '';
    let finalHref = href || nativeSearchUrl(title || '');
    if(type === 'collection'){
      const h = canonicalCollectionHandle(finalHref || title || desc);
      // V49: visible href is the verified collection URL when known; otherwise safe Shopify search.
      finalHref = verifiedCollectionUrl(h) || nativeSearchUrl(title || desc || 'rv parts');
      if(h){ extra = ' data-yf-dd-collection="1" data-handle="'+esc(h)+'" data-fallback-q="'+esc(title || desc || 'rv parts')+'"'; }
    }
    return '<a class="yf-dd-item"'+extra+' href="'+esc(finalHref)+'"><span class="yf-badge '+esc(type)+'">'+esc(type==='collection'?'Category':type.charAt(0).toUpperCase()+type.slice(1))+'</span><span><strong>'+esc(title)+'</strong><small>'+esc(desc||'')+'</small></span></a>';
  }
  function ddGroup(title, body){ return body ? '<div class="yf-dd-group"><div class="yf-dd-head">'+esc(title)+'</div>'+body+'</div>' : ''; }

  function bindDropdownCollectionSafety(root){
    if(!root) return;
    root.querySelectorAll('[data-yf-dd-collection]').forEach(a => {
      if(a.dataset.safeBound) return;
      a.dataset.safeBound = '1';
      a.addEventListener('click', async e => {
        const h = canonicalCollectionHandle(a.getAttribute('data-handle') || '');
        if(!h) return;
        e.preventDefault();
        // Never send a customer to a guessed /collections URL. Resolve via Shopify's own
        // collection suggestions first, then fall back to confirmed handle or native search.
        location.href = await resolveCollectionUrl(h, a.getAttribute('data-fallback-q') || a.textContent || h);
      });
    });
  }

  async function searchDD(root,q){
    const dd = root.querySelector('[data-yf-dd]'); if(!dd) return; if(q.length < 2){ dd.hidden = true; return; }
    const numberTokens = partOrModelCandidateTokens(q);
    const [exactSku, exactPart, exactModel] = await Promise.all([db.sku(q), bestPartForQuery(q), bestModelForQuery(q)]);
    let parts = [], models = [];
    if(numberTokens.length){
      const prefixJobs = numberTokens.slice(0,4).map(c => Promise.all([db.searchPrefix('part',c,3), db.searchPrefix('model',c,3)]));
      const prefixResults = await Promise.all(prefixJobs);
      prefixResults.forEach(([pp,mm]) => { parts = parts.concat(pp || []); models = models.concat(mm || []); });
    }
    const collection = await primaryCollection(q, exactModel, exactPart);
    const ddCollections = await collectionsForQuery(q, exactModel, exactPart, collection);
    let html = '';
    if(exactSku && exactSku.length){ html += ddGroup('Exact SKU match', exactSku.slice(0,3).map(p => ddItem('sku', p.sku, [p.title, p.inventory != null ? p.inventory + ' in stock' : ''].filter(Boolean).join(' • '), nativeSearchUrl(p.sku)+'&yf_force=sku')).join('')); }
    let partList = []; if(exactPart) partList.push(exactPart); parts.forEach(p => { if(p && !partList.find(x => x.p === p.p)) partList.push(p); });
    let modelList = []; if(exactModel) modelList.push(exactModel); models.forEach(m => { if(m && !modelList.find(x => x.m === m.m)) modelList.push(m); });
    html += ddGroup('Part number matches', partList.slice(0,5).map(p => ddItem('part', p.p, [p.d, p.fits ? 'Fits '+p.fits+' models' : ''].filter(Boolean).join(' • '), nativeSearchUrl(p.p)+'&yf_force=part')).join(''));
    html += ddGroup('Model number matches', modelList.slice(0,5).map(m => ddItem('model', m.m, [m.b, cleanCategoryName(m.c)].filter(Boolean).join(' • '), nativeModelSearchUrl(m))).join(''));
    html += ddCollections && ddCollections.length ? ddGroup(ddCollections.length > 1 ? 'Matching collections' : 'Best collection', ddCollections.slice(0,3).map(c => ddItem('collection', titleFromCollection(c), cleanCategoryName(c.categoryGroup || c.displayName || ''), collectionHref(c))).join('')) : '';
    html += '<div class="yf-dd-footer"><a href="'+nativeSearchUrl(q)+'">Search Shopify for “'+esc(q)+'”</a></div>';
    dd.innerHTML = html || '<div class="yf-empty-state small">Press Enter to search Shopify.</div>'; dd.hidden = false; bindDropdownCollectionSafety(dd);
  }
  function initSearch(root){
    const f = root.querySelector('form'), input = root.querySelector('[data-yf-search-input]'), dd = root.querySelector('[data-yf-dd]'); if(!f || !input || root.dataset.bound) return; root.dataset.bound = '1';
    f.addEventListener('submit', e => { e.preventDefault(); const q = input.value.trim(); if(q) location.href = nativeSearchUrl(q); });
    input.addEventListener('input', deb(() => searchDD(root, input.value.trim()), 220));
    input.addEventListener('focus', () => { const q = input.value.trim(); if(q.length >= 2) searchDD(root,q); });
    document.addEventListener('click', e => { if(dd && !root.contains(e.target)) dd.hidden = true; });
  }
  async function initModelAccordions(scope){
    scope.querySelectorAll('[data-yf-model-details]').forEach(el => { const details = el.closest('details'); if(!details || details.dataset.bound) return; details.dataset.bound = '1'; details.addEventListener('toggle', async () => { if(!details.open || el.dataset.loaded) return; el.dataset.loaded = '1'; const m = await db.model(el.dataset.model); if(!m){ el.innerHTML = '<p>No model details found.</p>'; return; } const di = (m.diagrams || [])[0]; const products = await productsForParts((m.parts || []).slice(0,40), 4, {expectedBrands:[m.b], expectedCategory:m.c}); el.innerHTML = '<div class="yf-model-detail"><p><strong>'+esc(m.m)+'</strong> • '+esc([m.b,cleanCategoryName(m.c)].filter(Boolean).join(' • '))+'</p>'+(products.length?'<div class="yf-mini-products">'+products.map(p=>productCard(p)).join('')+'</div>':'')+(di?'<a class="yf-btn small" href="'+diagramUrl(di.id)+'">View full diagram</a>':'')+'</div>'; hydrateProducts(el); }); });
  }
  async function compatibleModelRowsForExactPartNumber(partNumber){
    // Product-page YF Native Compatibility must show EVERY model associated
    // with the current product's exact yf_extracted_data.part_number.
    // This is intentionally NOT a supersession-chain lookup. It only uses the
    // extracted part number on this product, then merges every compatibility
    // source where that exact normalized part number appears:
    //   1) the part record's used[] rows,
    //   2) the complete reverse part->model compatibility index,
    //   3) a last-resort all-parts scan for older theme data/chunk gaps.
    const clean = norm(partNumber);
    const out = [];
    const seen = new Set();
    function addRow(row){
      if(!row) return;
      const modelNo = Array.isArray(row) ? row[0] : (row.model || row.m || row.modelNumber);
      const key = norm(modelNo);
      if(!key || seen.has(key)) return;
      seen.add(key);
      const brand = Array.isArray(row) ? (row[1] || '') : (row.brand || row.b || '');
      const category = Array.isArray(row) ? (row[2] || '') : (row.category || row.c || '');
      out.push([modelNo, brand, category]);
    }
    if(!clean) return out;

    try{
      const rec = await db.part(clean);
      (rec && rec.used || []).forEach(addRow);
    }catch(e){}

    try{
      const reverseRows = await db.partModelCompat(clean);
      (reverseRows || []).forEach(addRow);
    }catch(e){}

    // Older generated compatibility indexes can be incomplete. If anything is
    // missing, scan the full part index and add rows for the exact same key.
    // This is slower, so it only runs on the product page compatibility block
    // and is cached by the browser's asset cache. It ensures no compatible model
    // tied to the part index is left out.
    if(!out.length){
      try{
        const all = await db.allParts();
        Object.keys(all || {}).forEach(k => {
          if(norm(k) !== clean) return;
          const rec = all[k];
          (rec && rec.used || []).forEach(addRow);
        });
      }catch(e){}
    }

    out.sort((a,b) => String(a && a[0] || '').localeCompare(String(b && b[0] || ''), undefined, {numeric:true, sensitivity:'base'}));
    return out;
  }


  // V132: Amazon-style product fitment with supersession-family matching. Customers can save one appliance or RV
  // component per category, then every indexed product page in that category
  // immediately shows fits / does not fit.
  const YF_FITMENT_STORAGE_KEY = 'yf-fitment-equipment-v3';
  const YF_FITMENT_LEGACY_STORAGE_KEY = 'yf-fitment-equipment-v2';
  const YF_FITMENT_RETURN_KEY = 'yf-fitment-return-v1';
  const YF_EQUIPMENT_GARAGE_KEY = 'yf-my-equipment-v1';
  const yfGlobalEquipmentPromises = {};

  function fitmentAvailablePartsUrl(selected){
    const lookup = fitmentTidy(selected && (selected.serial || selected.model));
    return lookup ? modelBreakdownUrl(lookup) : '';
  }
  function fitmentRememberReturnPosition(root){
    if(!root || !window.history || !window.sessionStorage) return;
    try{
      const token = Date.now().toString(36) + Math.random().toString(36).slice(2,9);
      const rect = root.getBoundingClientRect();
      const record = {
        token,
        url: location.href,
        path: location.pathname + location.search + location.hash,
        part: root.dataset.part || '',
        anchorTop: Number.isFinite(rect.top) ? rect.top : 0,
        scrollY: window.scrollY || window.pageYOffset || 0,
        createdAt: Date.now()
      };
      sessionStorage.setItem(YF_FITMENT_RETURN_KEY, JSON.stringify(record));
      const nextState = Object.assign({}, history.state || {}, {yfFitmentReturnToken: token});
      history.replaceState(nextState, '', location.href);
    }catch(e){}
  }
  function fitmentRestoreReturnPosition(){
    if(!window.history || !window.sessionStorage) return;
    let record = null;
    try{ record = JSON.parse(sessionStorage.getItem(YF_FITMENT_RETURN_KEY) || 'null'); }catch(e){}
    const token = history.state && history.state.yfFitmentReturnToken;
    const currentPath = location.pathname + location.search + location.hash;
    if(!record || !token || record.token !== token || record.path !== currentPath || (Date.now() - Number(record.createdAt || 0)) > 60 * 60 * 1000) return;

    let attempts = 0;
    let stable = 0;
    let stopped = false;
    const stop = () => {
      if(stopped) return;
      stopped = true;
      try{
        sessionStorage.removeItem(YF_FITMENT_RETURN_KEY);
        const nextState = Object.assign({}, history.state || {});
        delete nextState.yfFitmentReturnToken;
        history.replaceState(nextState, '', location.href);
      }catch(e){}
    };
    const restore = () => {
      if(stopped) return;
      attempts += 1;
      const roots = Array.from(document.querySelectorAll('[data-yf-product-fitment]'));
      const anchor = roots.find(item => norm(item.dataset.part || '') === norm(record.part || '')) || roots[0];
      if(anchor && anchor.isConnected){
        const delta = anchor.getBoundingClientRect().top - Number(record.anchorTop || 0);
        if(Math.abs(delta) > 1){ window.scrollBy(0, delta); stable = 0; }
        else stable += 1;
      }else{
        const delta = (window.scrollY || window.pageYOffset || 0) - Number(record.scrollY || 0);
        if(Math.abs(delta) > 1) window.scrollTo(0, Number(record.scrollY || 0));
      }
      if(stable >= 4 || attempts >= 28) return stop();
      setTimeout(restore, attempts < 8 ? 80 : 150);
    };
    requestAnimationFrame(() => requestAnimationFrame(restore));
    setTimeout(stop, 5000);
  }

  function fitmentTidy(v){ return String(v || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim(); }
  function fitmentTitle(v){
    const fixes = {'shurflo':'SHURflo','wfco':'WFCO','rv':'RV','nt':'NT','sf':'SF','rm':'RM','lp':'LP','ac':'AC','dc':'DC'};
    return fitmentTidy(v).split(' ').map(w => fixes[w.toLowerCase()] || w).join(' ');
  }
  const YF_FITMENT_KNOWN_BRANDS = [
    'Lippert Components','Dinosaur Electronics','Marshall Excelsior','Hengs Industries','Fan-Tastic Vent',
    'Aqua-Hot','Duo-Therm','Suburban','Dometic','Atwood','Flojet','Jabsco','SHURflo','Shurflo','Remco',
    'Thetford','WFCO','Norcold','Coleman','Carefree','Furrion','Dexter','Camco','Valterra','Sealand',
    'MaxxAir','Ventline','PullRite / Pulliam Enterprises','Demco','Intellitec'
  ].sort((a,b)=>b.length-a.length);
  function fitmentParseBrand(raw){
    const source = String(raw || '').trim();
    const nbsp = source.split(/\u00a0+/).map(fitmentTidy).filter(Boolean);
    if(nbsp.length > 1) return {brand:fitmentTitle(nbsp.shift()), series:fitmentTitle(nbsp.join(' '))};
    const clean = fitmentTidy(source);
    const upper = clean.toUpperCase();
    for(const known of YF_FITMENT_KNOWN_BRANDS){
      const ku = known.toUpperCase();
      if(upper === ku) return {brand:fitmentTitle(known), series:''};
      if(upper.startsWith(ku + ' ')) return {brand:fitmentTitle(known), series:fitmentTitle(clean.slice(known.length))};
    }
    return {brand:fitmentTitle(clean), series:''};
  }
  function fitmentSeriesLabel(parsedSeries, dbSeries){
    const ps = fitmentTidy(parsedSeries);
    const ds = fitmentTidy(dbSeries);
    if(!ds || /^other$/i.test(ds)) return ps;
    if(!ps) return fitmentTitle(ds);
    const pn = norm(ps), dn = norm(ds);
    if(pn === dn || pn.includes(dn) || dn.includes(pn)) return fitmentTitle(ps);
    return fitmentTitle(ps + ' · ' + ds);
  }
  function fitmentBrandMatches(a,b){
    const na = norm(a), nb = norm(b);
    if(!na || !nb) return false;
    return na === nb || (Math.min(na.length, nb.length) >= 5 && (na.includes(nb) || nb.includes(na)));
  }
  function fitmentSeriesMatches(a,b){
    const na = norm(a), nb = norm(b);
    if(!na || !nb) return true;
    return na === nb || na.includes(nb) || nb.includes(na);
  }
  function fitmentReadStore(){
    try{
      const stored = JSON.parse(localStorage.getItem(YF_FITMENT_STORAGE_KEY) || 'null');
      if(stored && stored.scopes && typeof stored.scopes === 'object') return stored;
    }catch(e){}
    return {version:3, scopes:{}};
  }
  function fitmentWriteStore(store){
    try{ localStorage.setItem(YF_FITMENT_STORAGE_KEY, JSON.stringify(store)); }
    catch(e){}
  }
  function equipmentFingerprint(value, scope){
    return [scope || fitmentCategoryScope(value && value.category), norm(value && value.brand), norm(value && value.model), norm(value && value.series), norm(value && value.serial)].join('|');
  }
  function equipmentNotify(){
    try{ document.dispatchEvent(new CustomEvent('yf:equipment-updated')); }catch(e){}
  }
  function equipmentGarageRead(){
    let garage = {version:1, items:[]};
    try{
      const stored = JSON.parse(localStorage.getItem(YF_EQUIPMENT_GARAGE_KEY) || 'null');
      if(stored && Array.isArray(stored.items)) garage = stored;
    }catch(e){}
    garage.version = 1;
    garage.items = (garage.items || []).filter(item => item && item.brand && item.model).map(item => {
      const scope = item.scope || fitmentCategoryScope(item.category);
      return Object.assign({}, item, {scope});
    });

    // Automatically bring equipment saved by the product-page fitment picker
    // into My Equipment, including visitors who saved it in an earlier theme.
    let changed = false;
    const store = fitmentReadStore();
    Object.entries(store.scopes || {}).forEach(([scope, selected]) => {
      if(!selected || !selected.brand || !selected.model) return;
      const fp = equipmentFingerprint(selected, scope);
      if(garage.items.some(item => equipmentFingerprint(item, item.scope) === fp)) return;
      garage.items.push(Object.assign({}, selected, {
        id:'yf-eq-' + Date.now().toString(36) + Math.random().toString(36).slice(2,8),
        scope,
        createdAt:Date.now(),
        updatedAt:Date.now()
      }));
      changed = true;
    });
    if(changed){
      try{ localStorage.setItem(YF_EQUIPMENT_GARAGE_KEY, JSON.stringify(garage)); }catch(e){}
    }
    return garage;
  }
  function equipmentGarageWrite(garage){
    garage = garage && Array.isArray(garage.items) ? garage : {version:1,items:[]};
    garage.version = 1;
    try{ localStorage.setItem(YF_EQUIPMENT_GARAGE_KEY, JSON.stringify(garage)); }catch(e){}
    equipmentNotify();
  }
  function equipmentGarageUpsert(value, scope){
    if(!value || !value.brand || !value.model) return null;
    scope = scope || fitmentCategoryScope(value.category);
    if(!scope) return null;
    const garage = equipmentGarageRead();
    const fp = equipmentFingerprint(value, scope);
    let item = garage.items.find(candidate => equipmentFingerprint(candidate, candidate.scope) === fp);
    if(item){
      Object.assign(item, value, {scope, updatedAt:Date.now()});
    }else{
      item = Object.assign({}, value, {
        id:'yf-eq-' + Date.now().toString(36) + Math.random().toString(36).slice(2,8),
        scope,
        createdAt:Date.now(),
        updatedAt:Date.now()
      });
      garage.items.push(item);
    }
    equipmentGarageWrite(garage);
    return item;
  }
  function equipmentGarageRemoveMatching(scope, value){
    if(!scope || !value) return;
    const garage = equipmentGarageRead();
    const fp = equipmentFingerprint(value, scope);
    const next = garage.items.filter(item => equipmentFingerprint(item, item.scope) !== fp);
    if(next.length !== garage.items.length){
      garage.items = next;
      equipmentGarageWrite(garage);
    }
  }
  function fitmentReadSaved(rows){
    const scopes = fitmentScopeKeys(rows);
    const store = fitmentReadStore();
    for(const scope of scopes){
      const selected = store.scopes && store.scopes[scope];
      if(selected && selected.brand && selected.model) return selected;
    }

    // Migrate the previous one-equipment format only when its category belongs
    // to this product's category. This avoids carrying a refrigerator selection
    // into a water-heater, furnace, awning, or other unrelated fitment picker.
    try{
      const legacy = JSON.parse(localStorage.getItem(YF_FITMENT_LEGACY_STORAGE_KEY) || 'null');
      if(legacy && legacy.brand && legacy.model && legacy.category){
        const legacyScope = fitmentCategoryScope(legacy.category);
        if(legacyScope && scopes.includes(legacyScope)){
          store.scopes[legacyScope] = legacy;
          fitmentWriteStore(store);
          localStorage.removeItem(YF_FITMENT_LEGACY_STORAGE_KEY);
          return legacy;
        }
      }
    }catch(e){}
    return null;
  }
  function fitmentSave(rows, value){
    if(!value || !value.brand || !value.model) return;
    const scopes = fitmentScopeKeys(rows);
    const scope = fitmentCategoryScope(value.category) || scopes[0];
    if(!scope) return;
    const store = fitmentReadStore();
    store.scopes[scope] = Object.assign({}, value, {scope});
    fitmentWriteStore(store);
    equipmentGarageUpsert(Object.assign({}, value, {scope}), scope);
    try{ localStorage.removeItem(YF_FITMENT_LEGACY_STORAGE_KEY); }catch(e){}
  }

  /* Collection model finders navigate immediately after selection. Save to
     both the active-fitment store and My Equipment before navigation, then
     carry the same selection in the destination URL as a cross-page fallback.
     This also survives Shopify preview/market redirects that can partition
     browser storage between preview origins. */
  function persistSelectedEquipment(value){
    if(!value || !value.brand || !value.model || !value.category) return false;
    const clean = Object.assign({}, value, {
      brand:fitmentTidy(value.brand),
      model:fitmentTidy(value.model),
      series:fitmentTidy(value.series || ''),
      serial:fitmentTidy(value.serial || ''),
      category:fitmentTidy(value.category),
      categoryIndexKey:fitmentTidy(value.categoryIndexKey || '')
    });
    const scope = fitmentCategoryScope(clean.category);
    if(!scope) return false;
    fitmentSave([{categoryLabel:clean.category}], clean);
    // Explicit second upsert is harmless and protects against older cached
    // fitmentSave implementations while Shopify swaps theme sections.
    equipmentGarageUpsert(Object.assign({}, clean, {scope}), scope);
    equipmentNotify();
    return true;
  }
  function equipmentTransferUrl(url, value){
    try{
      const next = new URL(url, location.origin);
      next.searchParams.set('yf_save_equipment','1');
      next.searchParams.set('yf_eq_brand', value.brand || '');
      next.searchParams.set('yf_eq_model', value.model || '');
      next.searchParams.set('yf_eq_series', value.series || '');
      next.searchParams.set('yf_eq_serial', value.serial || '');
      next.searchParams.set('yf_eq_category', value.category || '');
      if(value.categoryIndexKey) next.searchParams.set('yf_eq_category_key', value.categoryIndexKey);
      return next.pathname + next.search + next.hash;
    }catch(e){ return url; }
  }
  function pendingModelRouteWrite(value, lookup){
    if(!value || !value.model) return;
    try{
      sessionStorage.setItem(YF_PENDING_MODEL_ROUTE_KEY, JSON.stringify({
        lookup:fitmentTidy(lookup || value.serial || value.model),
        model:fitmentTidy(value.model),
        brand:fitmentTidy(value.brand || ''),
        category:fitmentTidy(value.category || ''),
        categoryIndexKey:fitmentTidy(value.categoryIndexKey || ''),
        timestamp:Date.now()
      }));
    }catch(e){}
  }
  function restorePendingModelRoute(){
    if(!/\/search\/?$/i.test(location.pathname || '')) return null;
    let params;
    try{ params = new URLSearchParams(location.search || ''); }catch(e){ return null; }
    let pending = null;
    try{ pending = JSON.parse(sessionStorage.getItem(YF_PENDING_MODEL_ROUTE_KEY) || 'null'); }catch(e){}
    const now = Date.now();
    const recent = pending && pending.timestamp && (now - Number(pending.timestamp) < 120000);
    const currentQuery = fitmentTidy(params.get('q') || '');
    const pendingLookup = fitmentTidy(pending && (pending.lookup || pending.model) || '');
    const pendingMatches = !!(recent && pendingLookup && currentQuery && norm(pendingLookup) === norm(currentQuery));
    const hashForcesModel = /(?:^#|[#&])yf-model-match(?:=1)?(?:&|$)/i.test(location.hash || '');
    const explicitModel = params.get('yf_native') === '1' && (params.get('yf_force') || '').toLowerCase() === 'model';
    if(!explicitModel && !hashForcesModel && !pendingMatches) return null;

    const lookup = currentQuery || pendingLookup;
    if(!lookup) return null;
    params.set('q', lookup);
    params.set('type', 'product');
    params.set('options[prefix]', 'last');
    params.set('yf_native', '1');
    params.set('view', 'yf-model-match');
    params.set('yf_force', 'model');
    params.set('yf_model_key', norm(lookup));
    if(!params.get('yf_brand') && pending && pending.brand) params.set('yf_brand', pending.brand);
    if(!params.get('yf_category') && pending && pending.category) params.set('yf_category', pending.category);

    const nextModelUrl = location.pathname + '?' + params.toString() + (location.hash || '#yf-model-match');
    const redirectGuardKey = 'yf_model_match_template_redirect:' + norm(lookup);
    const needsModelTemplate = (new URLSearchParams(location.search || '')).get('view') !== 'yf-model-match';
    let alreadyRedirected = false;
    try{ alreadyRedirected = sessionStorage.getItem(redirectGuardKey) === '1'; }catch(e){}

    /* Model matches use a dedicated Shopify search template that contains only
       the YF Native Database App. Legacy links that land on the default search
       template are replaced once so Shopify's normal product grid never renders. */
    if(needsModelTemplate && !alreadyRedirected){
      try{ sessionStorage.setItem(redirectGuardKey, '1'); }catch(e){}
      location.replace(nextModelUrl);
      window.__YF_PENDING_MODEL_ROUTE__ = pending || {lookup:lookup};
      return pending || {lookup:lookup};
    }
    try{ sessionStorage.removeItem(redirectGuardKey); }catch(e){}
    try{
      history.replaceState(history.state || {}, '', nextModelUrl);
    }catch(e){}
    if(pendingMatches){ try{ sessionStorage.removeItem(YF_PENDING_MODEL_ROUTE_KEY); }catch(e){} }
    window.__YF_PENDING_MODEL_ROUTE__ = pending || {lookup:lookup};
    return pending || {lookup:lookup};
  }
  restorePendingModelRoute();

  function importTransferredEquipment(){
    let params;
    try{ params = new URLSearchParams(location.search); }catch(e){ return; }
    if(params.get('yf_save_equipment') !== '1') return;
    const selected = {
      brand:params.get('yf_eq_brand') || '',
      model:params.get('yf_eq_model') || '',
      series:params.get('yf_eq_series') || '',
      serial:params.get('yf_eq_serial') || '',
      category:params.get('yf_eq_category') || '',
      categoryIndexKey:params.get('yf_eq_category_key') || ''
    };
    if(!persistSelectedEquipment(selected)) return;
    ['yf_save_equipment','yf_eq_brand','yf_eq_model','yf_eq_series','yf_eq_serial','yf_eq_category','yf_eq_category_key'].forEach(key=>params.delete(key));
    try{
      const query = params.toString();
      history.replaceState(history.state || {}, '', location.pathname + (query ? '?' + query : '') + location.hash);
    }catch(e){}
  }
  importTransferredEquipment();
  function fitmentClear(rows){
    try{
      const store = fitmentReadStore();
      fitmentScopeKeys(rows).forEach(scope => {
        const selected = store.scopes && store.scopes[scope];
        if(selected) equipmentGarageRemoveMatching(scope, selected);
        delete store.scopes[scope];
      });
      if(Object.keys(store.scopes || {}).length) fitmentWriteStore(store);
      else localStorage.removeItem(YF_FITMENT_STORAGE_KEY);
      localStorage.removeItem(YF_FITMENT_LEGACY_STORAGE_KEY);
      equipmentNotify();
    }catch(e){}
  }
  function fitmentEquipmentLabel(v){
    if(!v) return '';
    return [v.brand, v.model, v.series, v.serial].filter(Boolean).join(' · ');
  }
  function preparePartFitmentRows(rows){
    return (rows || []).map(row => {
      const parsed = fitmentParseBrand(row.brand);
      return Object.assign({}, row, {
        brandLabel: parsed.brand || fitmentTidy(row.brand),
        seriesLabel: parsed.series || '',
        modelLabel: fitmentTidy(row.model),
        serialLabel: fitmentTidy(row.serial),
        categoryLabel: fitmentTidy(row.category)
      });
    }).filter(row => row.brandLabel && row.modelLabel);
  }

  // A Shopify product can represent an old number, a current replacement, or
  // one member of a supersession family. Model-match pages already treat every
  // number in that family as the same available replacement. Product-page
  // fitment must use the same rule or it can incorrectly say "does not fit"
  // while the selected model page lists the product as available.
  function fitmentPartSeeds(value){
    const raw = fitmentTidy(value);
    if(!raw) return [];
    const pieces = raw.split(/\s*(?:,|;|\||\r?\n)\s*|\s+\/\s+/).map(norm).filter(Boolean);
    const fallback = norm(raw);
    if(!pieces.length && fallback) pieces.push(fallback);
    return Array.from(new Set(pieces));
  }
  async function fitmentEquivalentPartNumbers(value){
    const seeds = fitmentPartSeeds(value);
    const out = [];
    const seen = new Set();
    const add = partNumber => {
      const key = norm(partNumber);
      if(key && !seen.has(key)){ seen.add(key); out.push(key); }
    };
    for(const seed of seeds){
      add(seed);
      try{
        const chain = await supersessionChain(seed);
        [chain && chain.searched, ...(chain && chain.forward || []), ...(chain && chain.reverse || [])].forEach(add);
      }catch(e){}
    }
    return out;
  }
  async function fitmentRowsForPartFamily(value){
    const partNumbers = await fitmentEquivalentPartNumbers(value);
    const groups = await Promise.all(partNumbers.map(async partNumber => {
      let rows = [];
      let compatibleModels = [];
      let partRecord = null;
      try{ rows = await db.fitment(partNumber); }catch(e){}
      try{ compatibleModels = await db.partModelCompat(partNumber); }catch(e){}
      try{ partRecord = await db.part(partNumber); }catch(e){}

      /* The product-page “Fits these models” block and model-number match page
         use the reverse part-to-model index plus the part record's used[] list.
         Include those same model relationships in Check Fitment. Otherwise a
         product can visibly list a model as compatible yet incorrectly return
         “does not fit” when its detailed serial rows are incomplete. */
      const broadRows = [];
      const addBroad = source => {
        if(!source) return;
        const model = Array.isArray(source) ? source[0] : (source.model || source.m || source.modelNumber);
        const brand = Array.isArray(source) ? (source[1] || '') : (source.brand || source.b || '');
        const category = Array.isArray(source) ? (source[2] || '') : (source.category || source.c || '');
        if(!fitmentTidy(model)) return;
        broadRows.push({brand, model, serial:'', category, exact:true, modelCompatibility:true});
      };
      (compatibleModels || []).forEach(addBroad);
      (partRecord && partRecord.used || []).forEach(addBroad);

      return {partNumber, rows:(rows || []).concat(broadRows)};
    }));
    const merged = new Map();
    groups.forEach(group => {
      (group.rows || []).forEach(row => {
        const key = [norm(row.brand), norm(row.model), norm(row.serial), norm(row.category)].join('|');
        if(!key.replace(/\|/g,'')) return;
        const current = merged.get(key);
        if(current){
          current.exact = !!(current.exact || row.exact);
          current.modelCompatibility = !!(current.modelCompatibility || row.modelCompatibility);
          if(!current.matchedPartNumbers.includes(group.partNumber)) current.matchedPartNumbers.push(group.partNumber);
        }else{
          merged.set(key, Object.assign({}, row, {matchedPartNumbers:[group.partNumber]}));
        }
      });
    });
    return {partNumbers, rows:Array.from(merged.values())};
  }

  // The reverse part-number index already tells us what type of equipment a
  // part belongs to. Keep each fitment picker inside that category instead of
  // loading every appliance and RV component in the database.
  const YF_FITMENT_CATEGORY_ALIASES = {
    COOKTOP: ['RANGE', 'OVENRANGE'],
    RANGEHOOD: ['RANGE', 'OVENRANGE'],
    AWNINGHARDWARE: ['AWNING', 'MOULDING'],
    JACKSLANDINGGEAR: ['LEVELINGSYSTEMS', 'STABILIZERS'],
    'JACKS&LANDINGGEAR': ['LEVELINGSYSTEMS', 'STABILIZERS'],
    SATELLITESYSTEMS: ['ANTENNA', 'RADIOSATELLITE'],
    INVERTERCHARGER: ['CONVERTER', 'CONVERTERINVERTER']
  };
  function fitmentCategoryFamily(value){
    const first = norm(value);
    const family = new Set();
    const queue = first ? [first] : [];
    const graph = Object.entries(YF_FITMENT_CATEGORY_ALIASES).map(([source, aliases]) => [norm(source), (aliases || []).map(norm)]);
    while(queue.length){
      const current = queue.shift();
      if(!current || family.has(current)) continue;
      family.add(current);
      graph.forEach(([source, aliases]) => {
        if(source === current || aliases.includes(current)){
          if(!family.has(source)) queue.push(source);
          aliases.forEach(alias => { if(alias && !family.has(alias)) queue.push(alias); });
        }
      });
    }
    return family;
  }
  function fitmentCategoryScope(value){
    return Array.from(fitmentCategoryFamily(value)).sort().join('|');
  }
  function fitmentScopeKeys(rows){
    return Array.from(new Set((rows || []).map(row => fitmentCategoryScope(row.categoryLabel || row.category)).filter(Boolean))).sort();
  }
  function fitmentCategoryMatches(a,b){
    const left = fitmentCategoryFamily(a);
    const right = fitmentCategoryFamily(b);
    if(!left.size || !right.size) return false;
    for(const key of left){ if(right.has(key)) return true; }
    return false;
  }
  function fitmentAllowedCategoryKeys(rows){
    const allowed = new Set();
    (rows || []).forEach(row => {
      fitmentCategoryFamily(row.categoryLabel || row.category).forEach(key => allowed.add(key));
    });
    return allowed;
  }
  function categoryRecordMatches(key, category, allowed){
    return [key, category && category.displayName, category && category.category].some(value => {
      const family = fitmentCategoryFamily(value);
      for(const candidate of family){ if(allowed.has(candidate)) return true; }
      return false;
    });
  }
  function evaluatePartFitment(rows, selected){
    if(!selected || !selected.brand || !selected.model) return {state:'neutral'};

    /* The selectable equipment list is built from this part's category only.
       Do not turn a completed check back into the neutral state merely because
       one source says "Refrigerator" and another says "Refrigerators". */
    const modelRows = rows.filter(row => fitmentBrandMatches(row.brandLabel, selected.brand) && norm(row.modelLabel) === norm(selected.model));
    if(!modelRows.length) return {state:'no'};
    const seriesRows = modelRows.filter(row => fitmentSeriesMatches(row.seriesLabel, selected.series));
    if(!seriesRows.length) return {state:'no'};
    const broad = seriesRows.find(row => !row.serialLabel);
    if(broad) return {state:'yes', exact:!!broad.exact};
    if(!selected.serial) return {state:'partial'};
    const exactSerial = seriesRows.find(row => norm(row.serialLabel) === norm(selected.serial));
    return exactSerial ? {state:'yes', exact:!!exactSerial.exact} : {state:'no'};
  }

  function addFitmentRecord(brands, rawBrand, series, modelLabel, serials, categoryLabel){
    const parsed = fitmentParseBrand(rawBrand);
    if(!parsed.brand || !modelLabel) return;
    const brandKey = norm(parsed.brand);
    const brand = brands[brandKey] || (brands[brandKey] = {key:brandKey, label:parsed.brand, models:{}});
    const modelKey = norm(modelLabel);
    if(!modelKey) return;
    const model = brand.models[modelKey] || (brand.models[modelKey] = {key:modelKey, label:modelLabel, records:[]});
    const cleanSerials = Array.from(new Set((serials || []).map(fitmentTidy).filter(Boolean)));
    const recordKey = [norm(series), cleanSerials.map(norm).sort().join(','), norm(categoryLabel)].join('|');
    if(!model.records.some(item => item.key === recordKey)){
      model.records.push({key:recordKey, series:fitmentTidy(series), serials:cleanSerials, category:fitmentTidy(categoryLabel)});
    }
  }

  async function globalFitmentEquipment(rows){
    const allowed = fitmentAllowedCategoryKeys(rows);
    const cacheKey = Array.from(allowed).sort().join('|') || 'PART-ROWS-ONLY';
    if(yfGlobalEquipmentPromises[cacheKey]) return yfGlobalEquipmentPromises[cacheKey];
    yfGlobalEquipmentPromises[cacheKey] = (async () => {
      const categories = await db.categoryModels();
      const brands = {};
      let matchedCategoryCount = 0;
      Object.entries(categories || {}).forEach(([categoryKey, category]) => {
        if(!categoryRecordMatches(categoryKey, category, allowed)) return;
        matchedCategoryCount += 1;
        const categoryLabel = fitmentTidy(category.displayName || category.category || categoryKey);
        Object.entries(category && category.manufacturers || {}).forEach(([rawBrand, manufacturer]) => {
          const parsed = fitmentParseBrand(rawBrand);
          Object.entries(manufacturer && manufacturer.series || {}).forEach(([dbSeries, models]) => {
            const series = fitmentSeriesLabel(parsed.series, dbSeries);
            (models || []).forEach(modelRec => {
              addFitmentRecord(
                brands,
                rawBrand,
                series,
                fitmentTidy(modelRec && modelRec.modelNumber),
                (modelRec && modelRec.serials) || [],
                categoryLabel
              );
            });
          });
        });
      });

      // Unknown or newly-added category names must never fall back to the full
      // database. Build a safe picker from this part's own compatibility rows.
      if(!matchedCategoryCount){
        (rows || []).forEach(row => {
          addFitmentRecord(
            brands,
            row.brandLabel || row.brand,
            row.seriesLabel,
            row.modelLabel,
            row.serialLabel ? [row.serialLabel] : [],
            row.categoryLabel || row.category
          );
        });
      }

      const brandList = Object.values(brands).sort((a,b)=>a.label.localeCompare(b.label, undefined, {numeric:true, sensitivity:'base'}));
      brandList.forEach(brand => {
        brand.modelList = Object.values(brand.models).sort((a,b)=>a.label.localeCompare(b.label, undefined, {numeric:true, sensitivity:'base'}));
      });
      return {
        brands,
        brandList,
        categoryLabels: Array.from(new Set((rows || []).map(row => row.categoryLabel || row.category).filter(Boolean)))
      };
    })();
    return yfGlobalEquipmentPromises[cacheKey];
  }

  function fitmentIcon(){
    return '<svg viewBox="0 0 64 48" aria-hidden="true"><path d="M8 10h34c7 0 12 4 14 10l2 7v11h-6a7 7 0 0 1-14 0H25a7 7 0 0 1-14 0H6V16c0-3 1-6 2-6Zm4 5v13h39l-2-7c-1-4-4-6-8-6H12Zm6 18a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm27 0a5 5 0 1 0 0 10 5 5 0 0 0 0-10ZM17 18h10v8H17v-8Zm14 0h10v8H31v-8Z"/></svg>';
  }
  function fitmentShell(part){
    return '<div class="yf-fitment-card" data-yf-fitment-card>'
      + '<div class="yf-fitment-icon">'+fitmentIcon()+'</div>'
      + '<div class="yf-fitment-copy"><strong data-yf-fitment-title>Check if this part fits</strong><span data-yf-fitment-detail>Select your appliance or RV component.</span><a class="yf-fitment-parts" data-yf-fitment-parts href="#" hidden>View available parts</a></div>'
      + '<button type="button" class="yf-fitment-open" data-yf-fitment-open aria-haspopup="dialog" aria-expanded="false">Check fitment</button>'
      + '</div>'
      + '<div class="yf-fitment-modal" data-yf-fitment-modal hidden>'
      + '<button type="button" class="yf-fitment-backdrop" data-yf-fitment-close tabindex="-1" aria-label="Close fitment"></button>'
      + '<section class="yf-fitment-dialog" role="dialog" aria-modal="true" aria-labelledby="yf-fitment-heading-'+esc(norm(part))+'">'
      + '<header class="yf-fitment-dialog-head"><div><p>Make sure it fits</p><h2 id="yf-fitment-heading-'+esc(norm(part))+'">Check fitment</h2></div><button type="button" class="yf-fitment-close" data-yf-fitment-close aria-label="Close">×</button></header>'
      + '<div class="yf-fitment-dialog-body">'
      + '<p class="yf-fitment-instruction">Select the information shown on your appliance or RV component label.</p>'
      + '<div class="yf-fitment-loading" data-yf-fitment-loading>Loading fitment options…</div>'
      + '<div class="yf-fitment-fields" data-yf-fitment-fields hidden>'
      + '<label><span>Brand</span><select data-yf-fitment-brand><option value="">Select brand</option></select></label>'
      + '<label data-yf-fitment-model-field hidden><span>Model</span><select data-yf-fitment-model><option value="">Select model</option></select></label>'
      + '<label data-yf-fitment-series-field hidden><span>Series</span><select data-yf-fitment-series><option value="">Select series</option></select></label>'
      + '<label data-yf-fitment-serial-field hidden><span>Serial / product number</span><select data-yf-fitment-serial><option value="">Select serial / product number</option></select><small>Use the number from the manufacturer label, not your RV VIN.</small></label>'
      + '</div>'
      + '<div class="yf-fitment-result" data-yf-fitment-result hidden></div>'
      + '<button type="button" class="yf-fitment-confirm" data-yf-fitment-confirm disabled>Confirm fitment</button>'
      + '<button type="button" class="yf-fitment-clear" data-yf-fitment-clear hidden>Clear saved equipment</button>'
      + '<p class="yf-fitment-note">Your selection is saved in this browser and reused for other parts in the same category.</p>'
      + '</div></section></div>';
  }

  function renderFitmentCard(root, rows, selected){
    const title = root.querySelector('[data-yf-fitment-title]');
    const detail = root.querySelector('[data-yf-fitment-detail]');
    const button = root.querySelector('[data-yf-fitment-open]');
    const partsLink = root.querySelector('[data-yf-fitment-parts]');
    const card = root.querySelector('[data-yf-fitment-card]');
    const outcome = evaluatePartFitment(rows, selected);
    const partsUrl = fitmentAvailablePartsUrl(selected);
    if(partsLink){
      partsLink.hidden = !partsUrl;
      partsLink.href = partsUrl || '#';
      partsLink.textContent = selected && (selected.serial || selected.model) ? 'View available parts' : 'View available parts';
    }
    card.classList.remove('is-fit','is-no-fit','is-partial');
    if(outcome.state === 'yes'){
      card.classList.add('is-fit'); title.textContent = 'This part fits'; detail.textContent = fitmentEquipmentLabel(selected); button.textContent = 'Change';
    }else if(outcome.state === 'no'){
      card.classList.add('is-no-fit'); title.textContent = 'This part does not fit'; detail.textContent = fitmentEquipmentLabel(selected); button.textContent = 'Change equipment';
    }else if(outcome.state === 'partial'){
      card.classList.add('is-partial'); title.textContent = 'Finish checking fitment'; detail.textContent = fitmentEquipmentLabel(selected); button.textContent = 'Finish check';
    }else{
      title.textContent = 'Check if this part fits'; detail.textContent = 'Select your appliance or RV component.'; button.textContent = 'Check fitment';
    }
  }

  function initProductFitmentWidgets(){
    document.querySelectorAll('[data-yf-product-fitment]').forEach(async root => {
      if(root.dataset.bound) return;
      root.dataset.bound = '1';
      const part = root.dataset.part || '';
      if(!part){ root.remove(); return; }
      const familyFitment = await fitmentRowsForPartFamily(part);
      const familyPartNumbers = new Set(familyFitment.partNumbers || []);
      let rows = preparePartFitmentRows(familyFitment.rows);
      rows = rows.filter(row => !familyPartNumbers.has(norm(row.modelLabel)));
      if(!rows.length){ root.remove(); return; }
      root.dataset.fitmentPartNumbers = Array.from(familyPartNumbers).join(',');
      root.innerHTML = fitmentShell(part);
      root.hidden = false;

      const modal = root.querySelector('[data-yf-fitment-modal]');
      const openButton = root.querySelector('[data-yf-fitment-open]');
      const partsLink = root.querySelector('[data-yf-fitment-parts]');
      const brandSelect = root.querySelector('[data-yf-fitment-brand]');
      const modelSelect = root.querySelector('[data-yf-fitment-model]');
      const seriesSelect = root.querySelector('[data-yf-fitment-series]');
      const serialSelect = root.querySelector('[data-yf-fitment-serial]');
      const modelField = root.querySelector('[data-yf-fitment-model-field]');
      const seriesField = root.querySelector('[data-yf-fitment-series-field]');
      const serialField = root.querySelector('[data-yf-fitment-serial-field]');
      const loading = root.querySelector('[data-yf-fitment-loading]');
      const fields = root.querySelector('[data-yf-fitment-fields]');
      const confirm = root.querySelector('[data-yf-fitment-confirm]');
      const result = root.querySelector('[data-yf-fitment-result]');
      const clear = root.querySelector('[data-yf-fitment-clear]');
      let equipment = null;
      let activeBrand = null;
      let activeModel = null;
      let seriesRequired = false;
      let serialRequired = false;

      function setResult(outcome, selected){
        result.hidden = false;
        result.className = 'yf-fitment-result ' + (outcome.state === 'yes' ? 'is-fit' : outcome.state === 'partial' ? 'is-partial' : 'is-no-fit');
        if(outcome.state === 'yes'){
          result.innerHTML = '<strong>Yes — this part fits.</strong><span>'+esc(fitmentEquipmentLabel(selected))+'</span>';
        }else if(outcome.state === 'partial'){
          result.innerHTML = '<strong>More information is needed.</strong><span>'+esc(fitmentEquipmentLabel(selected))+'</span>';
        }else{
          result.innerHTML = '<strong>No — this part is not listed as fitting.</strong><span>'+esc(fitmentEquipmentLabel(selected))+'</span>';
        }
      }
      function selectedValue(){
        const brand = activeBrand && activeBrand.label || '';
        const model = activeModel && activeModel.label || '';
        const series = seriesField.hidden ? '' : (seriesSelect.options[seriesSelect.selectedIndex] && seriesSelect.options[seriesSelect.selectedIndex].text || '');
        const serial = serialField.hidden ? '' : (serialSelect.options[serialSelect.selectedIndex] && serialSelect.options[serialSelect.selectedIndex].text || '');
        let records = activeModel && activeModel.records ? activeModel.records.slice() : [];
        if(seriesSelect.value) records = records.filter(record => fitmentSeriesMatches(record.series, series));
        if(serialSelect.value) records = records.filter(record => (record.serials || []).some(value => norm(value) === norm(serial)));
        const category = (records[0] && records[0].category) || (equipment && equipment.categoryLabels && equipment.categoryLabels[0]) || '';
        return {brand, model, series: seriesSelect.value ? series : '', serial: serialSelect.value ? serial : '', category};
      }
      function updateConfirm(){
        confirm.disabled = !activeBrand || !activeModel || (seriesRequired && !seriesSelect.value) || (serialRequired && !serialSelect.value);
      }
      function resetBelow(level){
        result.hidden = true;
        if(level <= 1){ modelSelect.innerHTML='<option value="">Select model</option>'; modelField.hidden=true; activeModel=null; }
        if(level <= 2){ seriesSelect.innerHTML='<option value="">Select series</option>'; seriesField.hidden=true; seriesRequired=false; }
        if(level <= 3){ serialSelect.innerHTML='<option value="">Select serial / product number</option>'; serialField.hidden=true; serialRequired=false; }
        updateConfirm();
      }
      function rebuildSerials(){
        serialSelect.innerHTML='<option value="">Select serial / product number</option>';
        serialField.hidden=true; serialRequired=false;
        if(!activeModel) return updateConfirm();
        let records = activeModel.records || [];
        if(!seriesField.hidden && seriesSelect.value){ records = records.filter(rec => norm(rec.series) === seriesSelect.value); }
        const serials = Array.from(new Set(records.flatMap(rec => rec.serials || []).filter(Boolean))).sort((a,b)=>a.localeCompare(b, undefined, {numeric:true, sensitivity:'base'}));
        if(serials.length){
          serials.forEach(serial => serialSelect.insertAdjacentHTML('beforeend','<option value="'+esc(norm(serial))+'">'+esc(serial)+'</option>'));
          serialField.hidden=false; serialRequired=true;
          if(serials.length === 1) serialSelect.value = norm(serials[0]);
        }
        updateConfirm();
      }
      function rebuildSeries(){
        seriesSelect.innerHTML='<option value="">Select series</option>';
        seriesField.hidden=true; seriesRequired=false;
        if(!activeModel) return rebuildSerials();
        const series = Array.from(new Set((activeModel.records || []).map(rec => fitmentTidy(rec.series)).filter(Boolean))).sort((a,b)=>a.localeCompare(b, undefined, {numeric:true, sensitivity:'base'}));
        if(series.length){
          series.forEach(value => seriesSelect.insertAdjacentHTML('beforeend','<option value="'+esc(norm(value))+'">'+esc(value)+'</option>'));
          seriesField.hidden=false; seriesRequired=true;
          if(series.length === 1) seriesSelect.value = norm(series[0]);
        }
        rebuildSerials();
      }
      function chooseBrand(key){
        activeBrand = equipment && equipment.brands[key] || null;
        resetBelow(1);
        if(!activeBrand) return;
        activeBrand.modelList.forEach(model => modelSelect.insertAdjacentHTML('beforeend','<option value="'+esc(model.key)+'">'+esc(model.label)+'</option>'));
        modelField.hidden=false;
        updateConfirm();
      }
      function chooseModel(key){
        activeModel = activeBrand && activeBrand.models[key] || null;
        resetBelow(2);
        rebuildSeries();
      }
      function prefill(saved){
        if(!saved || !equipment) return;
        const brand = equipment.brandList.find(item => fitmentBrandMatches(item.label, saved.brand));
        if(!brand) return;
        brandSelect.value = brand.key; chooseBrand(brand.key);
        const model = brand.modelList.find(item => norm(item.label) === norm(saved.model));
        if(!model) return;
        modelSelect.value = model.key; chooseModel(model.key);
        if(saved.series && !seriesField.hidden){
          const option = Array.from(seriesSelect.options).find(opt => fitmentSeriesMatches(opt.text, saved.series) && opt.value);
          if(option){ seriesSelect.value = option.value; rebuildSerials(); }
        }
        if(saved.serial && !serialField.hidden){
          const option = Array.from(serialSelect.options).find(opt => norm(opt.text) === norm(saved.serial));
          if(option) serialSelect.value = option.value;
        }
        updateConfirm();
      }
      async function ensureOptions(){
        if(equipment) return;
        loading.hidden=false; fields.hidden=true;
        equipment = await globalFitmentEquipment(rows);
        brandSelect.innerHTML='<option value="">Select brand</option>' + equipment.brandList.map(brand => '<option value="'+esc(brand.key)+'">'+esc(brand.label)+'</option>').join('');
        loading.hidden=true; fields.hidden=false;
        prefill(fitmentReadSaved(rows));
      }
      let fitmentReturnParent = root;
      let fitmentOpen = false;
      async function openModal(){
        if(!document.body || fitmentOpen) return;
        fitmentOpen = true;
        fitmentReturnParent = root;
        // Portal the modal to <body> while open. Product sections and Shopify's
        // mobile editor preview can apply transforms/overflow to section wrappers;
        // a fixed modal inside those wrappers is otherwise clipped or offset.
        if(modal.parentNode !== document.body) document.body.appendChild(modal);
        modal.hidden=false;
        openButton.setAttribute('aria-expanded','true');
        document.body.classList.add('yf-fitment-modal-open');
        try{
          await ensureOptions();
          if(!modal.isConnected) return;
          clear.hidden = !fitmentReadSaved(rows);
          setTimeout(()=>{ if(!modal.hidden && brandSelect) brandSelect.focus(); }, 30);
        }catch(error){
          loading.hidden=false;
          fields.hidden=true;
          loading.textContent='Fitment options could not be loaded. Please close this window and try again.';
          confirm.disabled=true;
        }
      }
      function closeModal(){
        if(!fitmentOpen && modal.hidden) return;
        fitmentOpen = false;
        modal.hidden=true;
        openButton.setAttribute('aria-expanded','false');
        if(!document.querySelector('.yf-fitment-modal:not([hidden])')) document.body.classList.remove('yf-fitment-modal-open');
        if(fitmentReturnParent && fitmentReturnParent.isConnected) fitmentReturnParent.appendChild(modal);
        else modal.remove();
        if(openButton && openButton.isConnected) openButton.focus();
      }

      brandSelect.addEventListener('change',()=>chooseBrand(brandSelect.value));
      modelSelect.addEventListener('change',()=>chooseModel(modelSelect.value));
      seriesSelect.addEventListener('change',()=>{ result.hidden=true; rebuildSerials(); });
      serialSelect.addEventListener('change',()=>{ result.hidden=true; updateConfirm(); });
      openButton.addEventListener('click',openModal);
      if(partsLink){
        partsLink.addEventListener('click', function(event){
          if(!partsLink.href || partsLink.getAttribute('href') === '#'){ event.preventDefault(); return; }
          fitmentRememberReturnPosition(root);
        });
      }
      root.querySelectorAll('[data-yf-fitment-close]').forEach(button => button.addEventListener('click',closeModal));
      document.addEventListener('shopify:section:unload',(event)=>{
        const unloadingThisSection = !!(event && event.target && event.target.contains && event.target.contains(root));
        if((unloadingThisSection || !root.isConnected) && modal.isConnected){
          fitmentOpen=false;
          modal.remove();
          if(!document.querySelector('.yf-fitment-modal:not([hidden])')) document.body.classList.remove('yf-fitment-modal-open');
        }
      });
      confirm.addEventListener('click',()=>{
        const selected = selectedValue();
        const outcome = evaluatePartFitment(rows, selected);
        fitmentSave(rows, selected);
        clear.hidden=false;
        renderFitmentCard(root, rows, selected);
        setResult(outcome, selected);
        closeModal();
      });
      clear.addEventListener('click',()=>{
        fitmentClear(rows); activeBrand=null; activeModel=null; brandSelect.value=''; resetBelow(1); clear.hidden=true; result.hidden=true; renderFitmentCard(root, rows, null);
      });
      document.addEventListener('keydown', e => { if(e.key === 'Escape' && !modal.hidden) closeModal(); });
      renderFitmentCard(root, rows, fitmentReadSaved(rows));
    });
  }

  async function initProductWidgets(){
    document.querySelectorAll('[data-yf-product-compat]').forEach(async root => {
      if(root.dataset.bound) return;
      root.dataset.bound = '1';
      const lookupNo = root.dataset.part || root.dataset.sku;
      root.hidden = true;
      if(!lookupNo){ root.innerHTML = ''; return; }

      // Product-page compatibility has two modes:
      // 1) If the extracted number is a model number, show the same model-match experience
      //    customers see in native search, but without the recommended collection block.
      // 2) If the extracted number is a part number, show only the Fits these models grid.
      // Check model first so complete units using model numbers do not get hidden as non-part matches.
      let model = await db.model(lookupNo);
      if(!model){
        const possiblePart = await db.part(lookupNo);
        if(!possiblePart){
          model = await bestModelForQuery(lookupNo);
        }
      }
      if(model){
        model._allDiagrams = await allDiagramSummariesForModel(model);
        const serialAware = modelHasSerialHierarchy(model);
        const completeId = 'yf-product-compat-complete-products-' + norm(lookupNo);
        const partsId = 'yf-product-compat-model-products-' + norm(lookupNo);
        let html = '<div class="yf-product-model-match-widget">' + modelIntro(model, serialAware);
        if(serialAware){
          html += serialPickerHtml(model);
          html += '<section class="yf-panel yf-soft"><h2>Choose a serial before we show parts</h2><p>This model has serial-specific breakdowns. We hide complete units, replacement parts, and diagram choices until a serial is selected so customers do not buy parts from the wrong production run.</p></section>';
        }else{
          html += breakdownPreview(model);
          html += productPlaceholder(completeId, 'Complete units', '');
          html += productPlaceholder(partsId, 'Available replacement parts for this model', '');
        }
        html += '</div>';
        root.hidden = false;
        root.innerHTML = html;
        initSerialSelectors(root);
        bindDiagramInteractions(root);
        hydrateProducts(root).catch(function(){});
        if(!serialAware){
          lazyLoadModelProducts(root, model, lookupNo, {
            currentHandle: root.dataset.handle || '',
            completePanelId: completeId,
            modelPanelId: partsId
          });
        }
        return;
      }

      // For part-number products, show every compatible model tied to this exact
      // yf_extracted_data.part_number. Do not use supersession here. A product
      // can have no supersession but still fit many models. Also do not require
      // db.part(lookupNo) to exist, because some exact compatibility rows only
      // exist in the reverse part->model index.
      const compatibleModels = (await compatibleModelRowsForExactPartNumber(lookupNo)).slice(0,640);
      if(compatibleModels.length){
        root.hidden = false;
        root.innerHTML = '<section class="yf-panel yf-product-compat-box yf-product-compat-models-only"><h2>Fits these models</h2><p class="yf-product-compat-subheading">Click your model number to view complete units, part breakdowns and all available parts for your model</p><div class="yf-model-list yf-compat-model-grid">'
          + compatibleModels.map(u => '<a class="yf-model-link" href="'+nativeModelSearchUrl(u)+'"><strong>'+esc(u[0])+'</strong></a>').join('')
          + '</div></section>';
        return;
      }
      root.hidden = true;
      root.innerHTML = '';
    });
  }
  // V21: category breakdown selector is a true cascade: manufacturer -> series only when needed -> model -> serial only when needed.
  // It also parses raw database brand values like "Flojet Fresh Water" into Manufacturer="Flojet" and Series="Fresh Water".
  const YF_MANUFACTURER_NAMES = [
    'Lippert Components','Aqua-Hot','Duo-Therm','Suburban','Dometic','Atwood','Flojet','Jabsco','SHURflo','Shurflo','Remco','Thetford','WFCO','Norcold','Coleman','Carefree','Furrion','Dexter','Camco','Valterra','Sealand','Marshall Excelsior'
  ];
  function tidyLabel(v){ return String(v || '').replace(/\u00A0/g,' ').replace(/\s+/g,' ').trim(); }
  function titleCaseSmart(v){
    let s = tidyLabel(v);
    const fixes = {'shurflo':'SHURflo','wfco':'WFCO','aqua-hot':'Aqua-Hot','duo-therm':'Duo-Therm','rv':'RV','nt':'NT','sf':'SF','rm':'RM'};
    return s.split(' ').map(w => fixes[w.toLowerCase()] || (w ? w[0].toUpperCase()+w.slice(1) : w)).join(' ');
  }
  function parseCategoryManufacturer(raw){
    const original = tidyLabel(raw);
    const upper = original.toUpperCase();
    for(const known of YF_MANUFACTURER_NAMES.sort((a,b)=>b.length-a.length)){
      const ku = known.toUpperCase();
      if(upper === ku || upper.startsWith(ku + ' ')){
        return {manufacturer:titleCaseSmart(known), parsedSeries:tidyLabel(original.slice(known.length))};
      }
    }
    const words = original.split(' ').filter(Boolean);
    return {manufacturer:titleCaseSmart(words.shift() || original), parsedSeries:tidyLabel(words.join(' '))};
  }
  function displaySeriesName(parsedSeries, dbSeries){
    const ps = tidyLabel(parsedSeries);
    const ds = tidyLabel(dbSeries);
    if(!ps && (!ds || /^other$/i.test(ds))) return 'All models';
    if(ps && (!ds || /^other$/i.test(ds))) return ps;
    if(!ps) return titleCaseSmart(ds);
    if(norm(ps) === norm(ds) || norm(ps).includes(norm(ds)) || norm(ds).includes(norm(ps))) return ps;
    return ps + ' · ' + ds;
  }
  function selectorContextFrom(root, c){
    const params = new URLSearchParams(location.search);
    return plain([
      root && root.dataset && root.dataset.categoryQuery,
      params.get('q'),
      c && c.collectionHandle,
      c && c.displayName,
      c && c.category,
      location.pathname
    ].filter(Boolean).join(' '));
  }
  function selectorFamilyFilter(root, c){
    const ctx = selectorContextFrom(root, c);
    const handle = plain(c && c.collectionHandle || '');
    const display = plain(c && c.displayName || '');
    const category = plain(c && c.category || '');
    const rule = referringRuleForQuery([ctx, handle, display, category].filter(Boolean).join(' '));
    const allow = new Set((rule && rule.selectorAllow || []).map(plain).filter(Boolean));
    const block = new Set((rule && rule.selectorBlock || []).map(plain).filter(Boolean));

    // Extra safety for categories that share a broad database category but are different real customer intents.
    if(handle.includes('pompes') || display.includes('water pump') || ctx.includes('water pump') || ctx === 'pump' || ctx === 'pumps'){
      ['vacuum','central vacuum','dometic vacuum'].forEach(x=>block.add(x));
      ['fresh water','waste water','water pump','flojet','jabsco','shurflo','shur flo','remco','thetford','wfco','lippert'].forEach(x=>allow.add(x));
    }
    if(handle.includes('vacuum') || display.includes('vacuum') || ctx.includes('vacuum')){
      allow.clear(); ['vacuum','central vacuum','dirt devil','dometic vacuum'].forEach(x=>allow.add(x));
      ['fresh water','waste water','water pump','pump fitting'].forEach(x=>block.add(x));
    }

    return function(rec){
      const hay = plain([rec.rawBrand, rec.rawSeries, rec.seriesName, rec.manufacturer, rec.modelNumber, category, display].join(' '));
      for(const b of block){ if(b && hay.includes(b)) return false; }
      if(allow.size){
        for(const a of allow){ if(a && hay.includes(a)) return true; }
        // Let exact non-mixed database categories through when no detailed family token is in the raw brand.
        if(category && !['pumps'].includes(category)) return true;
        return false;
      }
      return true;
    };
  }
  function collapseSingleMeaningSeries(seriesMap){
    const keys = Object.keys(seriesMap || {});
    if(keys.length === 1) return seriesMap;
    const nonUseful = keys.filter(k => ['all models','other',''].includes(plain(k)));
    if(nonUseful.length && keys.length === 2){
      const useful = keys.find(k => !nonUseful.includes(k));
      if(useful){
        nonUseful.forEach(k => {
          seriesMap[useful] = (seriesMap[useful] || []).concat(seriesMap[k] || []);
          delete seriesMap[k];
        });
      }
    }
    return seriesMap;
  }

  // V53: Some furnace selector rows store a series shell as the "model" and the real
  // model numbers inside serials. Example: Suburban SF Series -> model "SF Series"
  // -> serials ["SF20","SF25","SF30"]. For customers, SF20/SF25/SF30 are model
  // choices, not serial choices. Flatten these shell records so the selector flow
  // becomes Manufacturer -> Series -> Model, with no duplicate series/model step.
  function isSeriesShellModelRecord(rec){
    const model = tidyLabel(rec && rec.modelNumber);
    const serials = (rec && rec.serials) || [];
    if(!model || !/series$/i.test(model) || !serials.length) return false;
    return serials.some(x => /[0-9]/.test(String(x || '')));
  }
  function expandSeriesShellModelRecord(rec){
    if(!isSeriesShellModelRecord(rec)) return [rec];
    return (rec.serials || []).filter(Boolean).map(serialModel => Object.assign({}, rec, {
      modelNumber: String(serialModel),
      normalized: norm(serialModel),
      serials: [],
      _seriesShellModel: rec.modelNumber,
      _seriesShellExpanded: true
    }));
  }
  function buildCategoryCascade(c, root){
    const out = {manufacturers:{}};
    const allowRecord = selectorFamilyFilter(root, c || {});
    const strictCtx = plain([root && root.dataset && root.dataset.categoryQuery, c && c.collectionHandle, c && c.displayName, c && c.category].filter(Boolean).join(' '));
    const isWaterPumpIntent = strictCtx.includes('water pump') || strictCtx.includes('pompes') || strictCtx.includes('used water pump') || (strictCtx.includes('pump') && !strictCtx.includes('vacuum'));
    const isVacuumIntent = strictCtx.includes('vacuum');
    const awningChoice = plain(root && root.dataset && root.dataset.yfAwningBreakdownCategory || '');
    const isAwningSelector = plain([c && c.category, c && c.displayName, c && c.collectionHandle, root && root.dataset && root.dataset.categoryQuery].filter(Boolean).join(' ')).includes('awning');
    function awningRecordType(rawBrand, dbSeries, rec){
      const hay = plain([rawBrand, dbSeries, rec && rec.seriesName, rec && rec.modelNumber, rec && rec.rawSeries].filter(Boolean).join(' '));
      const hardwareish = /hardware|anti flap|anti-flap|rafter|arm|arms|bracket|support|cradle|knob|roller|torsion|spring|end cap|cap kit|mount|mounting|rail|track|motor|switch|control|sensor|center rafter|rafters/.test(hay);
      return hardwareish ? 'awning-hardware' : 'awnings';
    }
    Object.entries(c && c.manufacturers || {}).forEach(([rawBrand, raw]) => {
      const rawHay = plain([rawBrand, JSON.stringify(raw || {})].join(' '));
      // V30 hard guard: broad DB category "Pumps" contains both water pumps and central vacuums.
      // Water-pump selectors must never show vacuum brands/series/models, even if older cached data still contains them.
      if(isWaterPumpIntent && rawHay.includes('vacuum')) return;
      if(isVacuumIntent && !rawHay.includes('vacuum') && !rawHay.includes('dirt devil')) return;
      const parsed = parseCategoryManufacturer(rawBrand);
      const manufacturer = parsed.manufacturer || rawBrand;
      Object.entries(raw.series || {}).forEach(([dbSeries, models]) => {
        const seriesName = displaySeriesName(parsed.parsedSeries, dbSeries);
        (models || []).forEach(m => {
          const baseRec = Object.assign({}, m, {manufacturer, seriesName, rawBrand, rawSeries:dbSeries});
          expandSeriesShellModelRecord(baseRec).forEach(rec => {
            if(isAwningSelector && awningChoice){
              const recType = awningRecordType(rawBrand, dbSeries, rec);
              if(awningChoice === 'awning-hardware' && recType !== 'awning-hardware') return;
              if(awningChoice === 'awnings' && recType !== 'awnings') return;
            }
            if(!allowRecord(rec)) return;
            const mf = out.manufacturers[manufacturer] || (out.manufacturers[manufacturer] = {series:{}, count:0});
            const list = mf.series[seriesName] || (mf.series[seriesName] = []);
            if(!list.some(x => norm(x.modelNumber) === norm(rec.modelNumber) && JSON.stringify(x.serials||[]) === JSON.stringify(rec.serials||[]))) list.push(rec);
          });
        });
      });
    });
    Object.values(out.manufacturers).forEach(mf => {
      mf.series = collapseSingleMeaningSeries(mf.series);
      Object.keys(mf.series).forEach(k => { mf.series[k].sort((a,b)=>String(a.modelNumber).localeCompare(String(b.modelNumber), undefined, {numeric:true})); mf.count += mf.series[k].length; });
    });
    return out;
  }
  function showCascadeStep(step, show){ if(step){ step.hidden = !show; step.classList.toggle('active', !!show); } }
  function categoryWidgetRecord(idx, root, handle, title){
    const forcedIndexKey = String(root && root.dataset && root.dataset.categoryIndexKey || '').trim();
    const strictCategory = String(root && root.dataset && root.dataset.categoryStrict || '').toLowerCase() === 'true';
    if(forcedIndexKey){
      if(idx[forcedIndexKey]) return idx[forcedIndexKey];
      // A template-locked finder must fail closed. Never substitute another
      // appliance category just because its display name partially matches.
      if(strictCategory) return null;
    }
    const query = String(root && root.dataset && root.dataset.categoryQuery || '');
    const hay = plain([handle, title, query].filter(Boolean).join(' '));
    const templateMap = [
      [/air[- ]?condition|a\/?c|air-conditioners/i, 'new-used-rv-air-conditioners-replacement-parts'],
      [/awning|awning-hardware/i, 'mouldings'],
      [/furnace|used-furnaces/i, 'new-used-rv-furnaces-replacement-parts'],
      [/refrigerator|fridge|refrigerators/i, 'new-used-rv-refrigerators-replacement-parts'],
      [/water[- ]?heater|hot[- ]?water/i, 'new-used-rv-hot-water-heaters'],
      [/oven|range|stove|ovens/i, 'new-rv-ranges-ovens-range-hoods-replacement-parts']
    ];
    if(idx[handle]) return idx[handle];
    for(const pair of templateMap){ if(pair[0].test([handle,title,query].join(' ')) && idx[pair[1]]) return idx[pair[1]]; }
    return Object.values(idx).find(x => {
      const display = norm(x.displayName || x.category || '');
      const category = norm(x.category || '');
      const q = norm(query);
      const t = norm(title);
      return (display && (display.includes(t) || t.includes(display) || display.includes(q) || q.includes(display))) ||
             (category && (category.includes(t) || t.includes(category) || category.includes(q) || q.includes(category)));
    });
  }
  async function initCategoryWidgets(){
    document.querySelectorAll('[data-yf-category-widget]').forEach(async root => {
      const signature = [
        root.dataset.categoryIndexKey || '',
        root.dataset.categoryQuery || '',
        root.dataset.categoryTemplateSuffix || '',
        root.dataset.collectionHandle || '',
        root.dataset.collectionTitle || '',
        root.dataset.yfAwningBreakdownCategory || ''
      ].join('|');
      if(root.dataset.bound && root.dataset.yfCategorySignature === signature) return;
      root.dataset.bound = '1';
      root.dataset.yfCategorySignature = signature;
      root.innerHTML = '';
      const silent = String(root.dataset.yfSilent || '').toLowerCase() === 'true';
      const idx = await db.categoryModels();
      if(!root.isConnected || root.dataset.yfCategorySignature !== signature) return;
      const handle = root.dataset.collectionHandle || '';
      const title = root.dataset.collectionTitle || '';
      const c = categoryWidgetRecord(idx, root, handle, title);
      if(!c){
        root.innerHTML = silent ? '' : '<section class="yf-panel yf-category-widget"><h2>Model finder unavailable</h2><p>This collection is locked to a database category that could not be loaded. Please refresh the page.</p></section>';
        return;
      }
      root.dataset.yfResolvedCategory = fitmentTidy(c.category || c.displayName || root.dataset.categoryIndexKey || '');

      const widgetTitle = cleanCategoryName(c.category || c.displayName || title || 'this category');
      const isAwningWidget = plain([c.category, c.displayName, handle, title, root.dataset.categoryQuery].filter(Boolean).join(' ')).includes('awning');
      if(isAwningWidget && !root.dataset.yfAwningBreakdownCategory){ root.dataset.yfAwningBreakdownCategory = ''; }
      const forcedAwningChoice = isAwningWidget ? plain(root.dataset.yfAwningBreakdownCategory || '') : '';
      const showAwningTypeStep = isAwningWidget && !forcedAwningChoice;
      let cascade = buildCategoryCascade(c, root);
      let brands = Object.keys(cascade.manufacturers || {}).sort((a,b)=>a.localeCompare(b));
      if(!brands.length && !isAwningWidget){ root.innerHTML = silent ? '' : '<section class="yf-panel yf-category-widget"><h2>No model breakdowns found for this exact category</h2><p>Use the matching collection links above or try a broader search.</p></section>'; return; }
      const headCount = showAwningTypeStep ? '2 types' : esc(brands.length)+' brands';
      root.innerHTML = '<section class="yf-panel yf-category-widget yf-cascade-widget"><div class="yf-panel-head"><div><h2>Find parts breakdowns for your '+esc(widgetTitle)+'</h2><p>Choose one step at a time. We only show the next choice when it is needed for this category.</p></div><strong data-yf-cat-count>'+headCount+'</strong></div>'
        + '<div class="yf-cascade-steps">'
        + (showAwningTypeStep ? '<div class="yf-cascade-step active" data-yf-step="awning-type"><label>Category<select autocomplete="off" data-yf-cat-awning-type><option value="">Select category</option><option value="awnings">Awnings</option><option value="awning-hardware">Awning Hardware</option></select></label></div>' : '')
        + '<div class="yf-cascade-step '+(showAwningTypeStep ? '' : 'active')+'" data-yf-step="brand" '+(showAwningTypeStep ? 'hidden' : '')+'><label>Manufacturer<select autocomplete="off" data-yf-cat-brand><option value="">Select manufacturer</option>'+brands.map(b=>'<option value="'+esc(b)+'">'+esc(b)+'</option>').join('')+'</select></label></div>'
        + '<div class="yf-cascade-step" data-yf-step="series" hidden><label>Series<select autocomplete="off" data-yf-cat-series><option value="">Choose series</option></select></label></div>'
        + '<div class="yf-cascade-step" data-yf-step="model" hidden><label>Model Number<select autocomplete="off" data-yf-cat-model><option value="">Choose model</option></select></label></div>'
        + '<div class="yf-cascade-step" data-yf-step="serial" hidden><label>Serial / production range<select autocomplete="off" data-yf-cat-serial><option value="">All serials / not sure</option></select></label></div>'
        + '</div><button class="yf-btn is-disabled" data-yf-cat-go type="button" disabled aria-disabled="true">View parts for this model</button></section>';

      const awningTypeSel=root.querySelector('[data-yf-cat-awning-type]'), brandSel=root.querySelector('[data-yf-cat-brand]'), seriesSel=root.querySelector('[data-yf-cat-series]'), modelSel=root.querySelector('[data-yf-cat-model]'), serialSel=root.querySelector('[data-yf-cat-serial]'), go=root.querySelector('[data-yf-cat-go]');
      const countEl=root.querySelector('[data-yf-cat-count]'), brandStep=root.querySelector('[data-yf-step="brand"]'), seriesStep=root.querySelector('[data-yf-step="series"]'), modelStep=root.querySelector('[data-yf-step="model"]'), serialStep=root.querySelector('[data-yf-step="serial"]');
      let selectedModels=[];
      function setGoDisabled(disabled){
        go.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        go.classList.toggle('is-disabled', !!disabled);
        go.disabled = !!disabled;
      }
      function rebuildBrandChoices(){
        cascade = buildCategoryCascade(c, root);
        brands = Object.keys(cascade.manufacturers || {}).sort((a,b)=>a.localeCompare(b));
        brandSel.innerHTML = '<option value="">Select manufacturer</option>'+brands.map(b=>'<option value="'+esc(b)+'">'+esc(b)+'</option>').join('');
        if(countEl) countEl.textContent = brands.length + ' brands';
        showCascadeStep(brandStep, !!brands.length);
      }
      function resetBelow(level){
        if(level <= 1){ seriesSel.innerHTML='<option value="">Choose series</option>'; showCascadeStep(seriesStep,false); }
        if(level <= 2){ modelSel.innerHTML='<option value="">Choose model</option>'; showCascadeStep(modelStep,false); selectedModels=[]; }
        if(level <= 3){ serialSel.innerHTML='<option value="">All serials / not sure</option>'; showCascadeStep(serialStep,false); }
        setGoDisabled(true);
      }
      function showModels(models){
        selectedModels = (models || []).slice().sort((a,b)=>String(a.modelNumber).localeCompare(String(b.modelNumber), undefined, {numeric:true}));
        modelSel.innerHTML='<option value="">Choose model</option>'+selectedModels.map(m=>'<option value="'+esc(m.modelNumber)+'">'+esc(m.modelNumber)+'</option>').join('');
        showCascadeStep(modelStep,true);
      }
      function chooseBrand(value){
        resetBelow(1);
        const b = cascade.manufacturers[value];
        if(!b) return;
        const series = Object.keys(b.series || {}).sort((a,b)=>a.localeCompare(b));
        if(series.length > 1){
          seriesSel.innerHTML = '<option value="">Choose series</option>'+series.map(s=>'<option value="'+esc(s)+'">'+esc(s)+'</option>').join('');
          showCascadeStep(seriesStep,true);
        }else{
          showModels(b.series[series[0]] || []);
        }
      }
      function chooseSeries(value){
        resetBelow(2);
        const b = cascade.manufacturers[brandSel.value];
        if(!b || !value) return;
        showModels(b.series[value] || []);
      }
      function chooseModel(value){
        resetBelow(3);
        const m = selectedModels.find(x=>x.modelNumber===value);
        if(!m){ setGoDisabled(true); return; }
        const serials=(m.serials||[]).filter(Boolean).sort((a,b)=>String(a).localeCompare(String(b), undefined, {numeric:true}));
        if(serials.length){
          serialSel.innerHTML='<option value="">All serials / not sure</option>'+serials.map(s=>'<option value="'+esc(s)+'">'+esc(s)+'</option>').join('');
          showCascadeStep(serialStep,true);
        }
        updateGoDestination();
      }
      function selectedSeriesLabel(model){
        if(seriesStep && !seriesStep.hidden && seriesSel.value){
          const option = seriesSel.options[seriesSel.selectedIndex];
          return fitmentTidy(option && option.text || seriesSel.value);
        }
        const fallback = fitmentTidy(model && model.seriesName || '');
        return /^all models$/i.test(fallback) ? '' : fallback;
      }
      function selectedEquipmentForModel(model){
        if(!model) return null;
        const category = fitmentTidy(root.dataset.categoryQuery || root.dataset.yfResolvedCategory || c.category || c.displayName || title || '');
        return {
          brand: brandSel.value,
          model: model.modelNumber,
          series: selectedSeriesLabel(model),
          serial: serialSel.value || '',
          category,
          categoryIndexKey: root.dataset.categoryIndexKey || ''
        };
      }
      function updateGoDestination(){
        const model = selectedModels.find(x=>x.modelNumber===modelSel.value);
        const selected = selectedEquipmentForModel(model);
        if(!selected || !selected.model){ setGoDisabled(true); return null; }
        setGoDisabled(false);
        return {model, selected};
      }
      function submitModelThroughStoreSearch(selected){
        if(!selected || !selected.model) return false;
        const lookup = fitmentTidy(selected.model);
        if(!lookup) return false;

        // Use the storefront's real header search form. This behaves exactly
        // like typing the model number into the search bar, avoids Shopify
        // theme-editor external-link warnings, and lets the YF Native Database
        // App promote the exact model-number match on the search page.
        const forms = Array.from(document.querySelectorAll('[data-yf-native-search] form, form.yf-native-search-form'));
        const form = forms.find(candidate => {
          const rect = candidate.getBoundingClientRect ? candidate.getBoundingClientRect() : null;
          return rect && rect.width > 0 && rect.height > 0;
        }) || forms[0];

        if(form){
          const input = form.querySelector('input[name="q"]:not([type="hidden"]), [data-yf-search-input]');
          if(input){
            input.value = lookup;
            input.dispatchEvent(new Event('input', {bubbles:true}));
            input.dispatchEvent(new Event('change', {bubbles:true}));
          }
          go.textContent = 'Searching model…';
          go.disabled = true;
          if(typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
          return true;
        }

        // Fallback for pages where the header search is temporarily absent.
        // This is still the same normal Shopify search request, not a custom
        // external model-match link.
        go.textContent = 'Searching model…';
        go.disabled = true;
        location.href = nativeSearchUrl(lookup);
        return true;
      }
      function prefillSavedEquipment(){
        const category = fitmentTidy(c.category || c.displayName || root.dataset.categoryQuery || title || '');
        const saved = fitmentReadSaved([{categoryLabel:category}]);
        if(!saved || !saved.brand || !saved.model) return;
        const brandKey = brands.find(key => fitmentBrandMatches(key, saved.brand));
        if(!brandKey) return;
        brandSel.value = brandKey;
        chooseBrand(brandKey);
        const brandRecord = cascade.manufacturers[brandKey];
        if(!brandRecord) return;
        if(seriesStep && !seriesStep.hidden){
          const seriesKeys = Object.keys(brandRecord.series || {});
          const seriesKey = seriesKeys.find(key => saved.series && fitmentSeriesMatches(key, saved.series))
            || seriesKeys.find(key => (brandRecord.series[key] || []).some(model => norm(model.modelNumber) === norm(saved.model)));
          if(!seriesKey) return;
          seriesSel.value = seriesKey;
          chooseSeries(seriesKey);
        }
        const modelRecord = selectedModels.find(model => norm(model.modelNumber) === norm(saved.model));
        if(!modelRecord) return;
        modelSel.value = modelRecord.modelNumber;
        chooseModel(modelRecord.modelNumber);
        if(saved.serial && serialStep && !serialStep.hidden){
          const serialOption = Array.from(serialSel.options).find(option => option.value && norm(option.value) === norm(saved.serial));
          if(serialOption) serialSel.value = serialOption.value;
        }
        updateGoDestination();
      }
      if(awningTypeSel){
        awningTypeSel.addEventListener('change',()=>{
          root.dataset.yfAwningBreakdownCategory = awningTypeSel.value || '';
          resetBelow(1);
          if(!awningTypeSel.value){
            if(countEl) countEl.textContent = '2 types';
            showCascadeStep(brandStep, false);
            return;
          }
          rebuildBrandChoices();
        });
      }
      brandSel.addEventListener('change',()=>chooseBrand(brandSel.value));
      seriesSel.addEventListener('change',()=>chooseSeries(seriesSel.value));
      modelSel.addEventListener('change',()=>chooseModel(modelSel.value));
      serialSel.addEventListener('change',()=>{ updateGoDestination(); });
      go.addEventListener('click',(event)=>{
        event.preventDefault();
        const prepared = updateGoDestination();
        if(!prepared || go.getAttribute('aria-disabled') === 'true') return;

        // Save the selected appliance first, then perform the same search a
        // customer would make in the header search bar. The native database
        // search router recognizes the exact model number and renders the
        // model-match page while My Equipment already contains the selection.
        persistSelectedEquipment(prepared.selected);
        pendingModelRouteWrite(prepared.selected, prepared.selected.model);
        submitModelThroughStoreSearch(prepared.selected);
      });
      prefillSavedEquipment();
    });
  }

  // V135 — My Equipment garage. It shares the exact same category-scoped
  // browser storage as product-page fitment, so saved appliances immediately
  // follow the customer throughout the storefront.
  const YF_EQUIPMENT_CATEGORY_LABELS = [
    [/refrigerator|fridge/, 'Refrigerator'],
    [/hot water heater|water heater/, 'Water Heater'],
    [/furnace/, 'Furnace'],
    [/air conditioner|air conditioning|\ba\/?c\b/, 'Air Conditioner'],
    [/awning hardware|moulding/, 'Awning Hardware'],
    [/awning/, 'Awning'],
    [/range hood/, 'Range Hood'],
    [/oven|range|cooktop|stove/, 'Range / Oven'],
    [/water pump/, 'Water Pump'],
    [/vacuum/, 'RV Vacuum'],
    [/toilet/, 'Toilet'],
    [/converter|inverter|charger/, 'Converter / Inverter'],
    [/leveling|landing gear|stabilizer|jack/, 'Leveling System'],
    [/vent/, 'Roof Vent'],
    [/antenna|satellite/, 'Antenna / Satellite'],
    [/generator/, 'Generator'],
    [/slide/, 'Slide System']
  ];
  function equipmentCategoryLabel(value){
    const clean = fitmentTidy(value || 'Equipment');
    const hay = plain(clean);
    for(const pair of YF_EQUIPMENT_CATEGORY_LABELS){ if(pair[0].test(hay)) return pair[1]; }
    let label = cleanCategoryName(clean) || clean || 'Equipment';
    label = label.replace(/^new\s*(?:&|and)\s*used\s*rv\s*/i,'').replace(/^used\s*rv\s*/i,'').replace(/^new\s*rv\s*/i,'');
    return label.replace(/\bReplacement Parts?\b/ig,'').replace(/\s+/g,' ').trim() || 'Equipment';
  }
  function equipmentIcon(label){
    const hay = plain(label);
    if(hay.includes('refrigerator')) return '❄';
    if(hay.includes('water heater')) return '♨';
    if(hay.includes('furnace')) return '🔥';
    if(hay.includes('air conditioner')) return '❄';
    if(hay.includes('awning')) return '⌂';
    if(hay.includes('range') || hay.includes('oven')) return '◫';
    if(hay.includes('pump')) return '≈';
    if(hay.includes('toilet')) return '◉';
    return '▣';
  }
  function equipmentIsActive(item){
    const active = fitmentReadStore().scopes[item.scope];
    return !!(active && equipmentFingerprint(active, item.scope) === equipmentFingerprint(item, item.scope));
  }
  function equipmentSetActive(item){
    if(!item || !item.scope) return;
    const store = fitmentReadStore();
    store.scopes[item.scope] = Object.assign({}, item, {scope:item.scope});
    fitmentWriteStore(store);
    equipmentGarageUpsert(item, item.scope);
  }
  function equipmentRemoveById(id){
    const garage = equipmentGarageRead();
    const item = garage.items.find(candidate => candidate.id === id);
    if(!item) return;
    garage.items = garage.items.filter(candidate => candidate.id !== id);
    const store = fitmentReadStore();
    const active = store.scopes && store.scopes[item.scope];
    if(active && equipmentFingerprint(active, item.scope) === equipmentFingerprint(item, item.scope)){
      const replacement = garage.items.find(candidate => candidate.scope === item.scope);
      if(replacement) store.scopes[item.scope] = Object.assign({}, replacement, {scope:item.scope});
      else delete store.scopes[item.scope];
      if(Object.keys(store.scopes || {}).length) fitmentWriteStore(store);
      else try{ localStorage.removeItem(YF_FITMENT_STORAGE_KEY); }catch(e){}
    }
    equipmentGarageWrite(garage);
  }
  function equipmentCategoryChoices(index){
    const best = new Map();
    Object.entries(index || {}).forEach(([key, record]) => {
      if(!record || !Object.keys(record.manufacturers || {}).length) return;
      const raw = fitmentTidy(record.category || record.displayName || key);
      const rawPlain = plain(raw);
      const size = JSON.stringify(record.manufacturers || {}).length;
      const candidates = [];
      // The database's legacy Pumps category contains water pumps and central
      // vacuums. Present them as separate equipment categories in the garage.
      if(rawPlain === 'pumps' || (rawPlain.includes('pump') && JSON.stringify(record.manufacturers || {}).toLowerCase().includes('vacuum'))){
        candidates.push({key:key+'::water-pump',label:'Water Pump',query:'water pump',raw,record,size});
        candidates.push({key:key+'::vacuum',label:'RV Vacuum',query:'vacuum',raw,record,size});
      }else{
        const label = equipmentCategoryLabel(raw);
        candidates.push({key,label,query:label,raw,record,size});
      }
      candidates.forEach(candidate => {
        const current = best.get(candidate.label);
        if(!current || candidate.size > current.size) best.set(candidate.label,candidate);
      });
    });
    return Array.from(best.values()).sort((a,b)=>a.label.localeCompare(b.label));
  }
  function equipmentModalShell(){
    return '<div class="yf-equipment-modal" data-yf-equipment-modal hidden>'
      + '<button class="yf-equipment-backdrop" type="button" aria-label="Close My Equipment" data-yf-equipment-close></button>'
      + '<section class="yf-equipment-drawer" role="dialog" aria-modal="true" aria-labelledby="yf-equipment-title">'
      + '<header class="yf-equipment-head"><div class="yf-equipment-head-icon" aria-hidden="true">▣</div><div><p>Your appliance garage</p><h2 id="yf-equipment-title">My Equipment</h2></div><button class="yf-equipment-close" type="button" aria-label="Close" data-yf-equipment-close>×</button></header>'
      + '<div class="yf-equipment-body">'
      + '<div data-yf-equipment-list-view><div data-yf-equipment-list></div><button class="yf-equipment-add" type="button" data-yf-equipment-add><span>＋</span>Add equipment</button></div>'
      + '<div data-yf-equipment-form-view hidden>'
      + '<button class="yf-equipment-back" type="button" data-yf-equipment-back>← Back to My Equipment</button>'
      + '<div class="yf-equipment-form-heading"><p>Add or change equipment</p><h3>Tell us what you own</h3><span>We will save it in this browser and automatically check fitment across matching parts.</span></div>'
      + '<div class="yf-equipment-fields">'
      + '<label><span>Equipment category</span><select data-yf-equipment-category><option value="">Select category</option></select></label>'
      + '<label data-yf-equipment-brand-field hidden><span>Brand</span><select data-yf-equipment-brand><option value="">Select brand</option></select></label>'
      + '<label data-yf-equipment-model-field hidden><span>Model</span><select data-yf-equipment-model><option value="">Select model</option></select></label>'
      + '<label data-yf-equipment-series-field hidden><span>Series</span><select data-yf-equipment-series><option value="">Select series</option></select></label>'
      + '<label data-yf-equipment-serial-field hidden><span>Serial / product number</span><select data-yf-equipment-serial><option value="">Select serial / product number</option></select><small>Choose the number from the appliance label, not your RV VIN.</small></label>'
      + '</div><button class="yf-equipment-save" type="button" data-yf-equipment-save disabled>Save equipment</button>'
      + '</div></div></section></div>';
  }
  function dedupeMyEquipmentMobileTriggers(){
    const roots = new Set();
    document.querySelectorAll('main-nav-mobile, main-nav-mobile-loader').forEach(root => {
      if(roots.has(root)) return;
      roots.add(root);
      const triggers = Array.from(root.querySelectorAll('.yf-my-equipment-mobile-trigger'));
      triggers.slice(1).forEach(trigger => trigger.remove());
    });
  }
  function closeMobileMenuBeforeEquipment(opener, callback){
    const nav = opener && opener.closest ? opener.closest('main-nav-mobile') : null;
    const host = nav && nav.closest ? nav.closest('modal-container') : null;
    const dialog = host && host.querySelector ? host.querySelector('dialog[open]') : null;
    if(!host || !dialog){ callback(); return; }

    // Close the theme's native mobile navigation before opening the garage.
    // Waiting for the drawer animation also lets the bottom navigation return
    // to document.body before My Equipment takes over the viewport.
    try{
      if(typeof host.close === 'function') host.close();
      else host.dispatchEvent(new CustomEvent('modal-close',{bubbles:true}));
    }catch(error){
      host.dispatchEvent(new CustomEvent('modal-close',{bubbles:true}));
    }
    window.setTimeout(callback, 420);
  }
  function initMyEquipment(){
    dedupeMyEquipmentMobileTriggers();
    // Initialize the garage even when the mobile navigation is injected after
    // initial page load. This keeps the My Equipment button functional in the
    // live storefront and inside Shopify's mobile theme preview.
    let modal = document.querySelector('[data-yf-equipment-modal]');
    if(!modal){
      document.body.insertAdjacentHTML('beforeend', equipmentModalShell());
      modal = document.querySelector('[data-yf-equipment-modal]');
    }
    if(!modal || modal.dataset.bound) { renderEquipmentGarage(); return; }
    modal.dataset.bound = '1';

    const listView = modal.querySelector('[data-yf-equipment-list-view]');
    const formView = modal.querySelector('[data-yf-equipment-form-view]');
    const list = modal.querySelector('[data-yf-equipment-list]');
    const categorySel = modal.querySelector('[data-yf-equipment-category]');
    const brandSel = modal.querySelector('[data-yf-equipment-brand]');
    const modelSel = modal.querySelector('[data-yf-equipment-model]');
    const seriesSel = modal.querySelector('[data-yf-equipment-series]');
    const serialSel = modal.querySelector('[data-yf-equipment-serial]');
    const brandField = modal.querySelector('[data-yf-equipment-brand-field]');
    const modelField = modal.querySelector('[data-yf-equipment-model-field]');
    const seriesField = modal.querySelector('[data-yf-equipment-series-field]');
    const serialField = modal.querySelector('[data-yf-equipment-serial-field]');
    const saveBtn = modal.querySelector('[data-yf-equipment-save]');
    let categoryIndex = null, choices = [], activeChoice = null, cascade = null, modelRecords = [], editId = '';

    function setField(field, show){ if(field) field.hidden = !show; }
    function updateBadges(){
      const garage = equipmentGarageRead();
      const count = garage.items.length;
      document.querySelectorAll('[data-yf-equipment-count]').forEach(badge => {
        badge.textContent = count > 99 ? '99+' : String(count);
        badge.hidden = count < 1;
      });
      document.querySelectorAll('[data-yf-equipment-nav-summary]').forEach(summary => {
        summary.textContent = count
          ? 'You have '+count+' saved '+(count === 1 ? 'piece of equipment' : 'pieces of equipment')+'. Open your garage to check fitment or view every available part for a saved model.'
          : 'Save your refrigerator, furnace, water heater, air conditioner, and other equipment once. We will remember it, check part fitment, and show every available part for the model.';
      });
      document.querySelectorAll('[data-yf-equipment-copy]').forEach(copy => {
        copy.textContent = count
          ? 'Your saved appliances & models'
          : 'Input your model number to check fitment & find parts';
      });
    }
    window.renderEquipmentGarage = function(){
      updateBadges();
      if(!list) return;
      const garage = equipmentGarageRead();
      if(!garage.items.length){
        list.innerHTML = '<div class="yf-equipment-empty"><div class="yf-equipment-empty-icon">▣</div><h3>Save your equipment once</h3><p>Add your refrigerator, furnace, water heater, air conditioner, awning, or other RV equipment. We will remember it in this browser, check whether parts fit, and take you directly to every available part for that model.</p><button type="button" data-yf-equipment-add>Add your first equipment</button></div>';
        return;
      }
      const groups = new Map();
      garage.items.forEach(item => {
        const label = equipmentCategoryLabel(item.displayCategory || item.category);
        if(!groups.has(label)) groups.set(label, []);
        groups.get(label).push(item);
      });
      list.innerHTML = Array.from(groups.entries()).sort((a,b)=>a[0].localeCompare(b[0])).map(([label,items]) => {
        return '<section class="yf-equipment-group"><header><div><span class="yf-equipment-category-icon">'+esc(equipmentIcon(label))+'</span><h3>'+esc(label)+'</h3></div><span>'+items.length+'</span></header><div class="yf-equipment-cards">'
          + items.map(item => {
            const active = equipmentIsActive(item);
            const details = [item.series, item.serial].filter(Boolean).join(' · ');
            const lookup = item.serial || item.model;
            const url = nativeModelSearchUrl({m:lookup,b:item.brand,c:item.category});
            return '<article class="yf-equipment-card '+(active?'is-active':'')+'">'
              + '<div class="yf-equipment-card-main"><div class="yf-equipment-card-icon">'+esc(equipmentIcon(label))+'</div><div class="yf-equipment-card-copy"><div class="yf-equipment-card-top"><strong>'+esc(item.brand)+' '+esc(item.model)+'</strong>'+(active?'<span>Active fitment</span>':'')+'</div>'+(details?'<p>'+esc(details)+'</p>':'')+'</div></div>'
              + '<div class="yf-equipment-card-actions"><a class="yf-equipment-view-parts" href="'+esc(url)+'">View all available parts</a>'+(!active?'<button class="is-primary" type="button" data-yf-equipment-use="'+esc(item.id)+'">Use for fitment</button>':'')+'<button class="'+(active?'is-primary':'')+'" type="button" data-yf-equipment-edit="'+esc(item.id)+'">Change</button><button class="is-remove" type="button" data-yf-equipment-remove="'+esc(item.id)+'" aria-label="Remove '+esc(item.brand)+' '+esc(item.model)+'">Remove</button></div>'
              + '</article>';
          }).join('') + '</div></section>';
      }).join('');
    };

    function resetForm(){
      editId = ''; activeChoice = null; cascade = null; modelRecords = [];
      categorySel.value=''; brandSel.innerHTML='<option value="">Select brand</option>'; modelSel.innerHTML='<option value="">Select model</option>'; seriesSel.innerHTML='<option value="">Select series</option>'; serialSel.innerHTML='<option value="">Select serial / product number</option>';
      setField(brandField,false); setField(modelField,false); setField(seriesField,false); setField(serialField,false); saveBtn.disabled=true; saveBtn.textContent='Save equipment';
    }
    async function loadCategories(){
      if(!categoryIndex) categoryIndex = await db.categoryModels();
      choices = equipmentCategoryChoices(categoryIndex);
      categorySel.innerHTML = '<option value="">Select category</option>'+choices.map(choice => '<option value="'+esc(choice.key)+'">'+esc(choice.label)+'</option>').join('');
    }
    function brandModels(brand){
      const mf = cascade && cascade.manufacturers && cascade.manufacturers[brand];
      const out = new Map();
      Object.entries(mf && mf.series || {}).forEach(([series,models]) => {
        (models || []).forEach(model => {
          const key = norm(model.modelNumber);
          if(!key) return;
          const group = out.get(key) || {label:model.modelNumber, records:[]};
          group.records.push(Object.assign({}, model, {yfSeries:series}));
          out.set(key, group);
        });
      });
      return Array.from(out.values()).sort((a,b)=>String(a.label).localeCompare(String(b.label),undefined,{numeric:true,sensitivity:'base'}));
    }
    function chooseCategory(key){
      activeChoice = choices.find(choice => choice.key === key) || null;
      modal.dataset.categoryQuery = activeChoice ? (activeChoice.query || activeChoice.label || '') : '';
      modal.dataset.yfAwningBreakdownCategory = activeChoice && equipmentCategoryLabel(activeChoice.label) === 'Awning Hardware' ? 'awning-hardware' : (activeChoice && equipmentCategoryLabel(activeChoice.label) === 'Awning' ? 'awnings' : '');
      cascade = activeChoice ? buildCategoryCascade(activeChoice.record, modal) : null;
      const brands = Object.keys(cascade && cascade.manufacturers || {}).sort((a,b)=>a.localeCompare(b));
      brandSel.innerHTML='<option value="">Select brand</option>'+brands.map(brand=>'<option value="'+esc(brand)+'">'+esc(brand)+'</option>').join('');
      setField(brandField,!!brands.length); setField(modelField,false); setField(seriesField,false); setField(serialField,false); saveBtn.disabled=true;
    }
    function chooseBrand(brand){
      modelRecords = brandModels(brand);
      modelSel.innerHTML='<option value="">Select model</option>'+modelRecords.map(group=>'<option value="'+esc(group.label)+'">'+esc(group.label)+'</option>').join('');
      setField(modelField,!!modelRecords.length); setField(seriesField,false); setField(serialField,false); saveBtn.disabled=true;
    }
    function refreshSerials(records){
      const serials = Array.from(new Set((records || []).flatMap(record => record.serials || []).map(fitmentTidy).filter(Boolean))).sort((a,b)=>a.localeCompare(b,undefined,{numeric:true,sensitivity:'base'}));
      serialSel.innerHTML='<option value="">All serials / not sure</option>'+serials.map(serial=>'<option value="'+esc(serial)+'">'+esc(serial)+'</option>').join('');
      setField(serialField,!!serials.length);
    }
    function chooseModel(model){
      const group = modelRecords.find(candidate => norm(candidate.label) === norm(model));
      const records = group && group.records || [];
      const series = Array.from(new Set(records.map(record => fitmentTidy(record.yfSeries)).filter(value => value && !/^all models$/i.test(value))));
      seriesSel.innerHTML='<option value="">Select series</option>'+series.map(value=>'<option value="'+esc(value)+'">'+esc(value)+'</option>').join('');
      if(series.length > 1){ setField(seriesField,true); setField(serialField,false); saveBtn.disabled=true; }
      else { setField(seriesField,false); if(series.length===1) seriesSel.value=series[0]; refreshSerials(records); saveBtn.disabled=!model; }
    }
    function chosenModelRecords(){
      const group = modelRecords.find(candidate => norm(candidate.label) === norm(modelSel.value));
      let records = group && group.records || [];
      if(seriesSel.value) records = records.filter(record => fitmentSeriesMatches(record.yfSeries, seriesSel.value));
      return records;
    }
    async function showForm(item){
      listView.hidden=true; formView.hidden=false; resetForm(); await loadCategories();
      if(!item) return;
      editId=item.id || '';
      const choice = choices.find(candidate => fitmentCategoryMatches(candidate.raw, item.category)) || choices.find(candidate => equipmentCategoryLabel(candidate.raw) === equipmentCategoryLabel(item.category));
      if(!choice) return;
      categorySel.value=choice.key; chooseCategory(choice.key);
      const brand = Array.from(brandSel.options).find(option => option.value && fitmentBrandMatches(option.value,item.brand));
      if(!brand) return;
      brandSel.value=brand.value; chooseBrand(brand.value);
      const model = Array.from(modelSel.options).find(option => option.value && norm(option.value)===norm(item.model));
      if(!model) return;
      modelSel.value=model.value; chooseModel(model.value);
      if(item.series && !seriesField.hidden){
        const series = Array.from(seriesSel.options).find(option => option.value && fitmentSeriesMatches(option.value,item.series));
        if(series){ seriesSel.value=series.value; refreshSerials(chosenModelRecords()); }
      }
      if(item.serial && !serialField.hidden){
        const serial = Array.from(serialSel.options).find(option => option.value && norm(option.value)===norm(item.serial));
        if(serial) serialSel.value=serial.value;
      }
      saveBtn.disabled=false; saveBtn.textContent='Save changes';
    }
    function showList(){ formView.hidden=true; listView.hidden=false; resetForm(); window.renderEquipmentGarage(); }
    function openModal(){
      modal.hidden=false; document.body.classList.add('yf-equipment-modal-open'); showList();
      setTimeout(()=>{ const close=modal.querySelector('[data-yf-equipment-close]'); if(close) close.focus(); },20);
    }
    function closeModal(){ modal.hidden=true; document.body.classList.remove('yf-equipment-modal-open'); }
    // Public opener used by navigation rendered dynamically by the header.
    window.yfOpenMyEquipment = function(opener){
      closeMobileMenuBeforeEquipment(opener || document.querySelector('[data-yf-my-equipment-open]'), openModal);
    };

    document.addEventListener('click', function(event){
      const opener = event.target && event.target.closest && event.target.closest('[data-yf-my-equipment-open]');
      if(opener){
        event.preventDefault();
        event.stopPropagation();
        closeMobileMenuBeforeEquipment(opener, openModal);
        return;
      }
      if(!modal.contains(event.target)) return;
      if(event.target.closest('[data-yf-equipment-close]')){ closeModal(); return; }
      if(event.target.closest('[data-yf-equipment-add]')){ showForm(null); return; }
      if(event.target.closest('[data-yf-equipment-back]')){ showList(); return; }
      const use = event.target.closest('[data-yf-equipment-use]');
      if(use){ const item=equipmentGarageRead().items.find(candidate=>candidate.id===use.dataset.yfEquipmentUse); if(item) equipmentSetActive(item); window.renderEquipmentGarage(); return; }
      const edit = event.target.closest('[data-yf-equipment-edit]');
      if(edit){ const item=equipmentGarageRead().items.find(candidate=>candidate.id===edit.dataset.yfEquipmentEdit); if(item) showForm(item); return; }
      const remove = event.target.closest('[data-yf-equipment-remove]');
      if(remove){ equipmentRemoveById(remove.dataset.yfEquipmentRemove); window.renderEquipmentGarage(); return; }
    }, true);
    modal.addEventListener('keydown', event => { if(event.key==='Escape') closeModal(); });
    categorySel.addEventListener('change',()=>chooseCategory(categorySel.value));
    brandSel.addEventListener('change',()=>chooseBrand(brandSel.value));
    modelSel.addEventListener('change',()=>chooseModel(modelSel.value));
    seriesSel.addEventListener('change',()=>{ refreshSerials(chosenModelRecords()); saveBtn.disabled=!modelSel.value; });
    serialSel.addEventListener('change',()=>{ saveBtn.disabled=!modelSel.value; });
    saveBtn.addEventListener('click',()=>{
      if(!activeChoice || !brandSel.value || !modelSel.value) return;
      const old = editId ? equipmentGarageRead().items.find(item=>item.id===editId) : null;
      if(old) equipmentRemoveById(old.id);
      const records = chosenModelRecords();
      const selected = {
        brand:brandSel.value,
        model:modelSel.value,
        series:seriesSel.value || fitmentTidy(records[0] && records[0].yfSeries || ''),
        serial:serialSel.value || '',
        category:activeChoice.raw,
        displayCategory:activeChoice.label
      };
      if(/^all models$/i.test(selected.series)) selected.series='';
      fitmentSave([{categoryLabel:selected.category}],selected);
      showList();
    });
    document.addEventListener('yf:equipment-updated',()=>window.renderEquipmentGarage());
    window.addEventListener('storage',event=>{ if([YF_EQUIPMENT_GARAGE_KEY,YF_FITMENT_STORAGE_KEY].includes(event.key)) window.renderEquipmentGarage(); });
    window.renderEquipmentGarage();
  }
  function activateNativeModelOnlyMode(root){
    try{
      document.documentElement.classList.add('yf-native-model-only-prepaint');
      if(document.body) document.body.classList.add('yf-native-model-only-mode');

      const nativeSection = root && root.closest ? root.closest('.shopify-section') : null;
      const main = document.getElementById('MainContent') || document.querySelector('main');
      const hideNode = function(node){
        if(!node || node === nativeSection || (root && node.contains && node.contains(root))) return;
        node.style.setProperty('display','none','important');
        node.setAttribute('hidden','hidden');
        node.setAttribute('aria-hidden','true');
        node.setAttribute('data-yf-hidden-native-search','true');
      };

      document.querySelectorAll('[data-yf-shopify-search-grid]').forEach(function(grid){
        hideNode(grid.closest('.shopify-section') || grid);
      });

      if(main){
        main.querySelectorAll('.shopify-section').forEach(function(section){
          if(section === nativeSection || (root && section.contains(root))) return;
          const id = String(section.id || '').toLowerCase();
          const hasGrid = !!section.querySelector('[data-yf-shopify-search-grid]');
          const text = String(section.textContent || '').trim();
          const isSearchHeader = /__header(?:$|[-_])/.test(id) && /^search(?:\s+for)?/i.test(text);
          const isSearchMain = /__main(?:$|[-_])/.test(id) && (hasGrid || /results|sort by|filter/i.test(text));
          if(hasGrid || isSearchHeader || isSearchMain) hideNode(section);
        });
      }

      if(!window.__YF_NATIVE_MODEL_ONLY_OBSERVER__ && main && window.MutationObserver){
        window.__YF_NATIVE_MODEL_ONLY_OBSERVER__ = new MutationObserver(function(){
          if(!document.documentElement.classList.contains('yf-native-model-only-prepaint')) return;
          document.querySelectorAll('[data-yf-shopify-search-grid]').forEach(function(grid){
            hideNode(grid.closest('.shopify-section') || grid);
          });
          if(main){
            main.querySelectorAll('.shopify-section').forEach(function(section){
              if(section === nativeSection || (root && section.contains(root))) return;
              const id = String(section.id || '').toLowerCase();
              const text = String(section.textContent || '').trim();
              if((/__header(?:$|[-_])/.test(id) && /^search(?:\s+for)?/i.test(text)) ||
                 (/__main(?:$|[-_])/.test(id) && section.querySelector('[data-yf-shopify-search-grid]'))){
                hideNode(section);
              }
            });
          }
        });
        window.__YF_NATIVE_MODEL_ONLY_OBSERVER__.observe(main,{childList:true,subtree:true});
      }
    }catch(e){}
  }

  function hideShopifyNativeSearchSections(root){
    try{
      const section = root && root.closest && root.closest('.shopify-section');
      if(!section) return;

      // V120: Breakdown diagram pages live on Shopify's /search template so the
      // native diagram app can read query params. The normal search template sections
      // still render after the native app, and when the search query is unusual
      // Shopify can output those results as unstyled/plain text under the diagram.
      // On native breakdown pages, the diagram app is the whole page, so hide the
      // following search-template sections unconditionally instead of relying on
      // their text containing the word "Search".
      const params = new URLSearchParams(location.search || '');
      const nativeBreakdownMode = (params.get('yf_mode') || '').toLowerCase() === 'breakdowns';
      // V124: Native model links from YF Native Compatibility should behave like the
      // v115 model-match page only. They still use Shopify's /search URL for safety,
      // but the normal Shopify product-result sections below the native app must not
      // render underneath the model match. The old header search bar remains untouched
      // because it does not add yf_native=1&yf_force=model.
      const nativeModelOnlyMode =
        (params.get('yf_native') === '1' && (params.get('yf_force') || '').toLowerCase() === 'model') ||
        params.get('view') === 'yf-model-match' ||
        params.has('yf_model_key') ||
        /(?:^#|[#&])yf-model-match(?:=1)?(?:&|$)/i.test(location.hash || '') ||
        !!window.__YF_PENDING_MODEL_ROUTE__;
      const nativeOnlyMode = nativeBreakdownMode || nativeModelOnlyMode;
      if(nativeModelOnlyMode) activateNativeModelOnlyMode(root);
      let hidden = 0;
      let node = section.nextElementSibling;
      while(node && hidden < 8){
        const next = node.nextElementSibling;
        if(node.classList && node.classList.contains('shopify-section')){
          if(nativeOnlyMode){
            node.style.display = 'none';
            node.setAttribute('hidden', 'hidden');
            node.setAttribute('aria-hidden', 'true');
            node.setAttribute('data-yf-hidden-native-search','true');
            hidden++;
          }else{
            const txt = (node.textContent || '').trim();
            if(/Search/i.test(txt) || (node.id && /search/i.test(node.id))){
              node.style.display = 'none';
              node.setAttribute('data-yf-hidden-native-search','true');
              hidden++;
            }
          }
        }
        node = next;
      }
      if(nativeBreakdownMode) document.body.classList.add('yf-breakdown-mode');
      if(nativeModelOnlyMode) document.body.classList.add('yf-native-model-only-mode');
    }catch(e){}
  }
  function visibleNativeSearchInput(){
    const inputs = Array.from(document.querySelectorAll('[data-yf-native-search] [data-yf-search-input]'));
    return inputs.find(input => {
      if(!input || !input.getBoundingClientRect) return false;
      const rect = input.getBoundingClientRect();
      const style = window.getComputedStyle(input);
      return rect.width > 20 && rect.height > 10 && style.display !== 'none' && style.visibility !== 'hidden';
    }) || inputs[0] || null;
  }

  function activateModelSearch(model){
    const input = visibleNativeSearchInput();
    if(!input){
      location.assign(nativeSearchUrl(''));
      return;
    }
    const header = input.closest('header, [data-section-type="header"], .shopify-section') || input;
    try{ header.scrollIntoView({behavior:'smooth', block:'start'}); }
    catch(e){ window.scrollTo(0, 0); }
    window.setTimeout(() => {
      input.value = model || '';
      input.focus({preventScroll:true});
      if(typeof input.select === 'function') input.select();
      input.dispatchEvent(new Event('input', {bubbles:true}));
    }, 260);
  }

  document.addEventListener('click', function(event){
    const trigger = event.target && event.target.closest ? event.target.closest('[data-yf-change-serial-model]') : null;
    if(!trigger) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const mode = trigger.getAttribute('data-yf-change-mode') || 'model';
    const model = trigger.getAttribute('data-yf-change-model') || '';
    if(mode === 'serial'){
      const href = trigger.getAttribute('href') || modelBreakdownUrl(model);
      try{ sessionStorage.removeItem(nativePageCacheKey()); }catch(e){}
      location.assign(href);
      return;
    }
    activateModelSearch(model);
  }, true);

  function boot(){
    document.querySelectorAll('[data-yf-native-search]').forEach(initSearch);
    document.querySelectorAll('[data-yf-native-app]').forEach(root => {
      if(root.dataset.appBound) return;
      root.dataset.appBound = '1';
      const params = new URLSearchParams(location.search);
      const configuredType = root.dataset.pageType || '';
      const requestedType = (params.get('yf_mode') || '').toLowerCase();
      const forcedModelRoute =
        (params.get('yf_native') === '1' && (params.get('yf_force') || '').toLowerCase() === 'model') ||
        params.get('view') === 'yf-model-match' ||
        params.has('yf_model_key') ||
        /(?:^#|[#&])yf-model-match(?:=1)?(?:&|$)/i.test(location.hash || '') ||
        !!window.__YF_PENDING_MODEL_ROUTE__;
      const isSearchRouter = configuredType === 'search-router';

      // Ordinary Shopify product searches should keep the native product grid AND
      // show the useful database intelligence above it: recommended collections,
      // category-specific manufacturer/model selectors, exact model matches, and
      // exact part-number matches. Only explicit forced model routes hide Shopify's
      // normal search sections.
      if(isSearchRouter && !requestedType && !forcedModelRoute){
        const ordinaryQuery = (params.get('q') || '').trim();
        if(!ordinaryQuery){
          root.hidden = true;
          return;
        }
        root.hidden = false;
        renderSearch(root, ordinaryQuery);
        return;
      }

      const type = requestedType || (forcedModelRoute ? 'part-search' : configuredType);
      const form = root.querySelector('[data-yf-page-search]');
      if(form) form.addEventListener('submit', e => { e.preventDefault(); saveNativePageCache(root, false); const q = form.querySelector('input[name="q"]').value.trim(); if(q) location.href = nativeSearchUrl(q); });
      if(type === 'breakdowns' || forcedModelRoute) hideShopifyNativeSearchSections(root);
      if(restoreNativePageCache(root, type)) return;
      if(isSearchRouter && forcedModelRoute){
        renderSearch(root, params.get('q') || '', {modelOnly:true});
        return;
      }
      if(type === 'page-model-match'){
        const autoQ = pageModelQueryFromHandle(root.getAttribute('data-yf-page-handle') || '');
        if(!autoQ){ if(root && root.remove) root.remove(); return; }
        renderSearch(root, autoQ, {modelOnly:true, removeWhenNoModel:true});
        return;
      }
      if(type === 'part-search') renderSearch(root, params.get('q') || '');
      if(type === 'part-number') renderPart(root, params.get('id') || params.get('part') || params.get('q') || '');
      if(type === 'breakdowns') renderBreakdown(root, params);
      if(type === 'image-search'){
        const res = root.querySelector('[data-yf-results]');
        if(res){
          res.innerHTML = '<section class="yf-panel"><h2>Image Search</h2><p>Image recognition still needs a secure backend for AI keys. Model, part, compatibility, and diagram lookup are native inside this Shopify theme.</p><a class="yf-btn" href="/search">Search by part or model</a></section>';
          scheduleNativePageCacheSave(res, false);
        }
      }
    });
    initProductFitmentWidgets(); initProductWidgets(); initProductPartInfoWidgets(); initCategoryWidgets(); initMyEquipment();
    fitmentRestoreReturnPosition();
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function(event){
    try{
      const scope = event && event.target;
      if(scope && scope.querySelectorAll){
        scope.querySelectorAll('[data-yf-category-widget]').forEach(function(root){
          root.removeAttribute('data-bound');
          root.removeAttribute('data-yf-category-signature');
        });
      }
    }catch(error){}
    boot();
  });
  window.addEventListener('pageshow', function(event){
    if(event && event.persisted) fitmentRestoreReturnPosition();
    initCategoryWidgets();
  });
  window.addEventListener('pagehide', function(){ saveNativePageCache(document.querySelector('[data-yf-native-app]'), true); });
  document.addEventListener('click', function(e){
    const target = e.target && e.target.closest && e.target.closest('a[href], button, [role="button"]');
    if(!target) return;
    const nativeRoot = target.closest && target.closest('[data-yf-native-app]');
    let forceSnapshot = false;
    if(nativeRoot && target.matches && target.matches('a[href]')){
      try{
        const destination = new URL(target.href, location.href);
        forceSnapshot = destination.origin === location.origin && destination.pathname.indexOf('/products/') !== -1;
      }catch(error){}
    }
    // Product navigation from a model/part/breakdown result must always save
    // the exact rendered DOM and exact scroll position, even if a different
    // product rail is still finishing in the background.
    saveNativePageCache(nativeRoot || document.querySelector('[data-yf-native-app]'), forceSnapshot);
    if(forceSnapshot && window.YFSiteReturnState && typeof window.YFSiteReturnState.save === 'function'){
      try{ window.YFSiteReturnState.save(); }catch(error){}
    }
  }, true);


  // V39: capture smart collection clicks before the browser can visit a bad guessed handle.
  document.addEventListener('click', async function(e){
    const a = e.target && e.target.closest && e.target.closest('[data-yf-collection-card], [data-yf-dd-collection]');
    if(!a) return;
    const h = canonicalCollectionHandle(a.getAttribute('data-handle') || '');
    const fallback = a.getAttribute('data-fallback-q') || (a.querySelector && a.querySelector('h3') && a.querySelector('h3').textContent) || a.textContent || h;
    if(!h) return;
    e.preventDefault();
    location.href = await resolveCollectionUrl(h, fallback);
  }, true);

  // V38 defensive cleanup: never show old "No exact database match found" smart-panel cards.
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.yf-empty-state, .yf-panel, section, div').forEach(function(el){
      try{
        if(/No exact database match found/i.test(el.textContent || '')) el.remove();
      }catch(e){}
    });
  });

})();
